import { v4 as uuidv4 } from 'uuid'

export enum ROUTE_PATH {
  SETUP = '/setup',
  LOGIN = '/login',
  MANAGE_USER = '/manage-user',
  USER_DETAIL = '/user-detail',
  MANAGE_ADS = '/manage-ads',
  MANAGE_BOOKING = '/manage-booking',
  MANAGE_COMMISSION = '/manage-commission',
  MANAGE_QUESTION_AND_ANSWER = '/manage-question-and-answer',
  MANAGE_SERVICE = '/manage-service',
  MANAGE_MANUAL_CAR = '/manage-manual-car',
  MANAGE_SALE = '/manage-sale',
  MANAGE_PRODUCTS = '/manage-products',
  DEFAULT = '/',
  NOT_FOUND = '*',
  INSTALL = '/install'
}

export const enum STORAGE_KEYS {
  VERSION = 'version'
}

export const enum MAX_SIZE_FILE {
  IMAGE = 1024 * 1024 * 10
}

export const enum GENDER {
  MALE = 'MALE',
  FEMALE = 'FEMALE'
}

export const enum COLORS {
  PRIMARY = '#16533D',
  SECONDARY = '#FFFFFF'
}

export const enum LOCATIONS_ADVERTISING {
  BANNER_HOMEPAGE = 'BANNER_HOMEPAGE'
}

export const KEY_EVENT_MESSAGE = uuidv4()

export const PROVINCES = [
  {
    label: 'Thành phố Hà Nội',
    value: 'THANH_PHO_HA_NOI',
    children: [
      {
        label: 'Phường Ba Đình',
        value: 'PHUONG_BA_DINH'
      },
      {
        label: 'Phường Ngọc Hà',
        value: 'PHUONG_NGOC_HA'
      },
      {
        label: 'Phường Giảng Võ',
        value: 'PHUONG_GIANG_VO'
      },
      {
        label: 'Phường Hoàn Kiếm',
        value: 'PHUONG_HOAN_KIEM'
      },
      {
        label: 'Phường Cửa Nam',
        value: 'PHUONG_CUA_NAM'
      },
      {
        label: 'Phường Phú Thượng',
        value: 'PHUONG_PHU_THUONG'
      },
      {
        label: 'Phường Hồng Hà',
        value: 'PHUONG_HONG_HA'
      },
      {
        label: 'Phường Tây Hồ',
        value: 'PHUONG_TAY_HO'
      },
      {
        label: 'Phường Việt Hưng',
        value: 'PHUONG_VIET_HUNG'
      },
      {
        label: 'Phường Bồ Đề',
        value: 'PHUONG_BO_DE'
      },
      {
        label: 'Phường Phúc Lợi',
        value: 'PHUONG_PHUC_LOI'
      },
      {
        label: 'Phường Long Biên',
        value: 'PHUONG_LONG_BIEN'
      },
      {
        label: 'Phường Nghĩa Đô',
        value: 'PHUONG_NGHIA_DO'
      },
      {
        label: 'Phường Cầu Giấy',
        value: 'PHUONG_CAU_GIAY'
      },
      {
        label: 'Phường Yên Hòa',
        value: 'PHUONG_YEN_HOA'
      },
      {
        label: 'Phường Láng',
        value: 'PHUONG_LANG'
      },
      {
        label: 'Phường Ô Chợ Dừa',
        value: 'PHUONG_O_CHO_DUA'
      },
      {
        label: 'Phường Văn Miếu - Quốc Tử Giám',
        value: 'PHUONG_VAN_MIEU_QUOC_TU_GIAM'
      },
      {
        label: 'Phường Kim Liên',
        value: 'PHUONG_KIM_LIEN'
      },
      {
        label: 'Phường Đống Đa',
        value: 'PHUONG_DONG_DA'
      },
      {
        label: 'Phường Hai Bà Trưng',
        value: 'PHUONG_HAI_BA_TRUNG'
      },
      {
        label: 'Phường Bạch Mai',
        value: 'PHUONG_BACH_MAI'
      },
      {
        label: 'Phường Vĩnh Tuy',
        value: 'PHUONG_VINH_TUY'
      },
      {
        label: 'Phường Vĩnh Hưng',
        value: 'PHUONG_VINH_HUNG'
      },
      {
        label: 'Phường Tương Mai',
        value: 'PHUONG_TUONG_MAI'
      },
      {
        label: 'Phường Định Công',
        value: 'PHUONG_DINH_CONG'
      },
      {
        label: 'Phường Hoàng Mai',
        value: 'PHUONG_HOANG_MAI'
      },
      {
        label: 'Phường Lĩnh Nam',
        value: 'PHUONG_LINH_NAM'
      },
      {
        label: 'Phường Yên Sở',
        value: 'PHUONG_YEN_SO'
      },
      {
        label: 'Phường Hoàng Liệt',
        value: 'PHUONG_HOANG_LIET'
      },
      {
        label: 'Phường Phương Liệt',
        value: 'PHUONG_PHUONG_LIET'
      },
      {
        label: 'Phường Khương Đình',
        value: 'PHUONG_KHUONG_DINH'
      },
      {
        label: 'Phường Thanh Xuân',
        value: 'PHUONG_THANH_XUAN'
      },
      {
        label: 'Xã Sóc Sơn',
        value: 'XA_SOC_SON'
      },
      {
        label: 'Xã Kim Anh',
        value: 'XA_KIM_ANH'
      },
      {
        label: 'Xã Trung Giã',
        value: 'XA_TRUNG_GIA'
      },
      {
        label: 'Xã Đa Phúc',
        value: 'XA_DA_PHUC'
      },
      {
        label: 'Xã Nội Bài',
        value: 'XA_NOI_BAI'
      },
      {
        label: 'Xã Đông Anh',
        value: 'XA_DONG_ANH'
      },
      {
        label: 'Xã Phúc Thịnh',
        value: 'XA_PHUC_THINH'
      },
      {
        label: 'Xã Thư Lâm',
        value: 'XA_THU_LAM'
      },
      {
        label: 'Xã Thiên Lộc',
        value: 'XA_THIEN_LOC'
      },
      {
        label: 'Xã Vĩnh Thanh',
        value: 'XA_VINH_THANH'
      },
      {
        label: 'Xã Phù Đổng',
        value: 'XA_PHU_DONG'
      },
      {
        label: 'Xã Thuận An',
        value: 'XA_THUAN_AN'
      },
      {
        label: 'Xã Gia Lâm',
        value: 'XA_GIA_LAM'
      },
      {
        label: 'Xã Bát Tràng',
        value: 'XA_BAT_TRANG'
      },
      {
        label: 'Phường Từ Liêm',
        value: 'PHUONG_TU_LIEM'
      },
      {
        label: 'Phường Thượng Cát',
        value: 'PHUONG_THUONG_CAT'
      },
      {
        label: 'Phường Đông Ngạc',
        value: 'PHUONG_DONG_NGAC'
      },
      {
        label: 'Phường Xuân Đỉnh',
        value: 'PHUONG_XUAN_DINH'
      },
      {
        label: 'Phường Tây Tựu',
        value: 'PHUONG_TAY_TUU'
      },
      {
        label: 'Phường Phú Diễn',
        value: 'PHUONG_PHU_DIEN'
      },
      {
        label: 'Phường Xuân Phương',
        value: 'PHUONG_XUAN_PHUONG'
      },
      {
        label: 'Phường Tây Mỗ',
        value: 'PHUONG_TAY_MO'
      },
      {
        label: 'Phường Đại Mỗ',
        value: 'PHUONG_DAI_MO'
      },
      {
        label: 'Xã Thanh Trì',
        value: 'XA_THANH_TRI'
      },
      {
        label: 'Phường Thanh Liệt',
        value: 'PHUONG_THANH_LIET'
      },
      {
        label: 'Xã Đại Thanh',
        value: 'XA_DAI_THANH'
      },
      {
        label: 'Xã Ngọc Hồi',
        value: 'XA_NGOC_HOI'
      },
      {
        label: 'Xã Nam Phù',
        value: 'XA_NAM_PHU'
      },
      {
        label: 'Xã Yên Xuân',
        value: 'XA_YEN_XUAN'
      },
      {
        label: 'Xã Quang Minh',
        value: 'XA_QUANG_MINH'
      },
      {
        label: 'Xã Yên Lãng',
        value: 'XA_YEN_LANG'
      },
      {
        label: 'Xã Tiến Thắng',
        value: 'XA_TIEN_THANG'
      },
      {
        label: 'Xã Mê Linh',
        value: 'XA_ME_LINH'
      },
      {
        label: 'Phường Kiến Hưng',
        value: 'PHUONG_KIEN_HUNG'
      },
      {
        label: 'Phường Hà Đông',
        value: 'PHUONG_HA_DONG'
      },
      {
        label: 'Phường Yên Nghĩa',
        value: 'PHUONG_YEN_NGHIA'
      },
      {
        label: 'Phường Phú Lương',
        value: 'PHUONG_PHU_LUONG'
      },
      {
        label: 'Phường Sơn Tây',
        value: 'PHUONG_SON_TAY'
      },
      {
        label: 'Phường Tùng Thiện',
        value: 'PHUONG_TUNG_THIEN'
      },
      {
        label: 'Xã Đoài Phương',
        value: 'XA_DOAI_PHUONG'
      },
      {
        label: 'Xã Quảng Oai',
        value: 'XA_QUANG_OAI'
      },
      {
        label: 'Xã Cổ Đô',
        value: 'XA_CO_DO'
      },
      {
        label: 'Xã Minh Châu',
        value: 'XA_MINH_CHAU'
      },
      {
        label: 'Xã Vật Lại',
        value: 'XA_VAT_LAI'
      },
      {
        label: 'Xã Bất Bạt',
        value: 'XA_BAT_BAT'
      },
      {
        label: 'Xã Suối Hai',
        value: 'XA_SUOI_HAI'
      },
      {
        label: 'Xã Ba Vì',
        value: 'XA_BA_VI'
      },
      {
        label: 'Xã Yên Bài',
        value: 'XA_YEN_BAI'
      },
      {
        label: 'Xã Phúc Thọ',
        value: 'XA_PHUC_THO'
      },
      {
        label: 'Xã Phúc Lộc',
        value: 'XA_PHUC_LOC'
      },
      {
        label: 'Xã Hát Môn',
        value: 'XA_HAT_MON'
      },
      {
        label: 'Xã Đan Phượng',
        value: 'XA_DAN_PHUONG'
      },
      {
        label: 'Xã Liên Minh',
        value: 'XA_LIEN_MINH'
      },
      {
        label: 'Xã Ô Diên',
        value: 'XA_O_DIEN'
      },
      {
        label: 'Xã Hoài Đức',
        value: 'XA_HOAI_DUC'
      },
      {
        label: 'Xã Dương Hòa',
        value: 'XA_DUONG_HOA'
      },
      {
        label: 'Xã Sơn Đồng',
        value: 'XA_SON_DONG'
      },
      {
        label: 'Xã An Khánh',
        value: 'XA_AN_KHANH'
      },
      {
        label: 'Phường Dương Nội',
        value: 'PHUONG_DUONG_NOI'
      },
      {
        label: 'Xã Quốc Oai',
        value: 'XA_QUOC_OAI'
      },
      {
        label: 'Xã Phú Cát',
        value: 'XA_PHU_CAT'
      },
      {
        label: 'Xã Kiều Phú',
        value: 'XA_KIEU_PHU'
      },
      {
        label: 'Xã Hưng Đạo',
        value: 'XA_HUNG_DAO'
      },
      {
        label: 'Xã Thạch Thất',
        value: 'XA_THACH_THAT'
      },
      {
        label: 'Xã Hòa Lạc',
        value: 'XA_HOA_LAC'
      },
      {
        label: 'Xã Tây Phương',
        value: 'XA_TAY_PHUONG'
      },
      {
        label: 'Xã Hạ Bằng',
        value: 'XA_HA_BANG'
      },
      {
        label: 'Phường Chương Mỹ',
        value: 'PHUONG_CHUONG_MY'
      },
      {
        label: 'Xã Xuân Mai',
        value: 'XA_XUAN_MAI'
      },
      {
        label: 'Xã Phú Nghĩa',
        value: 'XA_PHU_NGHIA'
      },
      {
        label: 'Xã Trần Phú',
        value: 'XA_TRAN_PHU'
      },
      {
        label: 'Xã Quảng Bị',
        value: 'XA_QUANG_BI'
      },
      {
        label: 'Xã Hòa Phú',
        value: 'XA_HOA_PHU'
      },
      {
        label: 'Xã Thanh Oai',
        value: 'XA_THANH_OAI'
      },
      {
        label: 'Xã Bình Minh',
        value: 'XA_BINH_MINH'
      },
      {
        label: 'Xã Tam Hưng',
        value: 'XA_TAM_HUNG'
      },
      {
        label: 'Xã Dân Hòa',
        value: 'XA_DAN_HOA'
      },
      {
        label: 'Xã Thường Tín',
        value: 'XA_THUONG_TIN'
      },
      {
        label: 'Xã Hồng Vân',
        value: 'XA_HONG_VAN'
      },
      {
        label: 'Xã Thượng Phúc',
        value: 'XA_THUONG_PHUC'
      },
      {
        label: 'Xã Chương Dương',
        value: 'XA_CHUONG_DUONG'
      },
      {
        label: 'Xã Phú Xuyên',
        value: 'XA_PHU_XUYEN'
      },
      {
        label: 'Xã Phượng Dực',
        value: 'XA_PHUONG_DUC'
      },
      {
        label: 'Xã Chuyên Mỹ',
        value: 'XA_CHUYEN_MY'
      },
      {
        label: 'Xã Đại Xuyên',
        value: 'XA_DAI_XUYEN'
      },
      {
        label: 'Xã Vân Đình',
        value: 'XA_VAN_DINH'
      },
      {
        label: 'Xã Ứng Thiên',
        value: 'XA_UNG_THIEN'
      },
      {
        label: 'Xã Ứng Hòa',
        value: 'XA_UNG_HOA'
      },
      {
        label: 'Xã Hòa Xá',
        value: 'XA_HOA_XA'
      },
      {
        label: 'Xã Mỹ Đức',
        value: 'XA_MY_DUC'
      },
      {
        label: 'Xã Phúc Sơn',
        value: 'XA_PHUC_SON'
      },
      {
        label: 'Xã Hồng Sơn',
        value: 'XA_HONG_SON'
      },
      {
        label: 'Xã Hương Sơn',
        value: 'XA_HUONG_SON'
      }
    ]
  },
  {
    label: 'Cao Bằng',
    value: 'CAO_BANG',
    children: [
      {
        label: 'Phường Thục Phán',
        value: 'PHUONG_THUC_PHAN'
      },
      {
        label: 'Phường Nùng Trí Cao',
        value: 'PHUONG_NUNG_TRI_CAO'
      },
      {
        label: 'Phường Tân Giang',
        value: 'PHUONG_TAN_GIANG'
      },
      {
        label: 'Xã Bảo Lâm',
        value: 'XA_BAO_LAM'
      },
      {
        label: 'Xã Lý Bôn',
        value: 'XA_LY_BON'
      },
      {
        label: 'Xã Nam Quang',
        value: 'XA_NAM_QUANG'
      },
      {
        label: 'Xã Quảng Lâm',
        value: 'XA_QUANG_LAM'
      },
      {
        label: 'Xã Yên Thổ',
        value: 'XA_YEN_THO'
      },
      {
        label: 'Xã Bảo Lạc',
        value: 'XA_BAO_LAC'
      },
      {
        label: 'Xã Cốc Pàng',
        value: 'XA_COC_PANG'
      },
      {
        label: 'Xã Cô Ba',
        value: 'XA_CO_BA'
      },
      {
        label: 'Xã Khánh Xuân',
        value: 'XA_KHANH_XUAN'
      },
      {
        label: 'Xã Xuân Trường',
        value: 'XA_XUAN_TRUONG'
      },
      {
        label: 'Xã Hưng Đạo',
        value: 'XA_HUNG_DAO'
      },
      {
        label: 'Xã Huy Giáp',
        value: 'XA_HUY_GIAP'
      },
      {
        label: 'Xã Sơn Lộ',
        value: 'XA_SON_LO'
      },
      {
        label: 'Xã Thông Nông',
        value: 'XA_THONG_NONG'
      },
      {
        label: 'Xã Cần Yên',
        value: 'XA_CAN_YEN'
      },
      {
        label: 'Xã Thanh Long',
        value: 'XA_THANH_LONG'
      },
      {
        label: 'Xã Trường Hà',
        value: 'XA_TRUONG_HA'
      },
      {
        label: 'Xã Lũng Nặm',
        value: 'XA_LUNG_NAM'
      },
      {
        label: 'Xã Tổng Cọt',
        value: 'XA_TONG_COT'
      },
      {
        label: 'Xã Hà Quảng',
        value: 'XA_HA_QUANG'
      },
      {
        label: 'Xã Trà Lĩnh',
        value: 'XA_TRA_LINH'
      },
      {
        label: 'Xã Quang Hán',
        value: 'XA_QUANG_HAN'
      },
      {
        label: 'Xã Quang Trung',
        value: 'XA_QUANG_TRUNG'
      },
      {
        label: 'Xã Trùng Khánh',
        value: 'XA_TRUNG_KHANH'
      },
      {
        label: 'Xã Đình Phong',
        value: 'XA_DINH_PHONG'
      },
      {
        label: 'Xã Đàm Thuỷ',
        value: 'XA_DAM_THUY'
      },
      {
        label: 'Xã Đoài Dương',
        value: 'XA_DOAI_DUONG'
      },
      {
        label: 'Xã Vinh Quý',
        value: 'XA_VINH_QUY'
      },
      {
        label: 'Xã Quang Long',
        value: 'XA_QUANG_LONG'
      },
      {
        label: 'Xã Lý Quốc',
        value: 'XA_LY_QUOC'
      },
      {
        label: 'Xã Hạ Lang',
        value: 'XA_HA_LANG'
      },
      {
        label: 'Xã Quảng Uyên',
        value: 'XA_QUANG_UYEN'
      },
      {
        label: 'Xã Độc Lập',
        value: 'XA_DOC_LAP'
      },
      {
        label: 'Xã Hạnh Phúc',
        value: 'XA_HANH_PHUC'
      },
      {
        label: 'Xã Bế Văn Đàn',
        value: 'XA_BE_VAN_DAN'
      },
      {
        label: 'Xã Phục Hòa',
        value: 'XA_PHUC_HOA'
      },
      {
        label: 'Xã Hòa An',
        value: 'XA_HOA_AN'
      },
      {
        label: 'Xã Nam Tuấn',
        value: 'XA_NAM_TUAN'
      },
      {
        label: 'Xã Nguyễn Huệ',
        value: 'XA_NGUYEN_HUE'
      },
      {
        label: 'Xã Bạch Đằng',
        value: 'XA_BACH_DANG'
      },
      {
        label: 'Xã Nguyên Bình',
        value: 'XA_NGUYEN_BINH'
      },
      {
        label: 'Xã Tĩnh Túc',
        value: 'XA_TINH_TUC'
      },
      {
        label: 'Xã Ca Thành',
        value: 'XA_CA_THANH'
      },
      {
        label: 'Xã Minh Tâm',
        value: 'XA_MINH_TAM'
      },
      {
        label: 'Xã Phan Thanh',
        value: 'XA_PHAN_THANH'
      },
      {
        label: 'Xã Tam Kim',
        value: 'XA_TAM_KIM'
      },
      {
        label: 'Xã Thành Công',
        value: 'XA_THANH_CONG'
      },
      {
        label: 'Xã Đông Khê',
        value: 'XA_DONG_KHE'
      },
      {
        label: 'Xã Canh Tân',
        value: 'XA_CANH_TAN'
      },
      {
        label: 'Xã Kim Đồng',
        value: 'XA_KIM_DONG'
      },
      {
        label: 'Xã Minh Khai',
        value: 'XA_MINH_KHAI'
      },
      {
        label: 'Xã Thạch An',
        value: 'XA_THACH_AN'
      },
      {
        label: 'Xã Đức Long',
        value: 'XA_DUC_LONG'
      }
    ]
  },
  {
    label: 'Tuyên Quang',
    value: 'TUYEN_QUANG',
    children: [
      {
        label: 'Phường Hà Giang 2',
        value: 'PHUONG_HA_GIANG_2'
      },
      {
        label: 'Phường Hà Giang 1',
        value: 'PHUONG_HA_GIANG_1'
      },
      {
        label: 'Xã Ngọc Đường',
        value: 'XA_NGOC_DUONG'
      },
      {
        label: 'Xã Phú Linh',
        value: 'XA_PHU_LINH'
      },
      {
        label: 'Xã Lũng Cú',
        value: 'XA_LUNG_CU'
      },
      {
        label: 'Xã Đồng Văn',
        value: 'XA_DONG_VAN'
      },
      {
        label: 'Xã Sà Phìn',
        value: 'XA_SA_PHIN'
      },
      {
        label: 'Xã Phố Bảng',
        value: 'XA_PHO_BANG'
      },
      {
        label: 'Xã Lũng Phìn',
        value: 'XA_LUNG_PHIN'
      },
      {
        label: 'Xã Mèo Vạc',
        value: 'XA_MEO_VAC'
      },
      {
        label: 'Xã Sơn Vĩ',
        value: 'XA_SON_VI'
      },
      {
        label: 'Xã Sủng Máng',
        value: 'XA_SUNG_MANG'
      },
      {
        label: 'Xã Khâu Vai',
        value: 'XA_KHAU_VAI'
      },
      {
        label: 'Xã Tát Ngà',
        value: 'XA_TAT_NGA'
      },
      {
        label: 'Xã Niêm Sơn',
        value: 'XA_NIEM_SON'
      },
      {
        label: 'Xã Yên Minh',
        value: 'XA_YEN_MINH'
      },
      {
        label: 'Xã Thắng Mố',
        value: 'XA_THANG_MO'
      },
      {
        label: 'Xã Bạch Đích',
        value: 'XA_BACH_DICH'
      },
      {
        label: 'Xã Mậu Duệ',
        value: 'XA_MAU_DUE'
      },
      {
        label: 'Xã Ngọc Long',
        value: 'XA_NGOC_LONG'
      },
      {
        label: 'Xã Đường Thượng',
        value: 'XA_DUONG_THUONG'
      },
      {
        label: 'Xã Du Già',
        value: 'XA_DU_GIA'
      },
      {
        label: 'Xã Quản Bạ',
        value: 'XA_QUAN_BA'
      },
      {
        label: 'Xã Cán Tỷ',
        value: 'XA_CAN_TY'
      },
      {
        label: 'Xã Nghĩa Thuận',
        value: 'XA_NGHIA_THUAN'
      },
      {
        label: 'Xã Tùng Vài',
        value: 'XA_TUNG_VAI'
      },
      {
        label: 'Xã Lùng Tám',
        value: 'XA_LUNG_TAM'
      },
      {
        label: 'Xã Vị Xuyên',
        value: 'XA_VI_XUYEN'
      },
      {
        label: 'Xã Minh Tân',
        value: 'XA_MINH_TAN'
      },
      {
        label: 'Xã Thuận Hoà',
        value: 'XA_THUAN_HOA'
      },
      {
        label: 'Xã Tùng Bá',
        value: 'XA_TUNG_BA'
      },
      {
        label: 'Xã Thanh Thuỷ',
        value: 'XA_THANH_THUY'
      },
      {
        label: 'Xã Lao Chải',
        value: 'XA_LAO_CHAI'
      },
      {
        label: 'Xã Cao Bồ',
        value: 'XA_CAO_BO'
      },
      {
        label: 'Xã Thượng Sơn',
        value: 'XA_THUONG_SON'
      },
      {
        label: 'Xã Việt Lâm',
        value: 'XA_VIET_LAM'
      },
      {
        label: 'Xã Linh Hồ',
        value: 'XA_LINH_HO'
      },
      {
        label: 'Xã Bạch Ngọc',
        value: 'XA_BACH_NGOC'
      },
      {
        label: 'Xã Minh Sơn',
        value: 'XA_MINH_SON'
      },
      {
        label: 'Xã Giáp Trung',
        value: 'XA_GIAP_TRUNG'
      },
      {
        label: 'Xã Bắc Mê',
        value: 'XA_BAC_ME'
      },
      {
        label: 'Xã Minh Ngọc',
        value: 'XA_MINH_NGOC'
      },
      {
        label: 'Xã Yên Cường',
        value: 'XA_YEN_CUONG'
      },
      {
        label: 'Xã Đường Hồng',
        value: 'XA_DUONG_HONG'
      },
      {
        label: 'Xã Hoàng Su Phì',
        value: 'XA_HOANG_SU_PHI'
      },
      {
        label: 'Xã Bản Máy',
        value: 'XA_BAN_MAY'
      },
      {
        label: 'Xã Thàng Tín',
        value: 'XA_THANG_TIN'
      },
      {
        label: 'Xã Tân Tiến',
        value: 'XA_TAN_TIEN'
      },
      {
        label: 'Xã Pờ Ly Ngài',
        value: 'XA_PO_LY_NGAI'
      },
      {
        label: 'Xã Nậm Dịch',
        value: 'XA_NAM_DICH'
      },
      {
        label: 'Xã Hồ Thầu',
        value: 'XA_HO_THAU'
      },
      {
        label: 'Xã Thông Nguyên',
        value: 'XA_THONG_NGUYEN'
      },
      {
        label: 'Xã Pà Vầy Sủ',
        value: 'XA_PA_VAY_SU'
      },
      {
        label: 'Xã Xín Mần',
        value: 'XA_XIN_MAN'
      },
      {
        label: 'Xã Trung Thịnh',
        value: 'XA_TRUNG_THINH'
      },
      {
        label: 'Xã Nấm Dẩn',
        value: 'XA_NAM_DAN'
      },
      {
        label: 'Xã Quảng Nguyên',
        value: 'XA_QUANG_NGUYEN'
      },
      {
        label: 'Xã Khuôn Lùng',
        value: 'XA_KHUON_LUNG'
      },
      {
        label: 'Xã Bắc Quang',
        value: 'XA_BAC_QUANG'
      },
      {
        label: 'Xã Vĩnh Tuy',
        value: 'XA_VINH_TUY'
      },
      {
        label: 'Xã Đồng Tâm',
        value: 'XA_DONG_TAM'
      },
      {
        label: 'Xã Tân Quang',
        value: 'XA_TAN_QUANG'
      },
      {
        label: 'Xã Bằng Hành',
        value: 'XA_BANG_HANH'
      },
      {
        label: 'Xã Liên Hiệp',
        value: 'XA_LIEN_HIEP'
      },
      {
        label: 'Xã Hùng An',
        value: 'XA_HUNG_AN'
      },
      {
        label: 'Xã Đồng Yên',
        value: 'XA_DONG_YEN'
      },
      {
        label: 'Xã Tiên Nguyên',
        value: 'XA_TIEN_NGUYEN'
      },
      {
        label: 'Xã Yên Thành',
        value: 'XA_YEN_THANH'
      },
      {
        label: 'Xã Quang Bình',
        value: 'XA_QUANG_BINH'
      },
      {
        label: 'Xã Tân Trịnh',
        value: 'XA_TAN_TRINH'
      },
      {
        label: 'Xã Bằng Lang',
        value: 'XA_BANG_LANG'
      },
      {
        label: 'Xã Xuân Giang',
        value: 'XA_XUAN_GIANG'
      },
      {
        label: 'Xã Tiên Yên',
        value: 'XA_TIEN_YEN'
      },
      {
        label: 'Phường Nông Tiến',
        value: 'PHUONG_NONG_TIEN'
      },
      {
        label: 'Phường Minh Xuân',
        value: 'PHUONG_MINH_XUAN'
      },
      {
        label: 'Xã Nà Hang',
        value: 'XA_NA_HANG'
      },
      {
        label: 'Xã Thượng Nông',
        value: 'XA_THUONG_NONG'
      },
      {
        label: 'Xã Côn Lôn',
        value: 'XA_CON_LON'
      },
      {
        label: 'Xã Yên Hoa',
        value: 'XA_YEN_HOA'
      },
      {
        label: 'Xã Hồng Thái',
        value: 'XA_HONG_THAI'
      },
      {
        label: 'Xã Lâm Bình',
        value: 'XA_LAM_BINH'
      },
      {
        label: 'Xã Thượng Lâm',
        value: 'XA_THUONG_LAM'
      },
      {
        label: 'Xã Chiêm Hoá',
        value: 'XA_CHIEM_HOA'
      },
      {
        label: 'Xã Bình An',
        value: 'XA_BINH_AN'
      },
      {
        label: 'Xã Minh Quang',
        value: 'XA_MINH_QUANG'
      },
      {
        label: 'Xã Trung Hà',
        value: 'XA_TRUNG_HA'
      },
      {
        label: 'Xã Tân Mỹ',
        value: 'XA_TAN_MY'
      },
      {
        label: 'Xã Yên Lập',
        value: 'XA_YEN_LAP'
      },
      {
        label: 'Xã Tân An',
        value: 'XA_TAN_AN'
      },
      {
        label: 'Xã Kiên Đài',
        value: 'XA_KIEN_DAI'
      },
      {
        label: 'Xã Kim Bình',
        value: 'XA_KIM_BINH'
      },
      {
        label: 'Xã Hoà An',
        value: 'XA_HOA_AN'
      },
      {
        label: 'Xã Tri Phú',
        value: 'XA_TRI_PHU'
      },
      {
        label: 'Xã Yên Nguyên',
        value: 'XA_YEN_NGUYEN'
      },
      {
        label: 'Xã Hàm Yên',
        value: 'XA_HAM_YEN'
      },
      {
        label: 'Xã Bạch Xa',
        value: 'XA_BACH_XA'
      },
      {
        label: 'Xã Phù Lưu',
        value: 'XA_PHU_LUU'
      },
      {
        label: 'Xã Yên Phú',
        value: 'XA_YEN_PHU'
      },
      {
        label: 'Xã Bình Xa',
        value: 'XA_BINH_XA'
      },
      {
        label: 'Xã Thái Sơn',
        value: 'XA_THAI_SON'
      },
      {
        label: 'Xã Thái Hoà',
        value: 'XA_THAI_HOA'
      },
      {
        label: 'Xã Hùng Đức',
        value: 'XA_HUNG_DUC'
      },
      {
        label: 'Xã Lực Hành',
        value: 'XA_LUC_HANH'
      },
      {
        label: 'Xã Kiến Thiết',
        value: 'XA_KIEN_THIET'
      },
      {
        label: 'Xã Xuân Vân',
        value: 'XA_XUAN_VAN'
      },
      {
        label: 'Xã Hùng Lợi',
        value: 'XA_HUNG_LOI'
      },
      {
        label: 'Xã Trung Sơn',
        value: 'XA_TRUNG_SON'
      },
      {
        label: 'Xã Tân Long',
        value: 'XA_TAN_LONG'
      },
      {
        label: 'Xã Yên Sơn',
        value: 'XA_YEN_SON'
      },
      {
        label: 'Xã Thái Bình',
        value: 'XA_THAI_BINH'
      },
      {
        label: 'Phường Mỹ Lâm',
        value: 'PHUONG_MY_LAM'
      },
      {
        label: 'Phường An Tường',
        value: 'PHUONG_AN_TUONG'
      },
      {
        label: 'Phường Bình Thuận',
        value: 'PHUONG_BINH_THUAN'
      },
      {
        label: 'Xã Nhữ Khê',
        value: 'XA_NHU_KHE'
      },
      {
        label: 'Xã Sơn Dương',
        value: 'XA_SON_DUONG'
      },
      {
        label: 'Xã Tân Trào',
        value: 'XA_TAN_TRAO'
      },
      {
        label: 'Xã Bình Ca',
        value: 'XA_BINH_CA'
      },
      {
        label: 'Xã Minh Thanh',
        value: 'XA_MINH_THANH'
      },
      {
        label: 'Xã Đông Thọ',
        value: 'XA_DONG_THO'
      },
      {
        label: 'Xã Tân Thanh',
        value: 'XA_TAN_THANH'
      },
      {
        label: 'Xã Hồng Sơn',
        value: 'XA_HONG_SON'
      },
      {
        label: 'Xã Phú Lương',
        value: 'XA_PHU_LUONG'
      },
      {
        label: 'Xã Sơn Thuỷ',
        value: 'XA_SON_THUY'
      },
      {
        label: 'Xã Trường Sinh',
        value: 'XA_TRUONG_SINH'
      }
    ]
  },
  {
    label: 'Điện Biên',
    value: 'DIEN_BIEN',
    children: [
      {
        label: 'Phường Điện Biên Phủ',
        value: 'PHUONG_DIEN_BIEN_PHU'
      },
      {
        label: 'Phường Mường Lay',
        value: 'PHUONG_MUONG_LAY'
      },
      {
        label: 'Xã Sín Thầu',
        value: 'XA_SIN_THAU'
      },
      {
        label: 'Xã Mường Nhé',
        value: 'XA_MUONG_NHE'
      },
      {
        label: 'Xã Nậm Kè',
        value: 'XA_NAM_KE'
      },
      {
        label: 'Xã Mường Toong',
        value: 'XA_MUONG_TOONG'
      },
      {
        label: 'Xã Quảng Lâm',
        value: 'XA_QUANG_LAM'
      },
      {
        label: 'Xã Mường Chà',
        value: 'XA_MUONG_CHA'
      },
      {
        label: 'Xã Nà Hỳ',
        value: 'XA_NA_HY'
      },
      {
        label: 'Xã Na Sang',
        value: 'XA_NA_SANG'
      },
      {
        label: 'Xã Chà Tở',
        value: 'XA_CHA_TO'
      },
      {
        label: 'Xã Nà Bủng',
        value: 'XA_NA_BUNG'
      },
      {
        label: 'Xã Mường Tùng',
        value: 'XA_MUONG_TUNG'
      },
      {
        label: 'Xã Pa Ham',
        value: 'XA_PA_HAM'
      },
      {
        label: 'Xã Nậm Nèn',
        value: 'XA_NAM_NEN'
      },
      {
        label: 'Xã Si Pa Phìn',
        value: 'XA_SI_PA_PHIN'
      },
      {
        label: 'Xã Mường Pồn',
        value: 'XA_MUONG_PON'
      },
      {
        label: 'Xã Na Son',
        value: 'XA_NA_SON'
      },
      {
        label: 'Xã Xa Dung',
        value: 'XA_XA_DUNG'
      },
      {
        label: 'Xã Mường Luân',
        value: 'XA_MUONG_LUAN'
      },
      {
        label: 'Xã Tủa Chùa',
        value: 'XA_TUA_CHUA'
      },
      {
        label: 'Xã Tủa Thàng',
        value: 'XA_TUA_THANG'
      },
      {
        label: 'Xã Sín Chải',
        value: 'XA_SIN_CHAI'
      },
      {
        label: 'Xã Sính Phình',
        value: 'XA_SINH_PHINH'
      },
      {
        label: 'Xã Sáng Nhè',
        value: 'XA_SANG_NHE'
      },
      {
        label: 'Xã Tuần Giáo',
        value: 'XA_TUAN_GIAO'
      },
      {
        label: 'Xã Mường Ảng',
        value: 'XA_MUONG_ANG'
      },
      {
        label: 'Xã Pú Nhung',
        value: 'XA_PU_NHUNG'
      },
      {
        label: 'Xã Mường Mùn',
        value: 'XA_MUONG_MUN'
      },
      {
        label: 'Xã Chiềng Sinh',
        value: 'XA_CHIENG_SINH'
      },
      {
        label: 'Xã Quài Tở',
        value: 'XA_QUAI_TO'
      },
      {
        label: 'Xã Búng Lao',
        value: 'XA_BUNG_LAO'
      },
      {
        label: 'Xã Mường Lạn',
        value: 'XA_MUONG_LAN'
      },
      {
        label: 'Xã Nà Tấu',
        value: 'XA_NA_TAU'
      },
      {
        label: 'Xã Mường Phăng',
        value: 'XA_MUONG_PHANG'
      },
      {
        label: 'Xã Thanh Nưa',
        value: 'XA_THANH_NUA'
      },
      {
        label: 'Phường Mường Thanh',
        value: 'PHUONG_MUONG_THANH'
      },
      {
        label: 'Xã Thanh Yên',
        value: 'XA_THANH_YEN'
      },
      {
        label: 'Xã Thanh An',
        value: 'XA_THANH_AN'
      },
      {
        label: 'Xã Sam Mứn',
        value: 'XA_SAM_MUN'
      },
      {
        label: 'Xã Núa Ngam',
        value: 'XA_NUA_NGAM'
      },
      {
        label: 'Xã Mường Nhà',
        value: 'XA_MUONG_NHA'
      },
      {
        label: 'Xã Pu Nhi',
        value: 'XA_PU_NHI'
      },
      {
        label: 'Xã Phình Giàng',
        value: 'XA_PHINH_GIANG'
      },
      {
        label: 'Xã Tìa Dình',
        value: 'XA_TIA_DINH'
      }
    ]
  },
  {
    label: 'Lai Châu',
    value: 'LAI_CHAU',
    children: [
      {
        label: 'Phường Đoàn Kết',
        value: 'PHUONG_DOAN_KET'
      },
      {
        label: 'Xã Bình Lư',
        value: 'XA_BINH_LU'
      },
      {
        label: 'Xã Sin Suối Hồ',
        value: 'XA_SIN_SUOI_HO'
      },
      {
        label: 'Xã Tả Lèng',
        value: 'XA_TA_LENG'
      },
      {
        label: 'Phường Tân Phong',
        value: 'PHUONG_TAN_PHONG'
      },
      {
        label: 'Xã Bản Bo',
        value: 'XA_BAN_BO'
      },
      {
        label: 'Xã Khun Há',
        value: 'XA_KHUN_HA'
      },
      {
        label: 'Xã Bum Tở',
        value: 'XA_BUM_TO'
      },
      {
        label: 'Xã Nậm Hàng',
        value: 'XA_NAM_HANG'
      },
      {
        label: 'Xã Thu Lũm',
        value: 'XA_THU_LUM'
      },
      {
        label: 'Xã Pa Ủ',
        value: 'XA_PA_U'
      },
      {
        label: 'Xã Mường Tè',
        value: 'XA_MUONG_TE'
      },
      {
        label: 'Xã Mù Cả',
        value: 'XA_MU_CA'
      },
      {
        label: 'Xã Hua Bum',
        value: 'XA_HUA_BUM'
      },
      {
        label: 'Xã Tà Tổng',
        value: 'XA_TA_TONG'
      },
      {
        label: 'Xã Bum Nưa',
        value: 'XA_BUM_NUA'
      },
      {
        label: 'Xã Mường Mô',
        value: 'XA_MUONG_MO'
      },
      {
        label: 'Xã Sìn Hồ',
        value: 'XA_SIN_HO'
      },
      {
        label: 'Xã Lê Lợi',
        value: 'XA_LE_LOI'
      },
      {
        label: 'Xã Pa Tần',
        value: 'XA_PA_TAN'
      },
      {
        label: 'Xã Hồng Thu',
        value: 'XA_HONG_THU'
      },
      {
        label: 'Xã Nậm Tăm',
        value: 'XA_NAM_TAM'
      },
      {
        label: 'Xã Tủa Sín Chải',
        value: 'XA_TUA_SIN_CHAI'
      },
      {
        label: 'Xã Pu Sam Cáp',
        value: 'XA_PU_SAM_CAP'
      },
      {
        label: 'Xã Nậm Mạ',
        value: 'XA_NAM_MA'
      },
      {
        label: 'Xã Nậm Cuổi',
        value: 'XA_NAM_CUOI'
      },
      {
        label: 'Xã Phong Thổ',
        value: 'XA_PHONG_THO'
      },
      {
        label: 'Xã Sì Lở Lầu',
        value: 'XA_SI_LO_LAU'
      },
      {
        label: 'Xã Dào San',
        value: 'XA_DAO_SAN'
      },
      {
        label: 'Xã Khổng Lào',
        value: 'XA_KHONG_LAO'
      },
      {
        label: 'Xã Than Uyên',
        value: 'XA_THAN_UYEN'
      },
      {
        label: 'Xã Tân Uyên',
        value: 'XA_TAN_UYEN'
      },
      {
        label: 'Xã Mường Khoa',
        value: 'XA_MUONG_KHOA'
      },
      {
        label: 'Xã Nậm Sỏ',
        value: 'XA_NAM_SO'
      },
      {
        label: 'Xã Pắc Ta',
        value: 'XA_PAC_TA'
      },
      {
        label: 'Xã Mường Than',
        value: 'XA_MUONG_THAN'
      },
      {
        label: 'Xã Mường Kim',
        value: 'XA_MUONG_KIM'
      },
      {
        label: 'Xã Khoen On',
        value: 'XA_KHOEN_ON'
      }
    ]
  },
  {
    label: 'Sơn La',
    value: 'SON_LA',
    children: [
      {
        label: 'Phường Tô Hiệu',
        value: 'PHUONG_TO_HIEU'
      },
      {
        label: 'Phường Chiềng An',
        value: 'PHUONG_CHIENG_AN'
      },
      {
        label: 'Phường Chiềng Cơi',
        value: 'PHUONG_CHIENG_COI'
      },
      {
        label: 'Phường Chiềng Sinh',
        value: 'PHUONG_CHIENG_SINH'
      },
      {
        label: 'Xã Mường Chiên',
        value: 'XA_MUONG_CHIEN'
      },
      {
        label: 'Xã Mường Giôn',
        value: 'XA_MUONG_GION'
      },
      {
        label: 'Xã Quỳnh Nhai',
        value: 'XA_QUYNH_NHAI'
      },
      {
        label: 'Xã Mường Sại',
        value: 'XA_MUONG_SAI'
      },
      {
        label: 'Xã Thuận Châu',
        value: 'XA_THUAN_CHAU'
      },
      {
        label: 'Xã Bình Thuận',
        value: 'XA_BINH_THUAN'
      },
      {
        label: 'Xã Mường É',
        value: 'XA_MUONG_E'
      },
      {
        label: 'Xã Chiềng La',
        value: 'XA_CHIENG_LA'
      },
      {
        label: 'Xã Mường Khiêng',
        value: 'XA_MUONG_KHIENG'
      },
      {
        label: 'Xã Mường Bám',
        value: 'XA_MUONG_BAM'
      },
      {
        label: 'Xã Long Hẹ',
        value: 'XA_LONG_HE'
      },
      {
        label: 'Xã Co Mạ',
        value: 'XA_CO_MA'
      },
      {
        label: 'Xã Nậm Lầu',
        value: 'XA_NAM_LAU'
      },
      {
        label: 'Xã Muổi Nọi',
        value: 'XA_MUOI_NOI'
      },
      {
        label: 'Xã Mường La',
        value: 'XA_MUONG_LA'
      },
      {
        label: 'Xã Chiềng Lao',
        value: 'XA_CHIENG_LAO'
      },
      {
        label: 'Xã Ngọc Chiến',
        value: 'XA_NGOC_CHIEN'
      },
      {
        label: 'Xã Mường Bú',
        value: 'XA_MUONG_BU'
      },
      {
        label: 'Xã Chiềng Hoa',
        value: 'XA_CHIENG_HOA'
      },
      {
        label: 'Xã Bắc Yên',
        value: 'XA_BAC_YEN'
      },
      {
        label: 'Xã Xím Vàng',
        value: 'XA_XIM_VANG'
      },
      {
        label: 'Xã Tà Xùa',
        value: 'XA_TA_XUA'
      },
      {
        label: 'Xã Pắc Ngà',
        value: 'XA_PAC_NGA'
      },
      {
        label: 'Xã Tạ Khoa',
        value: 'XA_TA_KHOA'
      },
      {
        label: 'Xã Chiềng Sại',
        value: 'XA_CHIENG_SAI'
      },
      {
        label: 'Xã Suối Tọ',
        value: 'XA_SUOI_TO'
      },
      {
        label: 'Xã Mường Cơi',
        value: 'XA_MUONG_COI'
      },
      {
        label: 'Xã Phù Yên',
        value: 'XA_PHU_YEN'
      },
      {
        label: 'Xã Gia Phù',
        value: 'XA_GIA_PHU'
      },
      {
        label: 'Xã Mường Bang',
        value: 'XA_MUONG_BANG'
      },
      {
        label: 'Xã Tường Hạ',
        value: 'XA_TUONG_HA'
      },
      {
        label: 'Xã Kim Bon',
        value: 'XA_KIM_BON'
      },
      {
        label: 'Xã Tân Phong',
        value: 'XA_TAN_PHONG'
      },
      {
        label: 'Phường Mộc Sơn',
        value: 'PHUONG_MOC_SON'
      },
      {
        label: 'Phường Mộc Châu',
        value: 'PHUONG_MOC_CHAU'
      },
      {
        label: 'Phường Thảo Nguyên',
        value: 'PHUONG_THAO_NGUYEN'
      },
      {
        label: 'Xã Chiềng Sơn',
        value: 'XA_CHIENG_SON'
      },
      {
        label: 'Xã Tân Yên',
        value: 'XA_TAN_YEN'
      },
      {
        label: 'Xã Đoàn Kết',
        value: 'XA_DOAN_KET'
      },
      {
        label: 'Xã Song Khủa',
        value: 'XA_SONG_KHUA'
      },
      {
        label: 'Xã Tô Múa',
        value: 'XA_TO_MUA'
      },
      {
        label: 'Phường Vân Sơn',
        value: 'PHUONG_VAN_SON'
      },
      {
        label: 'Xã Lóng Sập',
        value: 'XA_LONG_SAP'
      },
      {
        label: 'Xã Vân Hồ',
        value: 'XA_VAN_HO'
      },
      {
        label: 'Xã Xuân Nha',
        value: 'XA_XUAN_NHA'
      },
      {
        label: 'Xã Yên Châu',
        value: 'XA_YEN_CHAU'
      },
      {
        label: 'Xã Chiềng Hặc',
        value: 'XA_CHIENG_HAC'
      },
      {
        label: 'Xã Yên Sơn',
        value: 'XA_YEN_SON'
      },
      {
        label: 'Xã Lóng Phiêng',
        value: 'XA_LONG_PHIENG'
      },
      {
        label: 'Xã Phiêng Khoài',
        value: 'XA_PHIENG_KHOAI'
      },
      {
        label: 'Xã Mai Sơn',
        value: 'XA_MAI_SON'
      },
      {
        label: 'Xã Chiềng Sung',
        value: 'XA_CHIENG_SUNG'
      },
      {
        label: 'Xã Mường Chanh',
        value: 'XA_MUONG_CHANH'
      },
      {
        label: 'Xã Chiềng Mung',
        value: 'XA_CHIENG_MUNG'
      },
      {
        label: 'Xã Chiềng Mai',
        value: 'XA_CHIENG_MAI'
      },
      {
        label: 'Xã Tà Hộc',
        value: 'XA_TA_HOC'
      },
      {
        label: 'Xã Phiêng Cằm',
        value: 'XA_PHIENG_CAM'
      },
      {
        label: 'Xã Phiêng Pằn',
        value: 'XA_PHIENG_PAN'
      },
      {
        label: 'Xã Sông Mã',
        value: 'XA_SONG_MA'
      },
      {
        label: 'Xã Bó Sinh',
        value: 'XA_BO_SINH'
      },
      {
        label: 'Xã Mường Lầm',
        value: 'XA_MUONG_LAM'
      },
      {
        label: 'Xã Nậm Ty',
        value: 'XA_NAM_TY'
      },
      {
        label: 'Xã Chiềng Sơ',
        value: 'XA_CHIENG_SO'
      },
      {
        label: 'Xã Chiềng Khoong',
        value: 'XA_CHIENG_KHOONG'
      },
      {
        label: 'Xã Huổi Một',
        value: 'XA_HUOI_MOT'
      },
      {
        label: 'Xã Mường Hung',
        value: 'XA_MUONG_HUNG'
      },
      {
        label: 'Xã Chiềng Khương',
        value: 'XA_CHIENG_KHUONG'
      },
      {
        label: 'Xã Púng Bánh',
        value: 'XA_PUNG_BANH'
      },
      {
        label: 'Xã Sốp Cộp',
        value: 'XA_SOP_COP'
      },
      {
        label: 'Xã Mường Lèo',
        value: 'XA_MUONG_LEO'
      },
      {
        label: 'Xã Mường Lạn',
        value: 'XA_MUONG_LAN'
      }
    ]
  },
  {
    label: 'Lào Cai',
    value: 'LAO_CAI',
    children: [
      {
        label: 'Phường Lào Cai',
        value: 'PHUONG_LAO_CAI'
      },
      {
        label: 'Phường Cam Đường',
        value: 'PHUONG_CAM_DUONG'
      },
      {
        label: 'Xã Hợp Thành',
        value: 'XA_HOP_THANH'
      },
      {
        label: 'Xã Bát Xát',
        value: 'XA_BAT_XAT'
      },
      {
        label: 'Xã A Mú Sung',
        value: 'XA_A_MU_SUNG'
      },
      {
        label: 'Xã Trịnh Tường',
        value: 'XA_TRINH_TUONG'
      },
      {
        label: 'Xã Y Tý',
        value: 'XA_Y_TY'
      },
      {
        label: 'Xã Dền Sáng',
        value: 'XA_DEN_SANG'
      },
      {
        label: 'Xã Bản Xèo',
        value: 'XA_BAN_XEO'
      },
      {
        label: 'Xã Mường Hum',
        value: 'XA_MUONG_HUM'
      },
      {
        label: 'Xã Cốc San',
        value: 'XA_COC_SAN'
      },
      {
        label: 'Xã Pha Long',
        value: 'XA_PHA_LONG'
      },
      {
        label: 'Xã Mường Khương',
        value: 'XA_MUONG_KHUONG'
      },
      {
        label: 'Xã Bản Lầu',
        value: 'XA_BAN_LAU'
      },
      {
        label: 'Xã Cao Sơn',
        value: 'XA_CAO_SON'
      },
      {
        label: 'Xã Si Ma Cai',
        value: 'XA_SI_MA_CAI'
      },
      {
        label: 'Xã Sín Chéng',
        value: 'XA_SIN_CHENG'
      },
      {
        label: 'Xã Bắc Hà',
        value: 'XA_BAC_HA'
      },
      {
        label: 'Xã Tả Củ Tỷ',
        value: 'XA_TA_CU_TY'
      },
      {
        label: 'Xã Lùng Phình',
        value: 'XA_LUNG_PHINH'
      },
      {
        label: 'Xã Bản Liền',
        value: 'XA_BAN_LIEN'
      },
      {
        label: 'Xã Bảo Nhai',
        value: 'XA_BAO_NHAI'
      },
      {
        label: 'Xã Cốc Lầu',
        value: 'XA_COC_LAU'
      },
      {
        label: 'Xã Phong Hải',
        value: 'XA_PHONG_HAI'
      },
      {
        label: 'Xã Bảo Thắng',
        value: 'XA_BAO_THANG'
      },
      {
        label: 'Xã Tằng Loỏng',
        value: 'XA_TANG_LOONG'
      },
      {
        label: 'Xã Gia Phú',
        value: 'XA_GIA_PHU'
      },
      {
        label: 'Xã Xuân Quang',
        value: 'XA_XUAN_QUANG'
      },
      {
        label: 'Xã Bảo Yên',
        value: 'XA_BAO_YEN'
      },
      {
        label: 'Xã Nghĩa Đô',
        value: 'XA_NGHIA_DO'
      },
      {
        label: 'Xã Xuân Hòa',
        value: 'XA_XUAN_HOA'
      },
      {
        label: 'Xã Thượng Hà',
        value: 'XA_THUONG_HA'
      },
      {
        label: 'Xã Bảo Hà',
        value: 'XA_BAO_HA'
      },
      {
        label: 'Xã Phúc Khánh',
        value: 'XA_PHUC_KHANH'
      },
      {
        label: 'Xã Ngũ Chỉ Sơn',
        value: 'XA_NGU_CHI_SON'
      },
      {
        label: 'Phường Sa Pa',
        value: 'PHUONG_SA_PA'
      },
      {
        label: 'Xã Tả Phìn',
        value: 'XA_TA_PHIN'
      },
      {
        label: 'Xã Tả Van',
        value: 'XA_TA_VAN'
      },
      {
        label: 'Xã Mường Bo',
        value: 'XA_MUONG_BO'
      },
      {
        label: 'Xã Bản Hồ',
        value: 'XA_BAN_HO'
      },
      {
        label: 'Xã Võ Lao',
        value: 'XA_VO_LAO'
      },
      {
        label: 'Xã Nậm Chày',
        value: 'XA_NAM_CHAY'
      },
      {
        label: 'Xã Văn Bàn',
        value: 'XA_VAN_BAN'
      },
      {
        label: 'Xã Nậm Xé',
        value: 'XA_NAM_XE'
      },
      {
        label: 'Xã Chiềng Ken',
        value: 'XA_CHIENG_KEN'
      },
      {
        label: 'Xã Khánh Yên',
        value: 'XA_KHANH_YEN'
      },
      {
        label: 'Xã Dương Quỳ',
        value: 'XA_DUONG_QUY'
      },
      {
        label: 'Xã Minh Lương',
        value: 'XA_MINH_LUONG'
      },
      {
        label: 'Phường Yên Bái',
        value: 'PHUONG_YEN_BAI'
      },
      {
        label: 'Phường Nam Cường',
        value: 'PHUONG_NAM_CUONG'
      },
      {
        label: 'Phường Văn Phú',
        value: 'PHUONG_VAN_PHU'
      },
      {
        label: 'Phường Nghĩa Lộ',
        value: 'PHUONG_NGHIA_LO'
      },
      {
        label: 'Xã Lục Yên',
        value: 'XA_LUC_YEN'
      },
      {
        label: 'Xã Lâm Thượng',
        value: 'XA_LAM_THUONG'
      },
      {
        label: 'Xã Khánh Hòa',
        value: 'XA_KHANH_HOA'
      },
      {
        label: 'Xã Tân Lĩnh',
        value: 'XA_TAN_LINH'
      },
      {
        label: 'Xã Mường Lai',
        value: 'XA_MUONG_LAI'
      },
      {
        label: 'Xã Phúc Lợi',
        value: 'XA_PHUC_LOI'
      },
      {
        label: 'Xã Mậu A',
        value: 'XA_MAU_A'
      },
      {
        label: 'Xã Lâm Giang',
        value: 'XA_LAM_GIANG'
      },
      {
        label: 'Xã Châu Quế',
        value: 'XA_CHAU_QUE'
      },
      {
        label: 'Xã Đông Cuông',
        value: 'XA_DONG_CUONG'
      },
      {
        label: 'Xã Phong Dụ Hạ',
        value: 'XA_PHONG_DU_HA'
      },
      {
        label: 'Xã Phong Dụ Thượng',
        value: 'XA_PHONG_DU_THUONG'
      },
      {
        label: 'Xã Tân Hợp',
        value: 'XA_TAN_HOP'
      },
      {
        label: 'Xã Xuân Ái',
        value: 'XA_XUAN_AI'
      },
      {
        label: 'Xã Mỏ Vàng',
        value: 'XA_MO_VANG'
      },
      {
        label: 'Xã Mù Cang Chải',
        value: 'XA_MU_CANG_CHAI'
      },
      {
        label: 'Xã Nậm Có',
        value: 'XA_NAM_CO'
      },
      {
        label: 'Xã Khao Mang',
        value: 'XA_KHAO_MANG'
      },
      {
        label: 'Xã Lao Chải',
        value: 'XA_LAO_CHAI'
      },
      {
        label: 'Xã Chế Tạo',
        value: 'XA_CHE_TAO'
      },
      {
        label: 'Xã Púng Luông',
        value: 'XA_PUNG_LUONG'
      },
      {
        label: 'Xã Trấn Yên',
        value: 'XA_TRAN_YEN'
      },
      {
        label: 'Xã Quy Mông',
        value: 'XA_QUY_MONG'
      },
      {
        label: 'Xã Lương Thịnh',
        value: 'XA_LUONG_THINH'
      },
      {
        label: 'Phường Âu Lâu',
        value: 'PHUONG_AU_LAU'
      },
      {
        label: 'Xã Việt Hồng',
        value: 'XA_VIET_HONG'
      },
      {
        label: 'Xã Hưng Khánh',
        value: 'XA_HUNG_KHANH'
      },
      {
        label: 'Xã Hạnh Phúc',
        value: 'XA_HANH_PHUC'
      },
      {
        label: 'Xã Trạm Tấu',
        value: 'XA_TRAM_TAU'
      },
      {
        label: 'Xã Tà Xi Láng',
        value: 'XA_TA_XI_LANG'
      },
      {
        label: 'Xã Phình Hồ',
        value: 'XA_PHINH_HO'
      },
      {
        label: 'Xã Tú Lệ',
        value: 'XA_TU_LE'
      },
      {
        label: 'Xã Gia Hội',
        value: 'XA_GIA_HOI'
      },
      {
        label: 'Xã Sơn Lương',
        value: 'XA_SON_LUONG'
      },
      {
        label: 'Xã Liên Sơn',
        value: 'XA_LIEN_SON'
      },
      {
        label: 'Phường Trung Tâm',
        value: 'PHUONG_TRUNG_TAM'
      },
      {
        label: 'Xã Văn Chấn',
        value: 'XA_VAN_CHAN'
      },
      {
        label: 'Phường Cầu Thia',
        value: 'PHUONG_CAU_THIA'
      },
      {
        label: 'Xã Cát Thịnh',
        value: 'XA_CAT_THINH'
      },
      {
        label: 'Xã Chấn Thịnh',
        value: 'XA_CHAN_THINH'
      },
      {
        label: 'Xã Thượng Bằng La',
        value: 'XA_THUONG_BANG_LA'
      },
      {
        label: 'Xã Nghĩa Tâm',
        value: 'XA_NGHIA_TAM'
      },
      {
        label: 'Xã Yên Bình',
        value: 'XA_YEN_BINH'
      },
      {
        label: 'Xã Thác Bà',
        value: 'XA_THAC_BA'
      },
      {
        label: 'Xã Cảm Nhân',
        value: 'XA_CAM_NHAN'
      },
      {
        label: 'Xã Yên Thành',
        value: 'XA_YEN_THANH'
      },
      {
        label: 'Xã Bảo Ái',
        value: 'XA_BAO_AI'
      }
    ]
  },
  {
    label: 'Thái Nguyên',
    value: 'THAI_NGUYEN',
    children: [
      {
        label: 'Phường Đức Xuân',
        value: 'PHUONG_DUC_XUAN'
      },
      {
        label: 'Phường Bắc Kạn',
        value: 'PHUONG_BAC_KAN'
      },
      {
        label: 'Xã Phong Quang',
        value: 'XA_PHONG_QUANG'
      },
      {
        label: 'Xã Bằng Thành',
        value: 'XA_BANG_THANH'
      },
      {
        label: 'Xã Cao Minh',
        value: 'XA_CAO_MINH'
      },
      {
        label: 'Xã Nghiên Loan',
        value: 'XA_NGHIEN_LOAN'
      },
      {
        label: 'Xã Phúc Lộc',
        value: 'XA_PHUC_LOC'
      },
      {
        label: 'Xã Ba Bể',
        value: 'XA_BA_BE'
      },
      {
        label: 'Xã Chợ Rã',
        value: 'XA_CHO_RA'
      },
      {
        label: 'Xã Thượng Minh',
        value: 'XA_THUONG_MINH'
      },
      {
        label: 'Xã Đồng Phúc',
        value: 'XA_DONG_PHUC'
      },
      {
        label: 'Xã Nà Phặc',
        value: 'XA_NA_PHAC'
      },
      {
        label: 'Xã Bằng Vân',
        value: 'XA_BANG_VAN'
      },
      {
        label: 'Xã Ngân Sơn',
        value: 'XA_NGAN_SON'
      },
      {
        label: 'Xã Thượng Quan',
        value: 'XA_THUONG_QUAN'
      },
      {
        label: 'Xã Hiệp Lực',
        value: 'XA_HIEP_LUC'
      },
      {
        label: 'Xã Phủ Thông',
        value: 'XA_PHU_THONG'
      },
      {
        label: 'Xã Vĩnh Thông',
        value: 'XA_VINH_THONG'
      },
      {
        label: 'Xã Cẩm Giàng',
        value: 'XA_CAM_GIANG'
      },
      {
        label: 'Xã Bạch Thông',
        value: 'XA_BACH_THONG'
      },
      {
        label: 'Xã Chợ Đồn',
        value: 'XA_CHO_DON'
      },
      {
        label: 'Xã Nam Cường',
        value: 'XA_NAM_CUONG'
      },
      {
        label: 'Xã Quảng Bạch',
        value: 'XA_QUANG_BACH'
      },
      {
        label: 'Xã Yên Thịnh',
        value: 'XA_YEN_THINH'
      },
      {
        label: 'Xã Nghĩa Tá',
        value: 'XA_NGHIA_TA'
      },
      {
        label: 'Xã Yên Phong',
        value: 'XA_YEN_PHONG'
      },
      {
        label: 'Xã Chợ Mới',
        value: 'XA_CHO_MOI'
      },
      {
        label: 'Xã Thanh Mai',
        value: 'XA_THANH_MAI'
      },
      {
        label: 'Xã Tân Kỳ',
        value: 'XA_TAN_KY'
      },
      {
        label: 'Xã Thanh Thịnh',
        value: 'XA_THANH_THINH'
      },
      {
        label: 'Xã Yên Bình',
        value: 'XA_YEN_BINH'
      },
      {
        label: 'Xã Văn Lang',
        value: 'XA_VAN_LANG'
      },
      {
        label: 'Xã Cường Lợi',
        value: 'XA_CUONG_LOI'
      },
      {
        label: 'Xã Na Rì',
        value: 'XA_NA_RI'
      },
      {
        label: 'Xã Trần Phú',
        value: 'XA_TRAN_PHU'
      },
      {
        label: 'Xã Côn Minh',
        value: 'XA_CON_MINH'
      },
      {
        label: 'Xã Xuân Dương',
        value: 'XA_XUAN_DUONG'
      },
      {
        label: 'Phường Phan Đình Phùng',
        value: 'PHUONG_PHAN_DINH_PHUNG'
      },
      {
        label: 'Phường Quyết Thắng',
        value: 'PHUONG_QUYET_THANG'
      },
      {
        label: 'Phường Gia Sàng',
        value: 'PHUONG_GIA_SANG'
      },
      {
        label: 'Phường Quan Triều',
        value: 'PHUONG_QUAN_TRIEU'
      },
      {
        label: 'Xã Đại Phúc',
        value: 'XA_DAI_PHUC'
      },
      {
        label: 'Phường Tích Lương',
        value: 'PHUONG_TICH_LUONG'
      },
      {
        label: 'Xã Tân Cương',
        value: 'XA_TAN_CUONG'
      },
      {
        label: 'Phường Sông Công',
        value: 'PHUONG_SONG_CONG'
      },
      {
        label: 'Phường Bách Quang',
        value: 'PHUONG_BACH_QUANG'
      },
      {
        label: 'Phường Bá Xuyên',
        value: 'PHUONG_BA_XUYEN'
      },
      {
        label: 'Xã Lam Vỹ',
        value: 'XA_LAM_VY'
      },
      {
        label: 'Xã Kim Phượng',
        value: 'XA_KIM_PHUONG'
      },
      {
        label: 'Xã Phượng Tiến',
        value: 'XA_PHUONG_TIEN'
      },
      {
        label: 'Xã Định Hóa',
        value: 'XA_DINH_HOA'
      },
      {
        label: 'Xã Trung Hội',
        value: 'XA_TRUNG_HOI'
      },
      {
        label: 'Xã Bình Yên',
        value: 'XA_BINH_YEN'
      },
      {
        label: 'Xã Phú Đình',
        value: 'XA_PHU_DINH'
      },
      {
        label: 'Xã Bình Thành',
        value: 'XA_BINH_THANH'
      },
      {
        label: 'Xã Phú Lương',
        value: 'XA_PHU_LUONG'
      },
      {
        label: 'Xã Yên Trạch',
        value: 'XA_YEN_TRACH'
      },
      {
        label: 'Xã Hợp Thành',
        value: 'XA_HOP_THANH'
      },
      {
        label: 'Xã Vô Tranh',
        value: 'XA_VO_TRANH'
      },
      {
        label: 'Xã Trại Cau',
        value: 'XA_TRAI_CAU'
      },
      {
        label: 'Xã Văn Lăng',
        value: 'XA_VAN_LANG'
      },
      {
        label: 'Xã Quang Sơn',
        value: 'XA_QUANG_SON'
      },
      {
        label: 'Xã Văn Hán',
        value: 'XA_VAN_HAN'
      },
      {
        label: 'Xã Đồng Hỷ',
        value: 'XA_DONG_HY'
      },
      {
        label: 'Xã Nam Hòa',
        value: 'XA_NAM_HOA'
      },
      {
        label: 'Phường Linh Sơn',
        value: 'PHUONG_LINH_SON'
      },
      {
        label: 'Xã Võ Nhai',
        value: 'XA_VO_NHAI'
      },
      {
        label: 'Xã Sảng Mộc',
        value: 'XA_SANG_MOC'
      },
      {
        label: 'Xã Nghinh Tường',
        value: 'XA_NGHINH_TUONG'
      },
      {
        label: 'Xã Thần Sa',
        value: 'XA_THAN_SA'
      },
      {
        label: 'Xã La Hiên',
        value: 'XA_LA_HIEN'
      },
      {
        label: 'Xã Tràng Xá',
        value: 'XA_TRANG_XA'
      },
      {
        label: 'Xã Dân Tiến',
        value: 'XA_DAN_TIEN'
      },
      {
        label: 'Xã Phú Xuyên',
        value: 'XA_PHU_XUYEN'
      },
      {
        label: 'Xã Đức Lương',
        value: 'XA_DUC_LUONG'
      },
      {
        label: 'Xã Phú Lạc',
        value: 'XA_PHU_LAC'
      },
      {
        label: 'Xã Phú Thịnh',
        value: 'XA_PHU_THINH'
      },
      {
        label: 'Xã An Khánh',
        value: 'XA_AN_KHANH'
      },
      {
        label: 'Xã La Bằng',
        value: 'XA_LA_BANG'
      },
      {
        label: 'Xã Đại Từ',
        value: 'XA_DAI_TU'
      },
      {
        label: 'Xã Vạn Phú',
        value: 'XA_VAN_PHU'
      },
      {
        label: 'Xã Quân Chu',
        value: 'XA_QUAN_CHU'
      },
      {
        label: 'Phường Phúc Thuận',
        value: 'PHUONG_PHUC_THUAN'
      },
      {
        label: 'Phường Phổ Yên',
        value: 'PHUONG_PHO_YEN'
      },
      {
        label: 'Xã Thành Công',
        value: 'XA_THANH_CONG'
      },
      {
        label: 'Phường Vạn Xuân',
        value: 'PHUONG_VAN_XUAN'
      },
      {
        label: 'Phường Trung Thành',
        value: 'PHUONG_TRUNG_THANH'
      },
      {
        label: 'Xã Phú Bình',
        value: 'XA_PHU_BINH'
      },
      {
        label: 'Xã Tân Khánh',
        value: 'XA_TAN_KHANH'
      },
      {
        label: 'Xã Tân Thành',
        value: 'XA_TAN_THANH'
      },
      {
        label: 'Xã Điềm Thụy',
        value: 'XA_DIEM_THUY'
      },
      {
        label: 'Xã Kha Sơn',
        value: 'XA_KHA_SON'
      }
    ]
  },
  {
    label: 'Lạng Sơn',
    value: 'LANG_SON',
    children: [
      {
        label: 'Phường Đông Kinh',
        value: 'PHUONG_DONG_KINH'
      },
      {
        label: 'Phường Lương Văn Tri',
        value: 'PHUONG_LUONG_VAN_TRI'
      },
      {
        label: 'Phường Tam Thanh',
        value: 'PHUONG_TAM_THANH'
      },
      {
        label: 'Xã Đoàn Kết',
        value: 'XA_DOAN_KET'
      },
      {
        label: 'Xã Quốc Khánh',
        value: 'XA_QUOC_KHANH'
      },
      {
        label: 'Xã Tân Tiến',
        value: 'XA_TAN_TIEN'
      },
      {
        label: 'Xã Kháng Chiến',
        value: 'XA_KHANG_CHIEN'
      },
      {
        label: 'Xã Thất Khê',
        value: 'XA_THAT_KHE'
      },
      {
        label: 'Xã Tràng Định',
        value: 'XA_TRANG_DINH'
      },
      {
        label: 'Xã Quốc Việt',
        value: 'XA_QUOC_VIET'
      },
      {
        label: 'Xã Hoa Thám',
        value: 'XA_HOA_THAM'
      },
      {
        label: 'Xã Quý Hòa',
        value: 'XA_QUY_HOA'
      },
      {
        label: 'Xã Hồng Phong',
        value: 'XA_HONG_PHONG'
      },
      {
        label: 'Xã Thiện Hòa',
        value: 'XA_THIEN_HOA'
      },
      {
        label: 'Xã Thiện Thuật',
        value: 'XA_THIEN_THUAT'
      },
      {
        label: 'Xã Thiện Long',
        value: 'XA_THIEN_LONG'
      },
      {
        label: 'Xã Bình Gia',
        value: 'XA_BINH_GIA'
      },
      {
        label: 'Xã Tân Văn',
        value: 'XA_TAN_VAN'
      },
      {
        label: 'Xã Thụy Hùng',
        value: 'XA_THUY_HUNG'
      },
      {
        label: 'Xã Hội Hoan',
        value: 'XA_HOI_HOAN'
      },
      {
        label: 'Xã Văn Lãng',
        value: 'XA_VAN_LANG'
      },
      {
        label: 'Xã Tân Thanh',
        value: 'XA_TAN_THANH'
      },
      {
        label: 'Xã Đồng Đăng',
        value: 'XA_DONG_DANG'
      },
      {
        label: 'Phường Hoàng Văn Thụ',
        value: 'PHUONG_HOANG_VAN_THU'
      },
      {
        label: 'Xã Cao Lộc',
        value: 'XA_CAO_LOC'
      },
      {
        label: 'Xã Ba Sơn',
        value: 'XA_BA_SON'
      },
      {
        label: 'Xã Na Sầm',
        value: 'XA_NA_SAM'
      },
      {
        label: 'Xã Công Sơn',
        value: 'XA_CONG_SON'
      },
      {
        label: 'Xã Văn Quan',
        value: 'XA_VAN_QUAN'
      },
      {
        label: 'Xã Điềm He',
        value: 'XA_DIEM_HE'
      },
      {
        label: 'Xã Khánh Khê',
        value: 'XA_KHANH_KHE'
      },
      {
        label: 'Xã Yên Phúc',
        value: 'XA_YEN_PHUC'
      },
      {
        label: 'Xã Tri Lễ',
        value: 'XA_TRI_LE'
      },
      {
        label: 'Xã Tân Đoàn',
        value: 'XA_TAN_DOAN'
      },
      {
        label: 'Xã Bắc Sơn',
        value: 'XA_BAC_SON'
      },
      {
        label: 'Xã Tân Tri',
        value: 'XA_TAN_TRI'
      },
      {
        label: 'Xã Hưng Vũ',
        value: 'XA_HUNG_VU'
      },
      {
        label: 'Xã Vũ Lễ',
        value: 'XA_VU_LE'
      },
      {
        label: 'Xã Vũ Lăng',
        value: 'XA_VU_LANG'
      },
      {
        label: 'Xã Nhất Hòa',
        value: 'XA_NHAT_HOA'
      },
      {
        label: 'Xã Hữu Lũng',
        value: 'XA_HUU_LUNG'
      },
      {
        label: 'Xã Yên Bình',
        value: 'XA_YEN_BINH'
      },
      {
        label: 'Xã Hữu Liên',
        value: 'XA_HUU_LIEN'
      },
      {
        label: 'Xã Vân Nham',
        value: 'XA_VAN_NHAM'
      },
      {
        label: 'Xã Thiện Tân',
        value: 'XA_THIEN_TAN'
      },
      {
        label: 'Xã Cai Kinh',
        value: 'XA_CAI_KINH'
      },
      {
        label: 'Xã Tân Thành',
        value: 'XA_TAN_THANH'
      },
      {
        label: 'Xã Tuấn Sơn',
        value: 'XA_TUAN_SON'
      },
      {
        label: 'Xã Chi Lăng',
        value: 'XA_CHI_LANG'
      },
      {
        label: 'Xã Bằng Mạc',
        value: 'XA_BANG_MAC'
      },
      {
        label: 'Xã Chiến Thắng',
        value: 'XA_CHIEN_THANG'
      },
      {
        label: 'Xã Nhân Lý',
        value: 'XA_NHAN_LY'
      },
      {
        label: 'Xã Vạn Linh',
        value: 'XA_VAN_LINH'
      },
      {
        label: 'Xã Quan Sơn',
        value: 'XA_QUAN_SON'
      },
      {
        label: 'Xã Na Dương',
        value: 'XA_NA_DUONG'
      },
      {
        label: 'Xã Lộc Bình',
        value: 'XA_LOC_BINH'
      },
      {
        label: 'Xã Mẫu Sơn',
        value: 'XA_MAU_SON'
      },
      {
        label: 'Xã Khuất Xá',
        value: 'XA_KHUAT_XA'
      },
      {
        label: 'Xã Thống Nhất',
        value: 'XA_THONG_NHAT'
      },
      {
        label: 'Xã Lợi Bác',
        value: 'XA_LOI_BAC'
      },
      {
        label: 'Xã Xuân Dương',
        value: 'XA_XUAN_DUONG'
      },
      {
        label: 'Xã Đình Lập',
        value: 'XA_DINH_LAP'
      },
      {
        label: 'Xã Thái Bình',
        value: 'XA_THAI_BINH'
      },
      {
        label: 'Xã Kiên Mộc',
        value: 'XA_KIEN_MOC'
      },
      {
        label: 'Xã Châu Sơn',
        value: 'XA_CHAU_SON'
      }
    ]
  },
  {
    label: 'Quảng Ninh',
    value: 'QUANG_NINH',
    children: [
      {
        label: 'Phường Hà Tu',
        value: 'PHUONG_HA_TU'
      },
      {
        label: 'Phường Cao Xanh',
        value: 'PHUONG_CAO_XANH'
      },
      {
        label: 'Phường Việt Hưng',
        value: 'PHUONG_VIET_HUNG'
      },
      {
        label: 'Phường Bãi Cháy',
        value: 'PHUONG_BAI_CHAY'
      },
      {
        label: 'Phường Hà Lầm',
        value: 'PHUONG_HA_LAM'
      },
      {
        label: 'Phường Hồng Gai',
        value: 'PHUONG_HONG_GAI'
      },
      {
        label: 'Phường Hạ Long',
        value: 'PHUONG_HA_LONG'
      },
      {
        label: 'Phường Tuần Châu',
        value: 'PHUONG_TUAN_CHAU'
      },
      {
        label: 'Phường Móng Cái 2',
        value: 'PHUONG_MONG_CAI_2'
      },
      {
        label: 'Phường Móng Cái 1',
        value: 'PHUONG_MONG_CAI_1'
      },
      {
        label: 'Xã Hải Sơn',
        value: 'XA_HAI_SON'
      },
      {
        label: 'Xã Hải Ninh',
        value: 'XA_HAI_NINH'
      },
      {
        label: 'Phường Móng Cái 3',
        value: 'PHUONG_MONG_CAI_3'
      },
      {
        label: 'Xã Vĩnh Thực',
        value: 'XA_VINH_THUC'
      },
      {
        label: 'Phường Mông Dương',
        value: 'PHUONG_MONG_DUONG'
      },
      {
        label: 'Phường Quang Hanh',
        value: 'PHUONG_QUANG_HANH'
      },
      {
        label: 'Phường Cửa Ông',
        value: 'PHUONG_CUA_ONG'
      },
      {
        label: 'Phường Cẩm Phả',
        value: 'PHUONG_CAM_PHA'
      },
      {
        label: 'Xã Hải Hòa',
        value: 'XA_HAI_HOA'
      },
      {
        label: 'Phường Uông Bí',
        value: 'PHUONG_UONG_BI'
      },
      {
        label: 'Phường Vàng Danh',
        value: 'PHUONG_VANG_DANH'
      },
      {
        label: 'Phường Yên Tử',
        value: 'PHUONG_YEN_TU'
      },
      {
        label: 'Xã Bình Liêu',
        value: 'XA_BINH_LIEU'
      },
      {
        label: 'Xã Hoành Mô',
        value: 'XA_HOANH_MO'
      },
      {
        label: 'Xã Lục Hồn',
        value: 'XA_LUC_HON'
      },
      {
        label: 'Xã Tiên Yên',
        value: 'XA_TIEN_YEN'
      },
      {
        label: 'Xã Điền Xá',
        value: 'XA_DIEN_XA'
      },
      {
        label: 'Xã Đông Ngũ',
        value: 'XA_DONG_NGU'
      },
      {
        label: 'Xã Hải Lạng',
        value: 'XA_HAI_LANG'
      },
      {
        label: 'Xã Đầm Hà',
        value: 'XA_DAM_HA'
      },
      {
        label: 'Xã Quảng Tân',
        value: 'XA_QUANG_TAN'
      },
      {
        label: 'Xã Quảng Hà',
        value: 'XA_QUANG_HA'
      },
      {
        label: 'Xã Quảng Đức',
        value: 'XA_QUANG_DUC'
      },
      {
        label: 'Xã Đường Hoa',
        value: 'XA_DUONG_HOA'
      },
      {
        label: 'Xã Cái Chiên',
        value: 'XA_CAI_CHIEN'
      },
      {
        label: 'Xã Ba Chẽ',
        value: 'XA_BA_CHE'
      },
      {
        label: 'Xã Kỳ Thượng',
        value: 'XA_KY_THUONG'
      },
      {
        label: 'Xã Lương Minh',
        value: 'XA_LUONG_MINH'
      },
      {
        label: 'Đặc khu Vân Đồn',
        value: 'DAC_KHU_VAN_DON'
      },
      {
        label: 'Phường Hoành Bồ',
        value: 'PHUONG_HOANH_BO'
      },
      {
        label: 'Xã Quảng La',
        value: 'XA_QUANG_LA'
      },
      {
        label: 'Xã Thống Nhất',
        value: 'XA_THONG_NHAT'
      },
      {
        label: 'Phường Mạo Khê',
        value: 'PHUONG_MAO_KHE'
      },
      {
        label: 'Phường Bình Khê',
        value: 'PHUONG_BINH_KHE'
      },
      {
        label: 'Phường An Sinh',
        value: 'PHUONG_AN_SINH'
      },
      {
        label: 'Phường Đông Triều',
        value: 'PHUONG_DONG_TRIEU'
      },
      {
        label: 'Phường Hoàng Quế',
        value: 'PHUONG_HOANG_QUE'
      },
      {
        label: 'Phường Quảng Yên',
        value: 'PHUONG_QUANG_YEN'
      },
      {
        label: 'Phường Đông Mai',
        value: 'PHUONG_DONG_MAI'
      },
      {
        label: 'Phường Hiệp Hòa',
        value: 'PHUONG_HIEP_HOA'
      },
      {
        label: 'Phường Hà An',
        value: 'PHUONG_HA_AN'
      },
      {
        label: 'Phường Liên Hòa',
        value: 'PHUONG_LIEN_HOA'
      },
      {
        label: 'Phường Phong Cốc',
        value: 'PHUONG_PHONG_COC'
      },
      {
        label: 'Đặc khu Cô Tô',
        value: 'DAC_KHU_CO_TO'
      }
    ]
  },
  {
    label: 'Bắc Ninh',
    value: 'BAC_NINH',
    children: [
      {
        label: 'Phường Bắc Giang',
        value: 'PHUONG_BAC_GIANG'
      },
      {
        label: 'Phường Đa Mai',
        value: 'PHUONG_DA_MAI'
      },
      {
        label: 'Xã Xuân Lương',
        value: 'XA_XUAN_LUONG'
      },
      {
        label: 'Xã Tam Tiến',
        value: 'XA_TAM_TIEN'
      },
      {
        label: 'Xã Đồng Kỳ',
        value: 'XA_DONG_KY'
      },
      {
        label: 'Xã Yên Thế',
        value: 'XA_YEN_THE'
      },
      {
        label: 'Xã Bố Hạ',
        value: 'XA_BO_HA'
      },
      {
        label: 'Xã Nhã Nam',
        value: 'XA_NHA_NAM'
      },
      {
        label: 'Xã Phúc Hòa',
        value: 'XA_PHUC_HOA'
      },
      {
        label: 'Xã Quang Trung',
        value: 'XA_QUANG_TRUNG'
      },
      {
        label: 'Xã Tân Yên',
        value: 'XA_TAN_YEN'
      },
      {
        label: 'Xã Ngọc Thiện',
        value: 'XA_NGOC_THIEN'
      },
      {
        label: 'Xã Lạng Giang',
        value: 'XA_LANG_GIANG'
      },
      {
        label: 'Xã Tiên Lục',
        value: 'XA_TIEN_LUC'
      },
      {
        label: 'Xã Kép',
        value: 'XA_KEP'
      },
      {
        label: 'Xã Mỹ Thái',
        value: 'XA_MY_THAI'
      },
      {
        label: 'Xã Tân Dĩnh',
        value: 'XA_TAN_DINH'
      },
      {
        label: 'Xã Lục Nam',
        value: 'XA_LUC_NAM'
      },
      {
        label: 'Xã Đông Phú',
        value: 'XA_DONG_PHU'
      },
      {
        label: 'Xã Bảo Đài',
        value: 'XA_BAO_DAI'
      },
      {
        label: 'Xã Nghĩa Phương',
        value: 'XA_NGHIA_PHUONG'
      },
      {
        label: 'Xã Trường Sơn',
        value: 'XA_TRUONG_SON'
      },
      {
        label: 'Xã Lục Sơn',
        value: 'XA_LUC_SON'
      },
      {
        label: 'Xã Bắc Lũng',
        value: 'XA_BAC_LUNG'
      },
      {
        label: 'Xã Cẩm Lý',
        value: 'XA_CAM_LY'
      },
      {
        label: 'Phường Chũ',
        value: 'PHUONG_CHU'
      },
      {
        label: 'Xã Tân Sơn',
        value: 'XA_TAN_SON'
      },
      {
        label: 'Xã Sa Lý',
        value: 'XA_SA_LY'
      },
      {
        label: 'Xã Biên Sơn',
        value: 'XA_BIEN_SON'
      },
      {
        label: 'Xã Sơn Hải',
        value: 'XA_SON_HAI'
      },
      {
        label: 'Xã Kiên Lao',
        value: 'XA_KIEN_LAO'
      },
      {
        label: 'Xã Biển Động',
        value: 'XA_BIEN_DONG'
      },
      {
        label: 'Xã Lục Ngạn',
        value: 'XA_LUC_NGAN'
      },
      {
        label: 'Xã Đèo Gia',
        value: 'XA_DEO_GIA'
      },
      {
        label: 'Xã Nam Dương',
        value: 'XA_NAM_DUONG'
      },
      {
        label: 'Phường Phượng Sơn',
        value: 'PHUONG_PHUONG_SON'
      },
      {
        label: 'Xã Sơn Động',
        value: 'XA_SON_DONG'
      },
      {
        label: 'Xã Tây Yên Tử',
        value: 'XA_TAY_YEN_TU'
      },
      {
        label: 'Xã Vân Sơn',
        value: 'XA_VAN_SON'
      },
      {
        label: 'Xã Đại Sơn',
        value: 'XA_DAI_SON'
      },
      {
        label: 'Xã Yên Định',
        value: 'XA_YEN_DINH'
      },
      {
        label: 'Xã An Lạc',
        value: 'XA_AN_LAC'
      },
      {
        label: 'Xã Tuấn Đạo',
        value: 'XA_TUAN_DAO'
      },
      {
        label: 'Xã Dương Hưu',
        value: 'XA_DUONG_HUU'
      },
      {
        label: 'Phường Yên Dũng',
        value: 'PHUONG_YEN_DUNG'
      },
      {
        label: 'Phường Tân An',
        value: 'PHUONG_TAN_AN'
      },
      {
        label: 'Phường Tiền Phong',
        value: 'PHUONG_TIEN_PHONG'
      },
      {
        label: 'Phường Tân Tiến',
        value: 'PHUONG_TAN_TIEN'
      },
      {
        label: 'Xã Đồng Việt',
        value: 'XA_DONG_VIET'
      },
      {
        label: 'Phường Cảnh Thụy',
        value: 'PHUONG_CANH_THUY'
      },
      {
        label: 'Phường Tự Lạn',
        value: 'PHUONG_TU_LAN'
      },
      {
        label: 'Phường Việt Yên',
        value: 'PHUONG_VIET_YEN'
      },
      {
        label: 'Phường Nếnh',
        value: 'PHUONG_NENH'
      },
      {
        label: 'Phường Vân Hà',
        value: 'PHUONG_VAN_HA'
      },
      {
        label: 'Xã Hoàng Vân',
        value: 'XA_HOANG_VAN'
      },
      {
        label: 'Xã Hiệp Hoà',
        value: 'XA_HIEP_HOA'
      },
      {
        label: 'Xã Hợp Thịnh',
        value: 'XA_HOP_THINH'
      },
      {
        label: 'Xã Xuân Cẩm',
        value: 'XA_XUAN_CAM'
      },
      {
        label: 'Phường Vũ Ninh',
        value: 'PHUONG_VU_NINH'
      },
      {
        label: 'Phường Kinh Bắc',
        value: 'PHUONG_KINH_BAC'
      },
      {
        label: 'Phường Võ Cường',
        value: 'PHUONG_VO_CUONG'
      },
      {
        label: 'Xã Yên Phong',
        value: 'XA_YEN_PHONG'
      },
      {
        label: 'Xã Tam Giang',
        value: 'XA_TAM_GIANG'
      },
      {
        label: 'Xã Yên Trung',
        value: 'XA_YEN_TRUNG'
      },
      {
        label: 'Xã Tam Đa',
        value: 'XA_TAM_DA'
      },
      {
        label: 'Xã Văn Môn',
        value: 'XA_VAN_MON'
      },
      {
        label: 'Phường Quế Võ',
        value: 'PHUONG_QUE_VO'
      },
      {
        label: 'Phường Nhân Hòa',
        value: 'PHUONG_NHAN_HOA'
      },
      {
        label: 'Phường Phương Liễu',
        value: 'PHUONG_PHUONG_LIEU'
      },
      {
        label: 'Phường Nam Sơn',
        value: 'PHUONG_NAM_SON'
      },
      {
        label: 'Xã Phù Lãng',
        value: 'XA_PHU_LANG'
      },
      {
        label: 'Phường Bồng Lai',
        value: 'PHUONG_BONG_LAI'
      },
      {
        label: 'Phường Đào Viên',
        value: 'PHUONG_DAO_VIEN'
      },
      {
        label: 'Xã Chi Lăng',
        value: 'XA_CHI_LANG'
      },
      {
        label: 'Xã Tiên Du',
        value: 'XA_TIEN_DU'
      },
      {
        label: 'Phường Hạp Lĩnh',
        value: 'PHUONG_HAP_LINH'
      },
      {
        label: 'Xã Liên Bão',
        value: 'XA_LIEN_BAO'
      },
      {
        label: 'Xã Đại Đồng',
        value: 'XA_DAI_DONG'
      },
      {
        label: 'Xã Tân Chi',
        value: 'XA_TAN_CHI'
      },
      {
        label: 'Xã Phật Tích',
        value: 'XA_PHAT_TICH'
      },
      {
        label: 'Phường Từ Sơn',
        value: 'PHUONG_TU_SON'
      },
      {
        label: 'Phường Phù Khê',
        value: 'PHUONG_PHU_KHE'
      },
      {
        label: 'Phường Tam Sơn',
        value: 'PHUONG_TAM_SON'
      },
      {
        label: 'Phường Đồng Nguyên',
        value: 'PHUONG_DONG_NGUYEN'
      },
      {
        label: 'Phường Thuận Thành',
        value: 'PHUONG_THUAN_THANH'
      },
      {
        label: 'Phường Mão Điền',
        value: 'PHUONG_MAO_DIEN'
      },
      {
        label: 'Phường Trí Quả',
        value: 'PHUONG_TRI_QUA'
      },
      {
        label: 'Phường Trạm Lộ',
        value: 'PHUONG_TRAM_LO'
      },
      {
        label: 'Phường Song Liễu',
        value: 'PHUONG_SONG_LIEU'
      },
      {
        label: 'Phường Ninh Xá',
        value: 'PHUONG_NINH_XA'
      },
      {
        label: 'Xã Gia Bình',
        value: 'XA_GIA_BINH'
      },
      {
        label: 'Xã Cao Đức',
        value: 'XA_CAO_DUC'
      },
      {
        label: 'Xã Đại Lai',
        value: 'XA_DAI_LAI'
      },
      {
        label: 'Xã Nhân Thắng',
        value: 'XA_NHAN_THANG'
      },
      {
        label: 'Xã Đông Cứu',
        value: 'XA_DONG_CUU'
      },
      {
        label: 'Xã Lương Tài',
        value: 'XA_LUONG_TAI'
      },
      {
        label: 'Xã Trung Kênh',
        value: 'XA_TRUNG_KENH'
      },
      {
        label: 'Xã Trung Chính',
        value: 'XA_TRUNG_CHINH'
      },
      {
        label: 'Xã Lâm Thao',
        value: 'XA_LAM_THAO'
      }
    ]
  },
  {
    label: 'Phú Thọ',
    value: 'PHU_THO',
    children: [
      {
        label: 'Phường Tân Hòa',
        value: 'PHUONG_TAN_HOA'
      },
      {
        label: 'Phường Hòa Bình',
        value: 'PHUONG_HOA_BINH'
      },
      {
        label: 'Phường Thống Nhất',
        value: 'PHUONG_THONG_NHAT'
      },
      {
        label: 'Xã Đà Bắc',
        value: 'XA_DA_BAC'
      },
      {
        label: 'Xã Đức Nhàn',
        value: 'XA_DUC_NHAN'
      },
      {
        label: 'Xã Tân Pheo',
        value: 'XA_TAN_PHEO'
      },
      {
        label: 'Xã Quy Đức',
        value: 'XA_QUY_DUC'
      },
      {
        label: 'Xã Cao Sơn',
        value: 'XA_CAO_SON'
      },
      {
        label: 'Xã Tiền Phong',
        value: 'XA_TIEN_PHONG'
      },
      {
        label: 'Phường Kỳ Sơn',
        value: 'PHUONG_KY_SON'
      },
      {
        label: 'Xã Thịnh Minh',
        value: 'XA_THINH_MINH'
      },
      {
        label: 'Xã Lương Sơn',
        value: 'XA_LUONG_SON'
      },
      {
        label: 'Xã Liên Sơn',
        value: 'XA_LIEN_SON'
      },
      {
        label: 'Xã Kim Bôi',
        value: 'XA_KIM_BOI'
      },
      {
        label: 'Xã Nật Sơn',
        value: 'XA_NAT_SON'
      },
      {
        label: 'Xã Mường Động',
        value: 'XA_MUONG_DONG'
      },
      {
        label: 'Xã Cao Dương',
        value: 'XA_CAO_DUONG'
      },
      {
        label: 'Xã Hợp Kim',
        value: 'XA_HOP_KIM'
      },
      {
        label: 'Xã Dũng Tiến',
        value: 'XA_DUNG_TIEN'
      },
      {
        label: 'Xã Cao Phong',
        value: 'XA_CAO_PHONG'
      },
      {
        label: 'Xã Thung Nai',
        value: 'XA_THUNG_NAI'
      },
      {
        label: 'Xã Mường Thàng',
        value: 'XA_MUONG_THANG'
      },
      {
        label: 'Xã Tân Lạc',
        value: 'XA_TAN_LAC'
      },
      {
        label: 'Xã Mường Hoa',
        value: 'XA_MUONG_HOA'
      },
      {
        label: 'Xã Vân Sơn',
        value: 'XA_VAN_SON'
      },
      {
        label: 'Xã Mường Bi',
        value: 'XA_MUONG_BI'
      },
      {
        label: 'Xã Toàn Thắng',
        value: 'XA_TOAN_THANG'
      },
      {
        label: 'Xã Mai Châu',
        value: 'XA_MAI_CHAU'
      },
      {
        label: 'Xã Tân Mai',
        value: 'XA_TAN_MAI'
      },
      {
        label: 'Xã Pà Cò',
        value: 'XA_PA_CO'
      },
      {
        label: 'Xã Bao La',
        value: 'XA_BAO_LA'
      },
      {
        label: 'Xã Mai Hạ',
        value: 'XA_MAI_HA'
      },
      {
        label: 'Xã Lạc Sơn',
        value: 'XA_LAC_SON'
      },
      {
        label: 'Xã Mường Vang',
        value: 'XA_MUONG_VANG'
      },
      {
        label: 'Xã Nhân Nghĩa',
        value: 'XA_NHAN_NGHIA'
      },
      {
        label: 'Xã Thượng Cốc',
        value: 'XA_THUONG_COC'
      },
      {
        label: 'Xã Yên Phú',
        value: 'XA_YEN_PHU'
      },
      {
        label: 'Xã Quyết Thắng',
        value: 'XA_QUYET_THANG'
      },
      {
        label: 'Xã Ngọc Sơn',
        value: 'XA_NGOC_SON'
      },
      {
        label: 'Xã Đại Đồng',
        value: 'XA_DAI_DONG'
      },
      {
        label: 'Xã Yên Thủy',
        value: 'XA_YEN_THUY'
      },
      {
        label: 'Xã Lạc Lương',
        value: 'XA_LAC_LUONG'
      },
      {
        label: 'Xã Yên Trị',
        value: 'XA_YEN_TRI'
      },
      {
        label: 'Xã Lạc Thủy',
        value: 'XA_LAC_THUY'
      },
      {
        label: 'Xã An Nghĩa',
        value: 'XA_AN_NGHIA'
      },
      {
        label: 'Xã An Bình',
        value: 'XA_AN_BINH'
      },
      {
        label: 'Phường Nông Trang',
        value: 'PHUONG_NONG_TRANG'
      },
      {
        label: 'Phường Việt Trì',
        value: 'PHUONG_VIET_TRI'
      },
      {
        label: 'Phường Thanh Miếu',
        value: 'PHUONG_THANH_MIEU'
      },
      {
        label: 'Phường Vân Phú',
        value: 'PHUONG_VAN_PHU'
      },
      {
        label: 'Phường Phú Thọ',
        value: 'PHUONG_PHU_THO'
      },
      {
        label: 'Phường Âu Cơ',
        value: 'PHUONG_AU_CO'
      },
      {
        label: 'Phường Phong Châu',
        value: 'PHUONG_PHONG_CHAU'
      },
      {
        label: 'Xã Đoan Hùng',
        value: 'XA_DOAN_HUNG'
      },
      {
        label: 'Xã Bằng Luân',
        value: 'XA_BANG_LUAN'
      },
      {
        label: 'Xã Chí Đám',
        value: 'XA_CHI_DAM'
      },
      {
        label: 'Xã Tây Cốc',
        value: 'XA_TAY_COC'
      },
      {
        label: 'Xã Chân Mộng',
        value: 'XA_CHAN_MONG'
      },
      {
        label: 'Xã Hạ Hòa',
        value: 'XA_HA_HOA'
      },
      {
        label: 'Xã Đan Thượng',
        value: 'XA_DAN_THUONG'
      },
      {
        label: 'Xã Hiền Lương',
        value: 'XA_HIEN_LUONG'
      },
      {
        label: 'Xã Yên Kỳ',
        value: 'XA_YEN_KY'
      },
      {
        label: 'Xã Văn Lang',
        value: 'XA_VAN_LANG'
      },
      {
        label: 'Xã Vĩnh Chân',
        value: 'XA_VINH_CHAN'
      },
      {
        label: 'Xã Thanh Ba',
        value: 'XA_THANH_BA'
      },
      {
        label: 'Xã Quảng Yên',
        value: 'XA_QUANG_YEN'
      },
      {
        label: 'Xã Hoàng Cương',
        value: 'XA_HOANG_CUONG'
      },
      {
        label: 'Xã Đông Thành',
        value: 'XA_DONG_THANH'
      },
      {
        label: 'Xã Chí Tiên',
        value: 'XA_CHI_TIEN'
      },
      {
        label: 'Xã Liên Minh',
        value: 'XA_LIEN_MINH'
      },
      {
        label: 'Xã Phù Ninh',
        value: 'XA_PHU_NINH'
      },
      {
        label: 'Xã Phú Mỹ',
        value: 'XA_PHU_MY'
      },
      {
        label: 'Xã Trạm Thản',
        value: 'XA_TRAM_THAN'
      },
      {
        label: 'Xã Dân Chủ',
        value: 'XA_DAN_CHU'
      },
      {
        label: 'Xã Bình Phú',
        value: 'XA_BINH_PHU'
      },
      {
        label: 'Xã Yên Lập',
        value: 'XA_YEN_LAP'
      },
      {
        label: 'Xã Sơn Lương',
        value: 'XA_SON_LUONG'
      },
      {
        label: 'Xã Xuân Viên',
        value: 'XA_XUAN_VIEN'
      },
      {
        label: 'Xã Trung Sơn',
        value: 'XA_TRUNG_SON'
      },
      {
        label: 'Xã Thượng Long',
        value: 'XA_THUONG_LONG'
      },
      {
        label: 'Xã Minh Hòa',
        value: 'XA_MINH_HOA'
      },
      {
        label: 'Xã Cẩm Khê',
        value: 'XA_CAM_KHE'
      },
      {
        label: 'Xã Tiên Lương',
        value: 'XA_TIEN_LUONG'
      },
      {
        label: 'Xã Vân Bán',
        value: 'XA_VAN_BAN'
      },
      {
        label: 'Xã Phú Khê',
        value: 'XA_PHU_KHE'
      },
      {
        label: 'Xã Hùng Việt',
        value: 'XA_HUNG_VIET'
      },
      {
        label: 'Xã Đồng Lương',
        value: 'XA_DONG_LUONG'
      },
      {
        label: 'Xã Tam Nông',
        value: 'XA_TAM_NONG'
      },
      {
        label: 'Xã Hiền Quan',
        value: 'XA_HIEN_QUAN'
      },
      {
        label: 'Xã Vạn Xuân',
        value: 'XA_VAN_XUAN'
      },
      {
        label: 'Xã Thọ Văn',
        value: 'XA_THO_VAN'
      },
      {
        label: 'Xã Lâm Thao',
        value: 'XA_LAM_THAO'
      },
      {
        label: 'Xã Xuân Lũng',
        value: 'XA_XUAN_LUNG'
      },
      {
        label: 'Xã Hy Cương',
        value: 'XA_HY_CUONG'
      },
      {
        label: 'Xã Phùng Nguyên',
        value: 'XA_PHUNG_NGUYEN'
      },
      {
        label: 'Xã Bản Nguyên',
        value: 'XA_BAN_NGUYEN'
      },
      {
        label: 'Xã Thanh Sơn',
        value: 'XA_THANH_SON'
      },
      {
        label: 'Xã Thu Cúc',
        value: 'XA_THU_CUC'
      },
      {
        label: 'Xã Lai Đồng',
        value: 'XA_LAI_DONG'
      },
      {
        label: 'Xã Tân Sơn',
        value: 'XA_TAN_SON'
      },
      {
        label: 'Xã Võ Miếu',
        value: 'XA_VO_MIEU'
      },
      {
        label: 'Xã Xuân Đài',
        value: 'XA_XUAN_DAI'
      },
      {
        label: 'Xã Minh Đài',
        value: 'XA_MINH_DAI'
      },
      {
        label: 'Xã Văn Miếu',
        value: 'XA_VAN_MIEU'
      },
      {
        label: 'Xã Cự Đồng',
        value: 'XA_CU_DONG'
      },
      {
        label: 'Xã Long Cốc',
        value: 'XA_LONG_COC'
      },
      {
        label: 'Xã Hương Cần',
        value: 'XA_HUONG_CAN'
      },
      {
        label: 'Xã Khả Cửu',
        value: 'XA_KHA_CUU'
      },
      {
        label: 'Xã Yên Sơn',
        value: 'XA_YEN_SON'
      },
      {
        label: 'Xã Đào Xá',
        value: 'XA_DAO_XA'
      },
      {
        label: 'Xã Thanh Thuỷ',
        value: 'XA_THANH_THUY'
      },
      {
        label: 'Xã Tu Vũ',
        value: 'XA_TU_VU'
      },
      {
        label: 'Phường Vĩnh Yên',
        value: 'PHUONG_VINH_YEN'
      },
      {
        label: 'Phường Vĩnh Phúc',
        value: 'PHUONG_VINH_PHUC'
      },
      {
        label: 'Phường Phúc Yên',
        value: 'PHUONG_PHUC_YEN'
      },
      {
        label: 'Phường Xuân Hòa',
        value: 'PHUONG_XUAN_HOA'
      },
      {
        label: 'Xã Lập Thạch',
        value: 'XA_LAP_THACH'
      },
      {
        label: 'Xã Hợp Lý',
        value: 'XA_HOP_LY'
      },
      {
        label: 'Xã Yên Lãng',
        value: 'XA_YEN_LANG'
      },
      {
        label: 'Xã Hải Lựu',
        value: 'XA_HAI_LUU'
      },
      {
        label: 'Xã Thái Hòa',
        value: 'XA_THAI_HOA'
      },
      {
        label: 'Xã Liên Hòa',
        value: 'XA_LIEN_HOA'
      },
      {
        label: 'Xã Tam Sơn',
        value: 'XA_TAM_SON'
      },
      {
        label: 'Xã Tiên Lữ',
        value: 'XA_TIEN_LU'
      },
      {
        label: 'Xã Sông Lô',
        value: 'XA_SONG_LO'
      },
      {
        label: 'Xã Sơn Đông',
        value: 'XA_SON_DONG'
      },
      {
        label: 'Xã Tam Dương',
        value: 'XA_TAM_DUONG'
      },
      {
        label: 'Xã Tam Dương Bắc',
        value: 'XA_TAM_DUONG_BAC'
      },
      {
        label: 'Xã Hoàng An',
        value: 'XA_HOANG_AN'
      },
      {
        label: 'Xã Hội Thịnh',
        value: 'XA_HOI_THINH'
      },
      {
        label: 'Xã Tam Đảo',
        value: 'XA_TAM_DAO'
      },
      {
        label: 'Xã Đạo Trù',
        value: 'XA_DAO_TRU'
      },
      {
        label: 'Xã Đại Đình',
        value: 'XA_DAI_DINH'
      },
      {
        label: 'Xã Bình Nguyên',
        value: 'XA_BINH_NGUYEN'
      },
      {
        label: 'Xã Bình Tuyền',
        value: 'XA_BINH_TUYEN'
      },
      {
        label: 'Xã Bình Xuyên',
        value: 'XA_BINH_XUYEN'
      },
      {
        label: 'Xã Xuân Lãng',
        value: 'XA_XUAN_LANG'
      },
      {
        label: 'Xã Yên Lạc',
        value: 'XA_YEN_LAC'
      },
      {
        label: 'Xã Tề Lỗ',
        value: 'XA_TE_LO'
      },
      {
        label: 'Xã Tam Hồng',
        value: 'XA_TAM_HONG'
      },
      {
        label: 'Xã Nguyệt Đức',
        value: 'XA_NGUYET_DUC'
      },
      {
        label: 'Xã Liên Châu',
        value: 'XA_LIEN_CHAU'
      },
      {
        label: 'Xã Vĩnh Tường',
        value: 'XA_VINH_TUONG'
      },
      {
        label: 'Xã Vĩnh An',
        value: 'XA_VINH_AN'
      },
      {
        label: 'Xã Vĩnh Hưng',
        value: 'XA_VINH_HUNG'
      },
      {
        label: 'Xã Vĩnh Thành',
        value: 'XA_VINH_THANH'
      },
      {
        label: 'Xã Thổ Tang',
        value: 'XA_THO_TANG'
      },
      {
        label: 'Xã Vĩnh Phú',
        value: 'XA_VINH_PHU'
      }
    ]
  },
  {
    label: 'Thành phố Hải Phòng',
    value: 'THANH_PHO_HAI_PHONG',
    children: [
      {
        label: 'Phường Thành Đông',
        value: 'PHUONG_THANH_DONG'
      },
      {
        label: 'Phường Hải Dương',
        value: 'PHUONG_HAI_DUONG'
      },
      {
        label: 'Phường Lê Thanh Nghị',
        value: 'PHUONG_LE_THANH_NGHI'
      },
      {
        label: 'Phường Tân Hưng',
        value: 'PHUONG_TAN_HUNG'
      },
      {
        label: 'Phường Tứ Minh',
        value: 'PHUONG_TU_MINH'
      },
      {
        label: 'Phường Việt Hòa',
        value: 'PHUONG_VIET_HOA'
      },
      {
        label: 'Phường Chí Linh',
        value: 'PHUONG_CHI_LINH'
      },
      {
        label: 'Phường Chu Văn An',
        value: 'PHUONG_CHU_VAN_AN'
      },
      {
        label: 'Phường Nguyễn Trãi',
        value: 'PHUONG_NGUYEN_TRAI'
      },
      {
        label: 'Phường Trần Hưng Đạo',
        value: 'PHUONG_TRAN_HUNG_DAO'
      },
      {
        label: 'Phường Trần Nhân Tông',
        value: 'PHUONG_TRAN_NHAN_TONG'
      },
      {
        label: 'Phường Lê Đại Hành',
        value: 'PHUONG_LE_DAI_HANH'
      },
      {
        label: 'Xã Nam Sách',
        value: 'XA_NAM_SACH'
      },
      {
        label: 'Xã Hợp Tiến',
        value: 'XA_HOP_TIEN'
      },
      {
        label: 'Xã Trần Phú',
        value: 'XA_TRAN_PHU'
      },
      {
        label: 'Xã Thái Tân',
        value: 'XA_THAI_TAN'
      },
      {
        label: 'Xã An Phú',
        value: 'XA_AN_PHU'
      },
      {
        label: 'Phường Ái Quốc',
        value: 'PHUONG_AI_QUOC'
      },
      {
        label: 'Phường Nam Đồng',
        value: 'PHUONG_NAM_DONG'
      },
      {
        label: 'Phường Kinh Môn',
        value: 'PHUONG_KINH_MON'
      },
      {
        label: 'Phường Bắc An Phụ',
        value: 'PHUONG_BAC_AN_PHU'
      },
      {
        label: 'Xã Nam An Phụ',
        value: 'XA_NAM_AN_PHU'
      },
      {
        label: 'Phường Nhị Chiểu',
        value: 'PHUONG_NHI_CHIEU'
      },
      {
        label: 'Phường Phạm Sư Mạnh',
        value: 'PHUONG_PHAM_SU_MANH'
      },
      {
        label: 'Phường Trần Liễu',
        value: 'PHUONG_TRAN_LIEU'
      },
      {
        label: 'Phường Nguyễn Đại Năng',
        value: 'PHUONG_NGUYEN_DAI_NANG'
      },
      {
        label: 'Xã Phú Thái',
        value: 'XA_PHU_THAI'
      },
      {
        label: 'Xã Lai Khê',
        value: 'XA_LAI_KHE'
      },
      {
        label: 'Xã An Thành',
        value: 'XA_AN_THANH'
      },
      {
        label: 'Xã Kim Thành',
        value: 'XA_KIM_THANH'
      },
      {
        label: 'Xã Thanh Hà',
        value: 'XA_THANH_HA'
      },
      {
        label: 'Xã Hà Bắc',
        value: 'XA_HA_BAC'
      },
      {
        label: 'Xã Hà Nam',
        value: 'XA_HA_NAM'
      },
      {
        label: 'Xã Hà Tây',
        value: 'XA_HA_TAY'
      },
      {
        label: 'Xã Hà Đông',
        value: 'XA_HA_DONG'
      },
      {
        label: 'Xã Cẩm Giang',
        value: 'XA_CAM_GIANG'
      },
      {
        label: 'Xã Cẩm Giàng',
        value: 'XA_CAM_GIANG'
      },
      {
        label: 'Xã Tuệ Tĩnh',
        value: 'XA_TUE_TINH'
      },
      {
        label: 'Xã Mao Điền',
        value: 'XA_MAO_DIEN'
      },
      {
        label: 'Xã Kẻ Sặt',
        value: 'XA_KE_SAT'
      },
      {
        label: 'Xã Bình Giang',
        value: 'XA_BINH_GIANG'
      },
      {
        label: 'Xã Đường An',
        value: 'XA_DUONG_AN'
      },
      {
        label: 'Xã Thượng Hồng',
        value: 'XA_THUONG_HONG'
      },
      {
        label: 'Xã Gia Lộc',
        value: 'XA_GIA_LOC'
      },
      {
        label: 'Phường Thạch Khôi',
        value: 'PHUONG_THACH_KHOI'
      },
      {
        label: 'Xã Yết Kiêu',
        value: 'XA_YET_KIEU'
      },
      {
        label: 'Xã Gia Phúc',
        value: 'XA_GIA_PHUC'
      },
      {
        label: 'Xã Trường Tân',
        value: 'XA_TRUONG_TAN'
      },
      {
        label: 'Xã Tứ Kỳ',
        value: 'XA_TU_KY'
      },
      {
        label: 'Xã Đại Sơn',
        value: 'XA_DAI_SON'
      },
      {
        label: 'Xã Tân Kỳ',
        value: 'XA_TAN_KY'
      },
      {
        label: 'Xã Chí Minh',
        value: 'XA_CHI_MINH'
      },
      {
        label: 'Xã Lạc Phượng',
        value: 'XA_LAC_PHUONG'
      },
      {
        label: 'Xã Nguyên Giáp',
        value: 'XA_NGUYEN_GIAP'
      },
      {
        label: 'Xã Vĩnh Lại',
        value: 'XA_VINH_LAI'
      },
      {
        label: 'Xã Tân An',
        value: 'XA_TAN_AN'
      },
      {
        label: 'Xã Ninh Giang',
        value: 'XA_NINH_GIANG'
      },
      {
        label: 'Xã Hồng Châu',
        value: 'XA_HONG_CHAU'
      },
      {
        label: 'Xã Khúc Thừa Dụ',
        value: 'XA_KHUC_THUA_DU'
      },
      {
        label: 'Xã Thanh Miện',
        value: 'XA_THANH_MIEN'
      },
      {
        label: 'Xã Nguyễn Lương Bằng',
        value: 'XA_NGUYEN_LUONG_BANG'
      },
      {
        label: 'Xã Bắc Thanh Miện',
        value: 'XA_BAC_THANH_MIEN'
      },
      {
        label: 'Xã Hải Hưng',
        value: 'XA_HAI_HUNG'
      },
      {
        label: 'Xã Nam Thanh Miện',
        value: 'XA_NAM_THANH_MIEN'
      },
      {
        label: 'Phường Hồng Bàng',
        value: 'PHUONG_HONG_BANG'
      },
      {
        label: 'Phường Ngô Quyền',
        value: 'PHUONG_NGO_QUYEN'
      },
      {
        label: 'Phường Gia Viên',
        value: 'PHUONG_GIA_VIEN'
      },
      {
        label: 'Phường Lê Chân',
        value: 'PHUONG_LE_CHAN'
      },
      {
        label: 'Phường An Biên',
        value: 'PHUONG_AN_BIEN'
      },
      {
        label: 'Phường Đông Hải',
        value: 'PHUONG_DONG_HAI'
      },
      {
        label: 'Phường Hải An',
        value: 'PHUONG_HAI_AN'
      },
      {
        label: 'Phường Kiến An',
        value: 'PHUONG_KIEN_AN'
      },
      {
        label: 'Phường Phù Liễn',
        value: 'PHUONG_PHU_LIEN'
      },
      {
        label: 'Phường Đồ Sơn',
        value: 'PHUONG_DO_SON'
      },
      {
        label: 'Phường Bạch Đằng',
        value: 'PHUONG_BACH_DANG'
      },
      {
        label: 'Phường Lưu Kiếm',
        value: 'PHUONG_LUU_KIEM'
      },
      {
        label: 'Xã Việt Khê',
        value: 'XA_VIET_KHE'
      },
      {
        label: 'Phường Lê Ích Mộc',
        value: 'PHUONG_LE_ICH_MOC'
      },
      {
        label: 'Phường Hoà Bình',
        value: 'PHUONG_HOA_BINH'
      },
      {
        label: 'Phường Nam Triệu',
        value: 'PHUONG_NAM_TRIEU'
      },
      {
        label: 'Phường Thiên Hương',
        value: 'PHUONG_THIEN_HUONG'
      },
      {
        label: 'Phường Thuỷ Nguyên',
        value: 'PHUONG_THUY_NGUYEN'
      },
      {
        label: 'Phường An Dương',
        value: 'PHUONG_AN_DUONG'
      },
      {
        label: 'Phường An Phong',
        value: 'PHUONG_AN_PHONG'
      },
      {
        label: 'Phường Hồng An',
        value: 'PHUONG_HONG_AN'
      },
      {
        label: 'Phường An Hải',
        value: 'PHUONG_AN_HAI'
      },
      {
        label: 'Xã An Lão',
        value: 'XA_AN_LAO'
      },
      {
        label: 'Xã An Trường',
        value: 'XA_AN_TRUONG'
      },
      {
        label: 'Xã An Quang',
        value: 'XA_AN_QUANG'
      },
      {
        label: 'Xã An Khánh',
        value: 'XA_AN_KHANH'
      },
      {
        label: 'Xã An Hưng',
        value: 'XA_AN_HUNG'
      },
      {
        label: 'Xã Kiến Thụy',
        value: 'XA_KIEN_THUY'
      },
      {
        label: 'Phường Hưng Đạo',
        value: 'PHUONG_HUNG_DAO'
      },
      {
        label: 'Phường Dương Kinh',
        value: 'PHUONG_DUONG_KINH'
      },
      {
        label: 'Xã Nghi Dương',
        value: 'XA_NGHI_DUONG'
      },
      {
        label: 'Xã Kiến Minh',
        value: 'XA_KIEN_MINH'
      },
      {
        label: 'Xã Kiến Hưng',
        value: 'XA_KIEN_HUNG'
      },
      {
        label: 'Phường Nam Đồ Sơn',
        value: 'PHUONG_NAM_DO_SON'
      },
      {
        label: 'Xã Kiến Hải',
        value: 'XA_KIEN_HAI'
      },
      {
        label: 'Xã Tiên Lãng',
        value: 'XA_TIEN_LANG'
      },
      {
        label: 'Xã Quyết Thắng',
        value: 'XA_QUYET_THANG'
      },
      {
        label: 'Xã Tân Minh',
        value: 'XA_TAN_MINH'
      },
      {
        label: 'Xã Tiên Minh',
        value: 'XA_TIEN_MINH'
      },
      {
        label: 'Xã Chấn Hưng',
        value: 'XA_CHAN_HUNG'
      },
      {
        label: 'Xã Hùng Thắng',
        value: 'XA_HUNG_THANG'
      },
      {
        label: 'Xã Vĩnh Bảo',
        value: 'XA_VINH_BAO'
      },
      {
        label: 'Xã Vĩnh Thịnh',
        value: 'XA_VINH_THINH'
      },
      {
        label: 'Xã Vĩnh Thuận',
        value: 'XA_VINH_THUAN'
      },
      {
        label: 'Xã Vĩnh Hòa',
        value: 'XA_VINH_HOA'
      },
      {
        label: 'Xã Vĩnh Hải',
        value: 'XA_VINH_HAI'
      },
      {
        label: 'Xã Vĩnh Am',
        value: 'XA_VINH_AM'
      },
      {
        label: 'Xã Nguyễn Bỉnh Khiêm',
        value: 'XA_NGUYEN_BINH_KHIEM'
      },
      {
        label: 'Đặc khu Cát Hải',
        value: 'DAC_KHU_CAT_HAI'
      },
      {
        label: 'Đặc khu Bạch Long Vĩ',
        value: 'DAC_KHU_BACH_LONG_VI'
      }
    ]
  },
  {
    label: 'Hưng Yên',
    value: 'HUNG_YEN',
    children: [
      {
        label: 'Phường Phố Hiến',
        value: 'PHUONG_PHO_HIEN'
      },
      {
        label: 'Xã Tân Hưng',
        value: 'XA_TAN_HUNG'
      },
      {
        label: 'Phường Hồng Châu',
        value: 'PHUONG_HONG_CHAU'
      },
      {
        label: 'Phường Sơn Nam',
        value: 'PHUONG_SON_NAM'
      },
      {
        label: 'Xã Như Quỳnh',
        value: 'XA_NHU_QUYNH'
      },
      {
        label: 'Xã Lạc Đạo',
        value: 'XA_LAC_DAO'
      },
      {
        label: 'Xã Đại Đồng',
        value: 'XA_DAI_DONG'
      },
      {
        label: 'Xã Văn Giang',
        value: 'XA_VAN_GIANG'
      },
      {
        label: 'Xã Phụng Công',
        value: 'XA_PHUNG_CONG'
      },
      {
        label: 'Xã Nghĩa Trụ',
        value: 'XA_NGHIA_TRU'
      },
      {
        label: 'Xã Mễ Sở',
        value: 'XA_ME_SO'
      },
      {
        label: 'Xã Yên Mỹ',
        value: 'XA_YEN_MY'
      },
      {
        label: 'Xã Nguyễn Văn Linh',
        value: 'XA_NGUYEN_VAN_LINH'
      },
      {
        label: 'Xã Hoàn Long',
        value: 'XA_HOAN_LONG'
      },
      {
        label: 'Xã Việt Yên',
        value: 'XA_VIET_YEN'
      },
      {
        label: 'Phường Mỹ Hào',
        value: 'PHUONG_MY_HAO'
      },
      {
        label: 'Phường Thượng Hồng',
        value: 'PHUONG_THUONG_HONG'
      },
      {
        label: 'Phường Đường Hào',
        value: 'PHUONG_DUONG_HAO'
      },
      {
        label: 'Xã Ân Thi',
        value: 'XA_AN_THI'
      },
      {
        label: 'Xã Phạm Ngũ Lão',
        value: 'XA_PHAM_NGU_LAO'
      },
      {
        label: 'Xã Xuân Trúc',
        value: 'XA_XUAN_TRUC'
      },
      {
        label: 'Xã Nguyễn Trãi',
        value: 'XA_NGUYEN_TRAI'
      },
      {
        label: 'Xã Hồng Quang',
        value: 'XA_HONG_QUANG'
      },
      {
        label: 'Xã Khoái Châu',
        value: 'XA_KHOAI_CHAU'
      },
      {
        label: 'Xã Triệu Việt Vương',
        value: 'XA_TRIEU_VIET_VUONG'
      },
      {
        label: 'Xã Việt Tiến',
        value: 'XA_VIET_TIEN'
      },
      {
        label: 'Xã Châu Ninh',
        value: 'XA_CHAU_NINH'
      },
      {
        label: 'Xã Chí Minh',
        value: 'XA_CHI_MINH'
      },
      {
        label: 'Xã Lương Bằng',
        value: 'XA_LUONG_BANG'
      },
      {
        label: 'Xã Nghĩa Dân',
        value: 'XA_NGHIA_DAN'
      },
      {
        label: 'Xã Đức Hợp',
        value: 'XA_DUC_HOP'
      },
      {
        label: 'Xã Hiệp Cường',
        value: 'XA_HIEP_CUONG'
      },
      {
        label: 'Xã Hoàng Hoa Thám',
        value: 'XA_HOANG_HOA_THAM'
      },
      {
        label: 'Xã Tiên Hoa',
        value: 'XA_TIEN_HOA'
      },
      {
        label: 'Xã Tiên Lữ',
        value: 'XA_TIEN_LU'
      },
      {
        label: 'Xã Quang Hưng',
        value: 'XA_QUANG_HUNG'
      },
      {
        label: 'Xã Đoàn Đào',
        value: 'XA_DOAN_DAO'
      },
      {
        label: 'Xã Tiên Tiến',
        value: 'XA_TIEN_TIEN'
      },
      {
        label: 'Xã Tống Trân',
        value: 'XA_TONG_TRAN'
      },
      {
        label: 'Phường Trần Hưng Đạo',
        value: 'PHUONG_TRAN_HUNG_DAO'
      },
      {
        label: 'Phường Trần Lãm',
        value: 'PHUONG_TRAN_LAM'
      },
      {
        label: 'Phường Vũ Phúc',
        value: 'PHUONG_VU_PHUC'
      },
      {
        label: 'Xã Quỳnh Phụ',
        value: 'XA_QUYNH_PHU'
      },
      {
        label: 'Xã Tân Tiến',
        value: 'XA_TAN_TIEN'
      },
      {
        label: 'Xã A Sào',
        value: 'XA_A_SAO'
      },
      {
        label: 'Xã Minh Thọ',
        value: 'XA_MINH_THO'
      },
      {
        label: 'Xã Ngọc Lâm',
        value: 'XA_NGOC_LAM'
      },
      {
        label: 'Xã Phụ Dực',
        value: 'XA_PHU_DUC'
      },
      {
        label: 'Xã Đồng Bằng',
        value: 'XA_DONG_BANG'
      },
      {
        label: 'Xã Nguyễn Du',
        value: 'XA_NGUYEN_DU'
      },
      {
        label: 'Xã Quỳnh An',
        value: 'XA_QUYNH_AN'
      },
      {
        label: 'Xã Hưng Hà',
        value: 'XA_HUNG_HA'
      },
      {
        label: 'Xã Ngự Thiên',
        value: 'XA_NGU_THIEN'
      },
      {
        label: 'Xã Long Hưng',
        value: 'XA_LONG_HUNG'
      },
      {
        label: 'Xã Diên Hà',
        value: 'XA_DIEN_HA'
      },
      {
        label: 'Xã Thần Khê',
        value: 'XA_THAN_KHE'
      },
      {
        label: 'Xã Tiên La',
        value: 'XA_TIEN_LA'
      },
      {
        label: 'Xã Lê Quý Đôn',
        value: 'XA_LE_QUY_DON'
      },
      {
        label: 'Xã Hồng Minh',
        value: 'XA_HONG_MINH'
      },
      {
        label: 'Xã Đông Hưng',
        value: 'XA_DONG_HUNG'
      },
      {
        label: 'Xã Bắc Đông Hưng',
        value: 'XA_BAC_DONG_HUNG'
      },
      {
        label: 'Xã Bắc Tiên Hưng',
        value: 'XA_BAC_TIEN_HUNG'
      },
      {
        label: 'Xã Đông Tiên Hưng',
        value: 'XA_DONG_TIEN_HUNG'
      },
      {
        label: 'Xã  Bắc Đông Quan',
        value: 'XA_BAC_DONG_QUAN'
      },
      {
        label: 'Xã Tiên Hưng',
        value: 'XA_TIEN_HUNG'
      },
      {
        label: 'Xã Nam Tiên Hưng',
        value: 'XA_NAM_TIEN_HUNG'
      },
      {
        label: 'Xã Nam Đông Hưng',
        value: 'XA_NAM_DONG_HUNG'
      },
      {
        label: 'Xã Đông Quan',
        value: 'XA_DONG_QUAN'
      },
      {
        label: 'Phường Trà Lý',
        value: 'PHUONG_TRA_LY'
      },
      {
        label: 'Xã Thái Thụy',
        value: 'XA_THAI_THUY'
      },
      {
        label: 'Xã Bắc Thái Ninh',
        value: 'XA_BAC_THAI_NINH'
      },
      {
        label: 'Xã Tây Thụy Anh',
        value: 'XA_TAY_THUY_ANH'
      },
      {
        label: 'Xã Bắc Thụy Anh',
        value: 'XA_BAC_THUY_ANH'
      },
      {
        label: 'Xã Đông Thụy Anh',
        value: 'XA_DONG_THUY_ANH'
      },
      {
        label: 'Xã Thụy Anh',
        value: 'XA_THUY_ANH'
      },
      {
        label: 'Xã Nam Thụy Anh',
        value: 'XA_NAM_THUY_ANH'
      },
      {
        label: 'Xã Tây Thái Ninh',
        value: 'XA_TAY_THAI_NINH'
      },
      {
        label: 'Xã Thái Ninh',
        value: 'XA_THAI_NINH'
      },
      {
        label: 'Xã Đông Thái Ninh',
        value: 'XA_DONG_THAI_NINH'
      },
      {
        label: 'Xã Nam Thái Ninh',
        value: 'XA_NAM_THAI_NINH'
      },
      {
        label: 'Xã Tiền Hải',
        value: 'XA_TIEN_HAI'
      },
      {
        label: 'Xã Đông Tiền Hải',
        value: 'XA_DONG_TIEN_HAI'
      },
      {
        label: 'Xã Đồng Châu',
        value: 'XA_DONG_CHAU'
      },
      {
        label: 'Xã Ái Quốc',
        value: 'XA_AI_QUOC'
      },
      {
        label: 'Xã Tây Tiền Hải',
        value: 'XA_TAY_TIEN_HAI'
      },
      {
        label: 'Xã Nam Cường',
        value: 'XA_NAM_CUONG'
      },
      {
        label: 'Xã Nam Tiền Hải',
        value: 'XA_NAM_TIEN_HAI'
      },
      {
        label: 'Xã Hưng Phú',
        value: 'XA_HUNG_PHU'
      },
      {
        label: 'Xã Kiến Xương',
        value: 'XA_KIEN_XUONG'
      },
      {
        label: 'Xã Trà Giang',
        value: 'XA_TRA_GIANG'
      },
      {
        label: 'Xã Bình Nguyên',
        value: 'XA_BINH_NGUYEN'
      },
      {
        label: 'Xã Lê Lợi',
        value: 'XA_LE_LOI'
      },
      {
        label: 'Xã Quang Lịch',
        value: 'XA_QUANG_LICH'
      },
      {
        label: 'Xã Vũ Quý',
        value: 'XA_VU_QUY'
      },
      {
        label: 'Xã Hồng Vũ',
        value: 'XA_HONG_VU'
      },
      {
        label: 'Xã Bình Thanh',
        value: 'XA_BINH_THANH'
      },
      {
        label: 'Xã Bình Định',
        value: 'XA_BINH_DINH'
      },
      {
        label: 'Xã Vũ Thư',
        value: 'XA_VU_THU'
      },
      {
        label: 'Xã Vạn Xuân',
        value: 'XA_VAN_XUAN'
      },
      {
        label: 'Xã Thư Trì',
        value: 'XA_THU_TRI'
      },
      {
        label: 'Phường Thái Bình',
        value: 'PHUONG_THAI_BINH'
      },
      {
        label: 'Xã Tân Thuận',
        value: 'XA_TAN_THUAN'
      },
      {
        label: 'Xã Thư Vũ',
        value: 'XA_THU_VU'
      },
      {
        label: 'Xã Vũ Tiên',
        value: 'XA_VU_TIEN'
      }
    ]
  },
  {
    label: 'Ninh Bình',
    value: 'NINH_BINH',
    children: [
      {
        label: 'Phường Châu Sơn',
        value: 'PHUONG_CHAU_SON'
      },
      {
        label: 'Phường Phủ Lý',
        value: 'PHUONG_PHU_LY'
      },
      {
        label: 'Phường Phù Vân',
        value: 'PHUONG_PHU_VAN'
      },
      {
        label: 'Phường Duy Tiên',
        value: 'PHUONG_DUY_TIEN'
      },
      {
        label: 'Phường Duy Tân',
        value: 'PHUONG_DUY_TAN'
      },
      {
        label: 'Phường Duy Hà',
        value: 'PHUONG_DUY_HA'
      },
      {
        label: 'Phường Đồng Văn',
        value: 'PHUONG_DONG_VAN'
      },
      {
        label: 'Phường Tiên Sơn',
        value: 'PHUONG_TIEN_SON'
      },
      {
        label: 'Phường Hà Nam',
        value: 'PHUONG_HA_NAM'
      },
      {
        label: 'Phường Kim Bảng',
        value: 'PHUONG_KIM_BANG'
      },
      {
        label: 'Phường Lê Hồ',
        value: 'PHUONG_LE_HO'
      },
      {
        label: 'Phường Nguyễn Uý',
        value: 'PHUONG_NGUYEN_UY'
      },
      {
        label: 'Phường Kim Thanh',
        value: 'PHUONG_KIM_THANH'
      },
      {
        label: 'Phường Tam Chúc',
        value: 'PHUONG_TAM_CHUC'
      },
      {
        label: 'Phường Lý Thường Kiệt',
        value: 'PHUONG_LY_THUONG_KIET'
      },
      {
        label: 'Phường Liêm Tuyền',
        value: 'PHUONG_LIEM_TUYEN'
      },
      {
        label: 'Xã Liêm Hà',
        value: 'XA_LIEM_HA'
      },
      {
        label: 'Xã Tân Thanh',
        value: 'XA_TAN_THANH'
      },
      {
        label: 'Xã Thanh Bình',
        value: 'XA_THANH_BINH'
      },
      {
        label: 'Xã Thanh Lâm',
        value: 'XA_THANH_LAM'
      },
      {
        label: 'Xã Thanh Liêm',
        value: 'XA_THANH_LIEM'
      },
      {
        label: 'Xã Bình Mỹ',
        value: 'XA_BINH_MY'
      },
      {
        label: 'Xã Bình Lục',
        value: 'XA_BINH_LUC'
      },
      {
        label: 'Xã Bình Giang',
        value: 'XA_BINH_GIANG'
      },
      {
        label: 'Xã Bình An',
        value: 'XA_BINH_AN'
      },
      {
        label: 'Xã Bình Sơn',
        value: 'XA_BINH_SON'
      },
      {
        label: 'Xã Lý Nhân',
        value: 'XA_LY_NHAN'
      },
      {
        label: 'Xã Bắc Lý',
        value: 'XA_BAC_LY'
      },
      {
        label: 'Xã Nam Xang',
        value: 'XA_NAM_XANG'
      },
      {
        label: 'Xã Trần Thương',
        value: 'XA_TRAN_THUONG'
      },
      {
        label: 'Xã Vĩnh Trụ',
        value: 'XA_VINH_TRU'
      },
      {
        label: 'Xã Nhân Hà',
        value: 'XA_NHAN_HA'
      },
      {
        label: 'Xã Nam Lý',
        value: 'XA_NAM_LY'
      },
      {
        label: 'Phường Nam Định',
        value: 'PHUONG_NAM_DINH'
      },
      {
        label: 'Phường Thiên Trường',
        value: 'PHUONG_THIEN_TRUONG'
      },
      {
        label: 'Phường Đông A',
        value: 'PHUONG_DONG_A'
      },
      {
        label: 'Phường Thành Nam',
        value: 'PHUONG_THANH_NAM'
      },
      {
        label: 'Phường Mỹ Lộc',
        value: 'PHUONG_MY_LOC'
      },
      {
        label: 'Xã Vụ Bản',
        value: 'XA_VU_BAN'
      },
      {
        label: 'Xã Minh Tân',
        value: 'XA_MINH_TAN'
      },
      {
        label: 'Xã Hiển Khánh',
        value: 'XA_HIEN_KHANH'
      },
      {
        label: 'Phường Trường Thi',
        value: 'PHUONG_TRUONG_THI'
      },
      {
        label: 'Xã Liên Minh',
        value: 'XA_LIEN_MINH'
      },
      {
        label: 'Xã Ý Yên',
        value: 'XA_Y_YEN'
      },
      {
        label: 'Xã Tân Minh',
        value: 'XA_TAN_MINH'
      },
      {
        label: 'Xã Phong Doanh',
        value: 'XA_PHONG_DOANH'
      },
      {
        label: 'Xã Vũ Dương',
        value: 'XA_VU_DUONG'
      },
      {
        label: 'Xã Vạn Thắng',
        value: 'XA_VAN_THANG'
      },
      {
        label: 'Xã Yên Cường',
        value: 'XA_YEN_CUONG'
      },
      {
        label: 'Xã Yên Đồng',
        value: 'XA_YEN_DONG'
      },
      {
        label: 'Xã Nghĩa Hưng',
        value: 'XA_NGHIA_HUNG'
      },
      {
        label: 'Xã Rạng Đông',
        value: 'XA_RANG_DONG'
      },
      {
        label: 'Xã Đồng Thịnh',
        value: 'XA_DONG_THINH'
      },
      {
        label: 'Xã Nghĩa Sơn',
        value: 'XA_NGHIA_SON'
      },
      {
        label: 'Xã Hồng Phong',
        value: 'XA_HONG_PHONG'
      },
      {
        label: 'Xã Quỹ Nhất',
        value: 'XA_QUY_NHAT'
      },
      {
        label: 'Xã Nghĩa Lâm',
        value: 'XA_NGHIA_LAM'
      },
      {
        label: 'Xã Nam Trực',
        value: 'XA_NAM_TRUC'
      },
      {
        label: 'Phường Vị Khê',
        value: 'PHUONG_VI_KHE'
      },
      {
        label: 'Phường Hồng Quang',
        value: 'PHUONG_HONG_QUANG'
      },
      {
        label: 'Xã Nam Hồng',
        value: 'XA_NAM_HONG'
      },
      {
        label: 'Xã Nam Ninh',
        value: 'XA_NAM_NINH'
      },
      {
        label: 'Xã Nam Minh',
        value: 'XA_NAM_MINH'
      },
      {
        label: 'Xã Nam Đồng',
        value: 'XA_NAM_DONG'
      },
      {
        label: 'Xã Cổ Lễ',
        value: 'XA_CO_LE'
      },
      {
        label: 'Xã Ninh Giang',
        value: 'XA_NINH_GIANG'
      },
      {
        label: 'Xã Trực Ninh',
        value: 'XA_TRUC_NINH'
      },
      {
        label: 'Xã Cát Thành',
        value: 'XA_CAT_THANH'
      },
      {
        label: 'Xã Quang Hưng',
        value: 'XA_QUANG_HUNG'
      },
      {
        label: 'Xã Minh Thái',
        value: 'XA_MINH_THAI'
      },
      {
        label: 'Xã Ninh Cường',
        value: 'XA_NINH_CUONG'
      },
      {
        label: 'Xã Xuân Trường',
        value: 'XA_XUAN_TRUONG'
      },
      {
        label: 'Xã Xuân Hồng',
        value: 'XA_XUAN_HONG'
      },
      {
        label: 'Xã  Xuân Giang',
        value: 'XA_XUAN_GIANG'
      },
      {
        label: 'Xã Xuân Hưng',
        value: 'XA_XUAN_HUNG'
      },
      {
        label: 'Xã Giao Minh',
        value: 'XA_GIAO_MINH'
      },
      {
        label: 'Xã Giao Thuỷ',
        value: 'XA_GIAO_THUY'
      },
      {
        label: 'Xã Giao Hưng',
        value: 'XA_GIAO_HUNG'
      },
      {
        label: 'Xã Giao Hoà',
        value: 'XA_GIAO_HOA'
      },
      {
        label: 'Xã Giao Bình',
        value: 'XA_GIAO_BINH'
      },
      {
        label: 'Xã Giao Phúc',
        value: 'XA_GIAO_PHUC'
      },
      {
        label: 'Xã Giao Ninh',
        value: 'XA_GIAO_NINH'
      },
      {
        label: 'Xã Hải Hậu',
        value: 'XA_HAI_HAU'
      },
      {
        label: 'Xã Hải Tiến',
        value: 'XA_HAI_TIEN'
      },
      {
        label: 'Xã Hải Thịnh',
        value: 'XA_HAI_THINH'
      },
      {
        label: 'Xã Hải Anh',
        value: 'XA_HAI_ANH'
      },
      {
        label: 'Xã Hải Hưng',
        value: 'XA_HAI_HUNG'
      },
      {
        label: 'Xã Hải An',
        value: 'XA_HAI_AN'
      },
      {
        label: 'Xã Hải Quang',
        value: 'XA_HAI_QUANG'
      },
      {
        label: 'Xã Hải Xuân',
        value: 'XA_HAI_XUAN'
      },
      {
        label: 'Phường Hoa Lư',
        value: 'PHUONG_HOA_LU'
      },
      {
        label: 'Phường Nam Hoa Lư',
        value: 'PHUONG_NAM_HOA_LU'
      },
      {
        label: 'Phường Tam Điệp',
        value: 'PHUONG_TAM_DIEP'
      },
      {
        label: 'Phường Trung Sơn',
        value: 'PHUONG_TRUNG_SON'
      },
      {
        label: 'Phường Yên Sơn',
        value: 'PHUONG_YEN_SON'
      },
      {
        label: 'Xã Gia Lâm',
        value: 'XA_GIA_LAM'
      },
      {
        label: 'Xã Gia Tường',
        value: 'XA_GIA_TUONG'
      },
      {
        label: 'Xã Cúc Phương',
        value: 'XA_CUC_PHUONG'
      },
      {
        label: 'Xã Phú Sơn',
        value: 'XA_PHU_SON'
      },
      {
        label: 'Xã Nho Quan',
        value: 'XA_NHO_QUAN'
      },
      {
        label: 'Xã Thanh Sơn',
        value: 'XA_THANH_SON'
      },
      {
        label: 'Xã Quỳnh Lưu',
        value: 'XA_QUYNH_LUU'
      },
      {
        label: 'Xã Phú Long',
        value: 'XA_PHU_LONG'
      },
      {
        label: 'Xã Gia Viễn',
        value: 'XA_GIA_VIEN'
      },
      {
        label: 'Xã Gia Hưng',
        value: 'XA_GIA_HUNG'
      },
      {
        label: 'Xã Gia Vân',
        value: 'XA_GIA_VAN'
      },
      {
        label: 'Xã Gia Trấn',
        value: 'XA_GIA_TRAN'
      },
      {
        label: 'Xã Đại Hoàng',
        value: 'XA_DAI_HOANG'
      },
      {
        label: 'Xã Gia Phong',
        value: 'XA_GIA_PHONG'
      },
      {
        label: 'Phường Tây Hoa Lư',
        value: 'PHUONG_TAY_HOA_LU'
      },
      {
        label: 'Xã Yên Khánh',
        value: 'XA_YEN_KHANH'
      },
      {
        label: 'Xã Khánh Thiện',
        value: 'XA_KHANH_THIEN'
      },
      {
        label: 'Phường Đông Hoa Lư',
        value: 'PHUONG_DONG_HOA_LU'
      },
      {
        label: 'Xã Khánh Hội',
        value: 'XA_KHANH_HOI'
      },
      {
        label: 'Xã Khánh Trung',
        value: 'XA_KHANH_TRUNG'
      },
      {
        label: 'Xã Khánh Nhạc',
        value: 'XA_KHANH_NHAC'
      },
      {
        label: 'Xã Phát Diệm',
        value: 'XA_PHAT_DIEM'
      },
      {
        label: 'Xã Bình Minh',
        value: 'XA_BINH_MINH'
      },
      {
        label: 'Xã Kim Sơn',
        value: 'XA_KIM_SON'
      },
      {
        label: 'Xã Quang Thiện',
        value: 'XA_QUANG_THIEN'
      },
      {
        label: 'Xã Chất Bình',
        value: 'XA_CHAT_BINH'
      },
      {
        label: 'Xã Lai Thành',
        value: 'XA_LAI_THANH'
      },
      {
        label: 'Xã Định Hóa',
        value: 'XA_DINH_HOA'
      },
      {
        label: 'Xã Kim Đông',
        value: 'XA_KIM_DONG'
      },
      {
        label: 'Xã Yên Mô',
        value: 'XA_YEN_MO'
      },
      {
        label: 'Phường Yên Thắng',
        value: 'PHUONG_YEN_THANG'
      },
      {
        label: 'Xã Yên Từ',
        value: 'XA_YEN_TU'
      },
      {
        label: 'Xã Yên Mạc',
        value: 'XA_YEN_MAC'
      },
      {
        label: 'Xã Đồng Thái',
        value: 'XA_DONG_THAI'
      }
    ]
  },
  {
    label: 'Thanh Hóa',
    value: 'THANH_HOA',
    children: [
      {
        label: 'Phường Hàm Rồng',
        value: 'PHUONG_HAM_RONG'
      },
      {
        label: 'Phường Hạc Thành',
        value: 'PHUONG_HAC_THANH'
      },
      {
        label: 'Phường Bỉm Sơn',
        value: 'PHUONG_BIM_SON'
      },
      {
        label: 'Phường Quang Trung',
        value: 'PHUONG_QUANG_TRUNG'
      },
      {
        label: 'Xã Mường Lát',
        value: 'XA_MUONG_LAT'
      },
      {
        label: 'Xã Tam Chung',
        value: 'XA_TAM_CHUNG'
      },
      {
        label: 'Xã Mường Lý',
        value: 'XA_MUONG_LY'
      },
      {
        label: 'Xã Trung Lý',
        value: 'XA_TRUNG_LY'
      },
      {
        label: 'Xã Quang Chiểu',
        value: 'XA_QUANG_CHIEU'
      },
      {
        label: 'Xã Pù Nhi',
        value: 'XA_PU_NHI'
      },
      {
        label: 'Xã Nhi Sơn',
        value: 'XA_NHI_SON'
      },
      {
        label: 'Xã Mường Chanh',
        value: 'XA_MUONG_CHANH'
      },
      {
        label: 'Xã Hồi Xuân',
        value: 'XA_HOI_XUAN'
      },
      {
        label: 'Xã Trung Thành',
        value: 'XA_TRUNG_THANH'
      },
      {
        label: 'Xã Trung Sơn',
        value: 'XA_TRUNG_SON'
      },
      {
        label: 'Xã Phú Lệ',
        value: 'XA_PHU_LE'
      },
      {
        label: 'Xã Phú Xuân',
        value: 'XA_PHU_XUAN'
      },
      {
        label: 'Xã Hiền Kiệt',
        value: 'XA_HIEN_KIET'
      },
      {
        label: 'Xã Nam Xuân',
        value: 'XA_NAM_XUAN'
      },
      {
        label: 'Xã Thiên Phủ',
        value: 'XA_THIEN_PHU'
      },
      {
        label: 'Xã Bá Thước',
        value: 'XA_BA_THUOC'
      },
      {
        label: 'Xã Điền Quang',
        value: 'XA_DIEN_QUANG'
      },
      {
        label: 'Xã Điền Lư',
        value: 'XA_DIEN_LU'
      },
      {
        label: 'Xã Quý Lương',
        value: 'XA_QUY_LUONG'
      },
      {
        label: 'Xã Pù Luông',
        value: 'XA_PU_LUONG'
      },
      {
        label: 'Xã Cổ Lũng',
        value: 'XA_CO_LUNG'
      },
      {
        label: 'Xã Văn Nho',
        value: 'XA_VAN_NHO'
      },
      {
        label: 'Xã Thiết Ống',
        value: 'XA_THIET_ONG'
      },
      {
        label: 'Xã Trung Hạ',
        value: 'XA_TRUNG_HA'
      },
      {
        label: 'Xã Tam Thanh',
        value: 'XA_TAM_THANH'
      },
      {
        label: 'Xã Sơn Thủy',
        value: 'XA_SON_THUY'
      },
      {
        label: 'Xã Na Mèo',
        value: 'XA_NA_MEO'
      },
      {
        label: 'Xã Quan Sơn',
        value: 'XA_QUAN_SON'
      },
      {
        label: 'Xã Tam Lư',
        value: 'XA_TAM_LU'
      },
      {
        label: 'Xã Sơn Điện',
        value: 'XA_SON_DIEN'
      },
      {
        label: 'Xã Mường Mìn',
        value: 'XA_MUONG_MIN'
      },
      {
        label: 'Xã Yên Khương',
        value: 'XA_YEN_KHUONG'
      },
      {
        label: 'Xã Yên Thắng',
        value: 'XA_YEN_THANG'
      },
      {
        label: 'Xã Giao An',
        value: 'XA_GIAO_AN'
      },
      {
        label: 'Xã Văn Phú',
        value: 'XA_VAN_PHU'
      },
      {
        label: 'Xã Linh Sơn',
        value: 'XA_LINH_SON'
      },
      {
        label: 'Xã Đồng Lương',
        value: 'XA_DONG_LUONG'
      },
      {
        label: 'Xã Ngọc Lặc',
        value: 'XA_NGOC_LAC'
      },
      {
        label: 'Xã Thạch Lập',
        value: 'XA_THACH_LAP'
      },
      {
        label: 'Xã Ngọc Liên',
        value: 'XA_NGOC_LIEN'
      },
      {
        label: 'Xã Nguyệt Ấn',
        value: 'XA_NGUYET_AN'
      },
      {
        label: 'Xã Kiên Thọ',
        value: 'XA_KIEN_THO'
      },
      {
        label: 'Xã Minh Sơn',
        value: 'XA_MINH_SON'
      },
      {
        label: 'Xã Cẩm Thủy',
        value: 'XA_CAM_THUY'
      },
      {
        label: 'Xã Cẩm Thạch',
        value: 'XA_CAM_THACH'
      },
      {
        label: 'Xã Cẩm Tú',
        value: 'XA_CAM_TU'
      },
      {
        label: 'Xã Cẩm Vân',
        value: 'XA_CAM_VAN'
      },
      {
        label: 'Xã Cẩm Tân',
        value: 'XA_CAM_TAN'
      },
      {
        label: 'Xã Kim Tân',
        value: 'XA_KIM_TAN'
      },
      {
        label: 'Xã Vân Du',
        value: 'XA_VAN_DU'
      },
      {
        label: 'Xã Thạch Quảng',
        value: 'XA_THACH_QUANG'
      },
      {
        label: 'Xã Thạch Bình',
        value: 'XA_THACH_BINH'
      },
      {
        label: 'Xã Thành Vinh',
        value: 'XA_THANH_VINH'
      },
      {
        label: 'Xã Ngọc Trạo',
        value: 'XA_NGOC_TRAO'
      },
      {
        label: 'Xã Hà Trung',
        value: 'XA_HA_TRUNG'
      },
      {
        label: 'Xã Hà Long',
        value: 'XA_HA_LONG'
      },
      {
        label: 'Xã Hoạt Giang',
        value: 'XA_HOAT_GIANG'
      },
      {
        label: 'Xã Lĩnh Toại',
        value: 'XA_LINH_TOAI'
      },
      {
        label: 'Xã Tống Sơn',
        value: 'XA_TONG_SON'
      },
      {
        label: 'Xã Vĩnh Lộc',
        value: 'XA_VINH_LOC'
      },
      {
        label: 'Xã Tây Đô',
        value: 'XA_TAY_DO'
      },
      {
        label: 'Xã Biện Thượng',
        value: 'XA_BIEN_THUONG'
      },
      {
        label: 'Xã Yên Phú',
        value: 'XA_YEN_PHU'
      },
      {
        label: 'Xã Quý Lộc',
        value: 'XA_QUY_LOC'
      },
      {
        label: 'Xã Yên Trường',
        value: 'XA_YEN_TRUONG'
      },
      {
        label: 'Xã Yên Ninh',
        value: 'XA_YEN_NINH'
      },
      {
        label: 'Xã Định Hòa',
        value: 'XA_DINH_HOA'
      },
      {
        label: 'Xã Định Tân',
        value: 'XA_DINH_TAN'
      },
      {
        label: 'Xã Yên Định',
        value: 'XA_YEN_DINH'
      },
      {
        label: 'Xã Thọ Xuân',
        value: 'XA_THO_XUAN'
      },
      {
        label: 'Xã Thọ Long',
        value: 'XA_THO_LONG'
      },
      {
        label: 'Xã Xuân Hòa',
        value: 'XA_XUAN_HOA'
      },
      {
        label: 'Xã Lam Sơn',
        value: 'XA_LAM_SON'
      },
      {
        label: 'Xã Sao Vàng',
        value: 'XA_SAO_VANG'
      },
      {
        label: 'Xã Thọ Lập',
        value: 'XA_THO_LAP'
      },
      {
        label: 'Xã Xuân Tín',
        value: 'XA_XUAN_TIN'
      },
      {
        label: 'Xã Xuân Lập',
        value: 'XA_XUAN_LAP'
      },
      {
        label: 'Xã Bát Mọt',
        value: 'XA_BAT_MOT'
      },
      {
        label: 'Xã Yên Nhân',
        value: 'XA_YEN_NHAN'
      },
      {
        label: 'Xã Vạn Xuân',
        value: 'XA_VAN_XUAN'
      },
      {
        label: 'Xã Lương Sơn',
        value: 'XA_LUONG_SON'
      },
      {
        label: 'Xã Luận Thành',
        value: 'XA_LUAN_THANH'
      },
      {
        label: 'Xã Thắng Lộc',
        value: 'XA_THANG_LOC'
      },
      {
        label: 'Xã Thường Xuân',
        value: 'XA_THUONG_XUAN'
      },
      {
        label: 'Xã Xuân Chinh',
        value: 'XA_XUAN_CHINH'
      },
      {
        label: 'Xã Tân Thành',
        value: 'XA_TAN_THANH'
      },
      {
        label: 'Xã Triệu Sơn',
        value: 'XA_TRIEU_SON'
      },
      {
        label: 'Xã Thọ Bình',
        value: 'XA_THO_BINH'
      },
      {
        label: 'Xã Hợp Tiến',
        value: 'XA_HOP_TIEN'
      },
      {
        label: 'Xã Tân Ninh',
        value: 'XA_TAN_NINH'
      },
      {
        label: 'Xã Đồng Tiến',
        value: 'XA_DONG_TIEN'
      },
      {
        label: 'Xã Thọ Ngọc',
        value: 'XA_THO_NGOC'
      },
      {
        label: 'Xã Thọ Phú',
        value: 'XA_THO_PHU'
      },
      {
        label: 'Xã An Nông',
        value: 'XA_AN_NONG'
      },
      {
        label: 'Xã Thiệu Hóa',
        value: 'XA_THIEU_HOA'
      },
      {
        label: 'Xã Thiệu Tiến',
        value: 'XA_THIEU_TIEN'
      },
      {
        label: 'Xã Thiệu Quang',
        value: 'XA_THIEU_QUANG'
      },
      {
        label: 'Xã Thiệu Toán',
        value: 'XA_THIEU_TOAN'
      },
      {
        label: 'Xã Thiệu Trung',
        value: 'XA_THIEU_TRUNG'
      },
      {
        label: 'Phường Đông Tiến',
        value: 'PHUONG_DONG_TIEN'
      },
      {
        label: 'Xã Hoằng Hóa',
        value: 'XA_HOANG_HOA'
      },
      {
        label: 'Xã Hoằng Giang',
        value: 'XA_HOANG_GIANG'
      },
      {
        label: 'Xã Hoằng Phú',
        value: 'XA_HOANG_PHU'
      },
      {
        label: 'Xã Hoằng Sơn',
        value: 'XA_HOANG_SON'
      },
      {
        label: 'Phường Nguyệt Viên',
        value: 'PHUONG_NGUYET_VIEN'
      },
      {
        label: 'Xã Hoằng Lộc',
        value: 'XA_HOANG_LOC'
      },
      {
        label: 'Xã Hoằng Châu',
        value: 'XA_HOANG_CHAU'
      },
      {
        label: 'Xã Hoằng Tiến',
        value: 'XA_HOANG_TIEN'
      },
      {
        label: 'Xã Hoằng Thanh',
        value: 'XA_HOANG_THANH'
      },
      {
        label: 'Xã Hậu Lộc',
        value: 'XA_HAU_LOC'
      },
      {
        label: 'Xã Triệu Lộc',
        value: 'XA_TRIEU_LOC'
      },
      {
        label: 'Xã Đông Thành',
        value: 'XA_DONG_THANH'
      },
      {
        label: 'Xã Hoa Lộc',
        value: 'XA_HOA_LOC'
      },
      {
        label: 'Xã Vạn Lộc',
        value: 'XA_VAN_LOC'
      },
      {
        label: 'Xã Nga Sơn',
        value: 'XA_NGA_SON'
      },
      {
        label: 'Xã Tân Tiến',
        value: 'XA_TAN_TIEN'
      },
      {
        label: 'Xã Nga Thắng',
        value: 'XA_NGA_THANG'
      },
      {
        label: 'Xã Hồ Vương',
        value: 'XA_HO_VUONG'
      },
      {
        label: 'Xã Nga An',
        value: 'XA_NGA_AN'
      },
      {
        label: 'Xã Ba Đình',
        value: 'XA_BA_DINH'
      },
      {
        label: 'Xã Như Xuân',
        value: 'XA_NHU_XUAN'
      },
      {
        label: 'Xã Xuân Bình',
        value: 'XA_XUAN_BINH'
      },
      {
        label: 'Xã Hóa Quỳ',
        value: 'XA_HOA_QUY'
      },
      {
        label: 'Xã Thanh Quân',
        value: 'XA_THANH_QUAN'
      },
      {
        label: 'Xã Thanh Phong',
        value: 'XA_THANH_PHONG'
      },
      {
        label: 'Xã Thượng Ninh',
        value: 'XA_THUONG_NINH'
      },
      {
        label: 'Xã Như Thanh',
        value: 'XA_NHU_THANH'
      },
      {
        label: 'Xã Xuân Du',
        value: 'XA_XUAN_DU'
      },
      {
        label: 'Xã Mậu Lâm',
        value: 'XA_MAU_LAM'
      },
      {
        label: 'Xã Xuân Thái',
        value: 'XA_XUAN_THAI'
      },
      {
        label: 'Xã Yên Thọ',
        value: 'XA_YEN_THO'
      },
      {
        label: 'Xã Thanh Kỳ',
        value: 'XA_THANH_KY'
      },
      {
        label: 'Xã Nông Cống',
        value: 'XA_NONG_CONG'
      },
      {
        label: 'Xã Trung Chính',
        value: 'XA_TRUNG_CHINH'
      },
      {
        label: 'Xã Thắng Lợi',
        value: 'XA_THANG_LOI'
      },
      {
        label: 'Xã Thăng Bình',
        value: 'XA_THANG_BINH'
      },
      {
        label: 'Xã Trường Văn',
        value: 'XA_TRUONG_VAN'
      },
      {
        label: 'Xã Tượng Lĩnh',
        value: 'XA_TUONG_LINH'
      },
      {
        label: 'Xã Công Chính',
        value: 'XA_CONG_CHINH'
      },
      {
        label: 'Phường Đông Sơn',
        value: 'PHUONG_DONG_SON'
      },
      {
        label: 'Phường Đông Quang',
        value: 'PHUONG_DONG_QUANG'
      },
      {
        label: 'Xã Lưu Vệ',
        value: 'XA_LUU_VE'
      },
      {
        label: 'Xã Quảng Yên',
        value: 'XA_QUANG_YEN'
      },
      {
        label: 'Xã Quảng Chính',
        value: 'XA_QUANG_CHINH'
      },
      {
        label: 'Xã Quảng Ngọc',
        value: 'XA_QUANG_NGOC'
      },
      {
        label: 'Phường Nam Sầm Sơn',
        value: 'PHUONG_NAM_SAM_SON'
      },
      {
        label: 'Phường Quảng Phú',
        value: 'PHUONG_QUANG_PHU'
      },
      {
        label: 'Phường Sầm Sơn',
        value: 'PHUONG_SAM_SON'
      },
      {
        label: 'Xã Quảng Ninh',
        value: 'XA_QUANG_NINH'
      },
      {
        label: 'Xã Quảng Bình',
        value: 'XA_QUANG_BINH'
      },
      {
        label: 'Xã Tiên Trang',
        value: 'XA_TIEN_TRANG'
      },
      {
        label: 'Phường Tĩnh Gia',
        value: 'PHUONG_TINH_GIA'
      },
      {
        label: 'Phường Ngọc Sơn',
        value: 'PHUONG_NGOC_SON'
      },
      {
        label: 'Xã Các Sơn',
        value: 'XA_CAC_SON'
      },
      {
        label: 'Phường Tân Dân',
        value: 'PHUONG_TAN_DAN'
      },
      {
        label: 'Phường Hải Lĩnh',
        value: 'PHUONG_HAI_LINH'
      },
      {
        label: 'Phường Đào Duy Tư',
        value: 'PHUONG_DAO_DUY_TU'
      },
      {
        label: 'Phường Trúc Lâm',
        value: 'PHUONG_TRUC_LAM'
      },
      {
        label: 'Xã Trường Lâm',
        value: 'XA_TRUONG_LAM'
      },
      {
        label: 'Phường Hải Bình',
        value: 'PHUONG_HAI_BINH'
      },
      {
        label: 'Phường Nghi Sơn',
        value: 'PHUONG_NGHI_SON'
      }
    ]
  },
  {
    label: 'Nghệ An',
    value: 'NGHE_AN',
    children: [
      {
        label: 'Phường Thành Vinh',
        value: 'PHUONG_THANH_VINH'
      },
      {
        label: 'Phường Trường Vinh',
        value: 'PHUONG_TRUONG_VINH'
      },
      {
        label: 'Phường Vinh Phú',
        value: 'PHUONG_VINH_PHU'
      },
      {
        label: 'Phường Vinh Lộc',
        value: 'PHUONG_VINH_LOC'
      },
      {
        label: 'Phường Cửa Lò',
        value: 'PHUONG_CUA_LO'
      },
      {
        label: 'Xã Quế Phong',
        value: 'XA_QUE_PHONG'
      },
      {
        label: 'Xã Thông Thụ',
        value: 'XA_THONG_THU'
      },
      {
        label: 'Xã Tiền Phong',
        value: 'XA_TIEN_PHONG'
      },
      {
        label: 'Xã Tri Lễ',
        value: 'XA_TRI_LE'
      },
      {
        label: 'Xã Mường Quàng',
        value: 'XA_MUONG_QUANG'
      },
      {
        label: 'Xã Quỳ Châu',
        value: 'XA_QUY_CHAU'
      },
      {
        label: 'Xã Châu Tiến',
        value: 'XA_CHAU_TIEN'
      },
      {
        label: 'Xã Hùng Chân',
        value: 'XA_HUNG_CHAN'
      },
      {
        label: 'Xã Châu Bình',
        value: 'XA_CHAU_BINH'
      },
      {
        label: 'Xã Mường Xén',
        value: 'XA_MUONG_XEN'
      },
      {
        label: 'Xã Mỹ Lý',
        value: 'XA_MY_LY'
      },
      {
        label: 'Xã Bắc Lý',
        value: 'XA_BAC_LY'
      },
      {
        label: 'Xã Keng Đu',
        value: 'XA_KENG_DU'
      },
      {
        label: 'Xã Huồi Tụ',
        value: 'XA_HUOI_TU'
      },
      {
        label: 'Xã Mường Lống',
        value: 'XA_MUONG_LONG'
      },
      {
        label: 'Xã Na Loi',
        value: 'XA_NA_LOI'
      },
      {
        label: 'Xã Nậm Cắn',
        value: 'XA_NAM_CAN'
      },
      {
        label: 'Xã Hữu Kiệm',
        value: 'XA_HUU_KIEM'
      },
      {
        label: 'Xã Chiêu Lưu',
        value: 'XA_CHIEU_LUU'
      },
      {
        label: 'Xã Mường Típ',
        value: 'XA_MUONG_TIP'
      },
      {
        label: 'Xã Na Ngoi',
        value: 'XA_NA_NGOI'
      },
      {
        label: 'Xã Tương Dương',
        value: 'XA_TUONG_DUONG'
      },
      {
        label: 'Xã Nhôn Mai',
        value: 'XA_NHON_MAI'
      },
      {
        label: 'Xã Hữu Khuông',
        value: 'XA_HUU_KHUONG'
      },
      {
        label: 'Xã Nga My',
        value: 'XA_NGA_MY'
      },
      {
        label: 'Xã Lượng Minh',
        value: 'XA_LUONG_MINH'
      },
      {
        label: 'Xã Yên Hòa',
        value: 'XA_YEN_HOA'
      },
      {
        label: 'Xã Yên Na',
        value: 'XA_YEN_NA'
      },
      {
        label: 'Xã Tam Quang',
        value: 'XA_TAM_QUANG'
      },
      {
        label: 'Xã Tam Thái',
        value: 'XA_TAM_THAI'
      },
      {
        label: 'Phường Thái Hòa',
        value: 'PHUONG_THAI_HOA'
      },
      {
        label: 'Xã Nghĩa Đàn',
        value: 'XA_NGHIA_DAN'
      },
      {
        label: 'Xã Nghĩa Lâm',
        value: 'XA_NGHIA_LAM'
      },
      {
        label: 'Xã Nghĩa Thọ',
        value: 'XA_NGHIA_THO'
      },
      {
        label: 'Xã Nghĩa Hưng',
        value: 'XA_NGHIA_HUNG'
      },
      {
        label: 'Xã Nghĩa Mai',
        value: 'XA_NGHIA_MAI'
      },
      {
        label: 'Phường Tây Hiếu',
        value: 'PHUONG_TAY_HIEU'
      },
      {
        label: 'Xã Đông Hiếu',
        value: 'XA_DONG_HIEU'
      },
      {
        label: 'Xã Nghĩa Lộc',
        value: 'XA_NGHIA_LOC'
      },
      {
        label: 'Xã Nghĩa Khánh',
        value: 'XA_NGHIA_KHANH'
      },
      {
        label: 'Xã Quỳ Hợp',
        value: 'XA_QUY_HOP'
      },
      {
        label: 'Xã Châu Hồng',
        value: 'XA_CHAU_HONG'
      },
      {
        label: 'Xã Châu Lộc',
        value: 'XA_CHAU_LOC'
      },
      {
        label: 'Xã Tam Hợp',
        value: 'XA_TAM_HOP'
      },
      {
        label: 'Xã Minh Hợp',
        value: 'XA_MINH_HOP'
      },
      {
        label: 'Xã Mường Ham',
        value: 'XA_MUONG_HAM'
      },
      {
        label: 'Xã Mường Chọng',
        value: 'XA_MUONG_CHONG'
      },
      {
        label: 'Phường Hoàng Mai',
        value: 'PHUONG_HOANG_MAI'
      },
      {
        label: 'Phường Quỳnh Mai',
        value: 'PHUONG_QUYNH_MAI'
      },
      {
        label: 'Phường Tân Mai',
        value: 'PHUONG_TAN_MAI'
      },
      {
        label: 'Xã Quỳnh Văn',
        value: 'XA_QUYNH_VAN'
      },
      {
        label: 'Xã Quỳnh Tam',
        value: 'XA_QUYNH_TAM'
      },
      {
        label: 'Xã Quỳnh Sơn',
        value: 'XA_QUYNH_SON'
      },
      {
        label: 'Xã Quỳnh Anh',
        value: 'XA_QUYNH_ANH'
      },
      {
        label: 'Xã Quỳnh Lưu',
        value: 'XA_QUYNH_LUU'
      },
      {
        label: 'Xã Quỳnh Phú',
        value: 'XA_QUYNH_PHU'
      },
      {
        label: 'Xã Quỳnh Thắng',
        value: 'XA_QUYNH_THANG'
      },
      {
        label: 'Xã Bình Chuẩn',
        value: 'XA_BINH_CHUAN'
      },
      {
        label: 'Xã Mậu Thạch',
        value: 'XA_MAU_THACH'
      },
      {
        label: 'Xã Cam Phục',
        value: 'XA_CAM_PHUC'
      },
      {
        label: 'Xã Châu Khê',
        value: 'XA_CHAU_KHE'
      },
      {
        label: 'Xã Con Cuông',
        value: 'XA_CON_CUONG'
      },
      {
        label: 'Xã Môn Sơn',
        value: 'XA_MON_SON'
      },
      {
        label: 'Xã Tân Kỳ',
        value: 'XA_TAN_KY'
      },
      {
        label: 'Xã Tân Phú',
        value: 'XA_TAN_PHU'
      },
      {
        label: 'Xã Giai Xuân',
        value: 'XA_GIAI_XUAN'
      },
      {
        label: 'Xã Nghĩa Đồng',
        value: 'XA_NGHIA_DONG'
      },
      {
        label: 'Xã Tiên Đồng',
        value: 'XA_TIEN_DONG'
      },
      {
        label: 'Xã Tân An',
        value: 'XA_TAN_AN'
      },
      {
        label: 'Xã Nghĩa Hành',
        value: 'XA_NGHIA_HANH'
      },
      {
        label: 'Xã Anh Sơn',
        value: 'XA_ANH_SON'
      },
      {
        label: 'Xã Thành Bình Thọ',
        value: 'XA_THANH_BINH_THO'
      },
      {
        label: 'Xã Nhân Hòa',
        value: 'XA_NHAN_HOA'
      },
      {
        label: 'Xã Vĩnh Tường',
        value: 'XA_VINH_TUONG'
      },
      {
        label: 'Xã Anh Sơn Đông',
        value: 'XA_ANH_SON_DONG'
      },
      {
        label: 'Xã Yên Xuân',
        value: 'XA_YEN_XUAN'
      },
      {
        label: 'Xã Hùng Châu',
        value: 'XA_HUNG_CHAU'
      },
      {
        label: 'Xã Đức Châu',
        value: 'XA_DUC_CHAU'
      },
      {
        label: 'Xã Hải Châu',
        value: 'XA_HAI_CHAU'
      },
      {
        label: 'Xã Quảng Châu',
        value: 'XA_QUANG_CHAU'
      },
      {
        label: 'Xã Diễn Châu',
        value: 'XA_DIEN_CHAU'
      },
      {
        label: 'Xã Minh Châu',
        value: 'XA_MINH_CHAU'
      },
      {
        label: 'Xã An Châu',
        value: 'XA_AN_CHAU'
      },
      {
        label: 'Xã Tân Châu',
        value: 'XA_TAN_CHAU'
      },
      {
        label: 'Xã Yên Thành',
        value: 'XA_YEN_THANH'
      },
      {
        label: 'Xã Bình Minh',
        value: 'XA_BINH_MINH'
      },
      {
        label: 'Xã Quang Đồng',
        value: 'XA_QUANG_DONG'
      },
      {
        label: 'Xã Giai Lạc',
        value: 'XA_GIAI_LAC'
      },
      {
        label: 'Xã Đông Thành',
        value: 'XA_DONG_THANH'
      },
      {
        label: 'Xã Vân Du',
        value: 'XA_VAN_DU'
      },
      {
        label: 'Xã Quan Thành',
        value: 'XA_QUAN_THANH'
      },
      {
        label: 'Xã Hợp Minh',
        value: 'XA_HOP_MINH'
      },
      {
        label: 'Xã Vân Tụ',
        value: 'XA_VAN_TU'
      },
      {
        label: 'Xã Bạch Ngọc',
        value: 'XA_BACH_NGOC'
      },
      {
        label: 'Xã Lương Sơn',
        value: 'XA_LUONG_SON'
      },
      {
        label: 'Xã Đô Lương',
        value: 'XA_DO_LUONG'
      },
      {
        label: 'Xã Văn Hiến',
        value: 'XA_VAN_HIEN'
      },
      {
        label: 'Xã Thuần Trung',
        value: 'XA_THUAN_TRUNG'
      },
      {
        label: 'Xã Bạch Hà',
        value: 'XA_BACH_HA'
      },
      {
        label: 'Xã Đại Đồng',
        value: 'XA_DAI_DONG'
      },
      {
        label: 'Xã Hạnh Lâm',
        value: 'XA_HANH_LAM'
      },
      {
        label: 'Xã Cát Ngạn',
        value: 'XA_CAT_NGAN'
      },
      {
        label: 'Xã Tam Đồng',
        value: 'XA_TAM_DONG'
      },
      {
        label: 'Xã Sơn Lâm',
        value: 'XA_SON_LAM'
      },
      {
        label: 'Xã Hoa Quân',
        value: 'XA_HOA_QUAN'
      },
      {
        label: 'Xã Xuân Lâm',
        value: 'XA_XUAN_LAM'
      },
      {
        label: 'Xã Kim Bảng',
        value: 'XA_KIM_BANG'
      },
      {
        label: 'Xã Bích Hào',
        value: 'XA_BICH_HAO'
      },
      {
        label: 'Xã Nghi Lộc',
        value: 'XA_NGHI_LOC'
      },
      {
        label: 'Xã Hải Lộc',
        value: 'XA_HAI_LOC'
      },
      {
        label: 'Xã Thần Lĩnh',
        value: 'XA_THAN_LINH'
      },
      {
        label: 'Xã Văn Kiều',
        value: 'XA_VAN_KIEU'
      },
      {
        label: 'Xã Phúc Lộc',
        value: 'XA_PHUC_LOC'
      },
      {
        label: 'Xã Trung Lộc',
        value: 'XA_TRUNG_LOC'
      },
      {
        label: 'Xã Đông Lộc',
        value: 'XA_DONG_LOC'
      },
      {
        label: 'Phường Vinh Hưng',
        value: 'PHUONG_VINH_HUNG'
      },
      {
        label: 'Xã Nam Đàn',
        value: 'XA_NAM_DAN'
      },
      {
        label: 'Xã Đại Huệ',
        value: 'XA_DAI_HUE'
      },
      {
        label: 'Xã Vạn An',
        value: 'XA_VAN_AN'
      },
      {
        label: 'Xã Kim Liên',
        value: 'XA_KIM_LIEN'
      },
      {
        label: 'Xã Thiên Nhẫn',
        value: 'XA_THIEN_NHAN'
      },
      {
        label: 'Xã Hưng Nguyên',
        value: 'XA_HUNG_NGUYEN'
      },
      {
        label: 'Xã Yên Trung',
        value: 'XA_YEN_TRUNG'
      },
      {
        label: 'Xã Hưng Nguyên Nam',
        value: 'XA_HUNG_NGUYEN_NAM'
      },
      {
        label: 'Xã Lam Thành',
        value: 'XA_LAM_THANH'
      }
    ]
  },
  {
    label: 'Hà Tĩnh',
    value: 'HA_TINH',
    children: [
      {
        label: 'Phường Thành Sen',
        value: 'PHUONG_THANH_SEN'
      },
      {
        label: 'Phường Trần Phú',
        value: 'PHUONG_TRAN_PHU'
      },
      {
        label: 'Phường Bắc Hồng Lĩnh',
        value: 'PHUONG_BAC_HONG_LINH'
      },
      {
        label: 'Phường Nam Hồng Lĩnh',
        value: 'PHUONG_NAM_HONG_LINH'
      },
      {
        label: 'Xã Hương Sơn',
        value: 'XA_HUONG_SON'
      },
      {
        label: 'Xã Sơn Hồng',
        value: 'XA_SON_HONG'
      },
      {
        label: 'Xã Sơn Tiến',
        value: 'XA_SON_TIEN'
      },
      {
        label: 'Xã Sơn Tây',
        value: 'XA_SON_TAY'
      },
      {
        label: 'Xã Sơn Giang',
        value: 'XA_SON_GIANG'
      },
      {
        label: 'Xã Sơn Kim 1',
        value: 'XA_SON_KIM_1'
      },
      {
        label: 'Xã Sơn Kim 2',
        value: 'XA_SON_KIM_2'
      },
      {
        label: 'Xã Tứ Mỹ',
        value: 'XA_TU_MY'
      },
      {
        label: 'Xã Kim Hoa',
        value: 'XA_KIM_HOA'
      },
      {
        label: 'Xã Đức Thọ',
        value: 'XA_DUC_THO'
      },
      {
        label: 'Xã Đức Minh',
        value: 'XA_DUC_MINH'
      },
      {
        label: 'Xã Đức Quang',
        value: 'XA_DUC_QUANG'
      },
      {
        label: 'Xã Đức Thịnh',
        value: 'XA_DUC_THINH'
      },
      {
        label: 'Xã Đức Đồng',
        value: 'XA_DUC_DONG'
      },
      {
        label: 'Xã Vũ Quang',
        value: 'XA_VU_QUANG'
      },
      {
        label: 'Xã Mai Hoa',
        value: 'XA_MAI_HOA'
      },
      {
        label: 'Xã Thượng Đức',
        value: 'XA_THUONG_DUC'
      },
      {
        label: 'Xã Nghi Xuân',
        value: 'XA_NGHI_XUAN'
      },
      {
        label: 'Xã Đan Hải',
        value: 'XA_DAN_HAI'
      },
      {
        label: 'Xã Tiên Điền',
        value: 'XA_TIEN_DIEN'
      },
      {
        label: 'Xã Cổ Đạm',
        value: 'XA_CO_DAM'
      },
      {
        label: 'Xã Can Lộc',
        value: 'XA_CAN_LOC'
      },
      {
        label: 'Xã Hồng Lộc',
        value: 'XA_HONG_LOC'
      },
      {
        label: 'Xã Tùng Lộc',
        value: 'XA_TUNG_LOC'
      },
      {
        label: 'Xã Trường Lưu',
        value: 'XA_TRUONG_LUU'
      },
      {
        label: 'Xã Gia Hanh',
        value: 'XA_GIA_HANH'
      },
      {
        label: 'Xã Xuân Lộc',
        value: 'XA_XUAN_LOC'
      },
      {
        label: 'Xã Đồng Lộc',
        value: 'XA_DONG_LOC'
      },
      {
        label: 'Xã Hương Khê',
        value: 'XA_HUONG_KHE'
      },
      {
        label: 'Xã Hà Linh',
        value: 'XA_HA_LINH'
      },
      {
        label: 'Xã Hương Bình',
        value: 'XA_HUONG_BINH'
      },
      {
        label: 'Xã Hương Phố',
        value: 'XA_HUONG_PHO'
      },
      {
        label: 'Xã Hương Xuân',
        value: 'XA_HUONG_XUAN'
      },
      {
        label: 'Xã Phúc Trạch',
        value: 'XA_PHUC_TRACH'
      },
      {
        label: 'Xã Hương Đô',
        value: 'XA_HUONG_DO'
      },
      {
        label: 'Xã Thạch Hà',
        value: 'XA_THACH_HA'
      },
      {
        label: 'Xã Lộc Hà',
        value: 'XA_LOC_HA'
      },
      {
        label: 'Xã Mai Phụ',
        value: 'XA_MAI_PHU'
      },
      {
        label: 'Xã Đông Kinh',
        value: 'XA_DONG_KINH'
      },
      {
        label: 'Xã Việt Xuyên',
        value: 'XA_VIET_XUYEN'
      },
      {
        label: 'Xã Thạch Khê',
        value: 'XA_THACH_KHE'
      },
      {
        label: 'Xã Đồng Tiến',
        value: 'XA_DONG_TIEN'
      },
      {
        label: 'Xã Thạch Lạc',
        value: 'XA_THACH_LAC'
      },
      {
        label: 'Xã Toàn Lưu',
        value: 'XA_TOAN_LUU'
      },
      {
        label: 'Phường Hà Huy Tập',
        value: 'PHUONG_HA_HUY_TAP'
      },
      {
        label: 'Xã Thạch Xuân',
        value: 'XA_THACH_XUAN'
      },
      {
        label: 'Xã Cẩm Xuyên',
        value: 'XA_CAM_XUYEN'
      },
      {
        label: 'Xã Thiên Cầm',
        value: 'XA_THIEN_CAM'
      },
      {
        label: 'Xã Yên Hòa',
        value: 'XA_YEN_HOA'
      },
      {
        label: 'Xã Cẩm Bình',
        value: 'XA_CAM_BINH'
      },
      {
        label: 'Xã Cẩm Hưng',
        value: 'XA_CAM_HUNG'
      },
      {
        label: 'Xã Cẩm Duệ',
        value: 'XA_CAM_DUE'
      },
      {
        label: 'Xã Cẩm Trung',
        value: 'XA_CAM_TRUNG'
      },
      {
        label: 'Xã Cẩm Lạc',
        value: 'XA_CAM_LAC'
      },
      {
        label: 'Phường Sông Trí',
        value: 'PHUONG_SONG_TRI'
      },
      {
        label: 'Xã Kỳ Xuân',
        value: 'XA_KY_XUAN'
      },
      {
        label: 'Xã Kỳ Anh',
        value: 'XA_KY_ANH'
      },
      {
        label: 'Phường Hải Ninh',
        value: 'PHUONG_HAI_NINH'
      },
      {
        label: 'Xã Kỳ Văn',
        value: 'XA_KY_VAN'
      },
      {
        label: 'Xã Kỳ Khang',
        value: 'XA_KY_KHANG'
      },
      {
        label: 'Xã Kỳ Hoa',
        value: 'XA_KY_HOA'
      },
      {
        label: 'Phường Vũng Áng',
        value: 'PHUONG_VUNG_ANG'
      },
      {
        label: 'Phường Hoành Sơn',
        value: 'PHUONG_HOANH_SON'
      },
      {
        label: 'Xã Kỳ Lạc',
        value: 'XA_KY_LAC'
      },
      {
        label: 'Xã Kỳ Thượng',
        value: 'XA_KY_THUONG'
      }
    ]
  },
  {
    label: 'Quảng Trị',
    value: 'QUANG_TRI',
    children: [
      {
        label: 'Phường Đồng Thuận',
        value: 'PHUONG_DONG_THUAN'
      },
      {
        label: 'Phường Đồng Sơn',
        value: 'PHUONG_DONG_SON'
      },
      {
        label: 'Phường Đồng Hới',
        value: 'PHUONG_DONG_HOI'
      },
      {
        label: 'Xã Minh Hóa',
        value: 'XA_MINH_HOA'
      },
      {
        label: 'Xã Dân Hóa',
        value: 'XA_DAN_HOA'
      },
      {
        label: 'Xã Tân Thành',
        value: 'XA_TAN_THANH'
      },
      {
        label: 'Xã Kim Điền',
        value: 'XA_KIM_DIEN'
      },
      {
        label: 'Xã Kim Phú',
        value: 'XA_KIM_PHU'
      },
      {
        label: 'Xã Đồng Lê',
        value: 'XA_DONG_LE'
      },
      {
        label: 'Xã Tuyên Sơn',
        value: 'XA_TUYEN_SON'
      },
      {
        label: 'Xã Tuyên Lâm',
        value: 'XA_TUYEN_LAM'
      },
      {
        label: 'Xã Tuyên Phú',
        value: 'XA_TUYEN_PHU'
      },
      {
        label: 'Xã Tuyên Bình',
        value: 'XA_TUYEN_BINH'
      },
      {
        label: 'Xã Tuyên Hóa',
        value: 'XA_TUYEN_HOA'
      },
      {
        label: 'Phường Ba Đồn',
        value: 'PHUONG_BA_DON'
      },
      {
        label: 'Xã Phú Trạch',
        value: 'XA_PHU_TRACH'
      },
      {
        label: 'Xã Trung Thuần',
        value: 'XA_TRUNG_THUAN'
      },
      {
        label: 'Xã Hòa Trạch',
        value: 'XA_HOA_TRACH'
      },
      {
        label: 'Xã Tân Gianh',
        value: 'XA_TAN_GIANH'
      },
      {
        label: 'Xã Quảng Trạch',
        value: 'XA_QUANG_TRACH'
      },
      {
        label: 'Phường Bắc Gianh',
        value: 'PHUONG_BAC_GIANH'
      },
      {
        label: 'Xã Nam Ba Đồn',
        value: 'XA_NAM_BA_DON'
      },
      {
        label: 'Xã Nam Gianh',
        value: 'XA_NAM_GIANH'
      },
      {
        label: 'Xã Hoàn Lão',
        value: 'XA_HOAN_LAO'
      },
      {
        label: 'Xã Bắc Trạch',
        value: 'XA_BAC_TRACH'
      },
      {
        label: 'Xã Bố Trạch',
        value: 'XA_BO_TRACH'
      },
      {
        label: 'Xã Thượng Trạch',
        value: 'XA_THUONG_TRACH'
      },
      {
        label: 'Xã Đông Trạch',
        value: 'XA_DONG_TRACH'
      },
      {
        label: 'Xã Phong Nha',
        value: 'XA_PHONG_NHA'
      },
      {
        label: 'Xã Nam Trạch',
        value: 'XA_NAM_TRACH'
      },
      {
        label: 'Xã Trường Sơn',
        value: 'XA_TRUONG_SON'
      },
      {
        label: 'Xã Quảng Ninh',
        value: 'XA_QUANG_NINH'
      },
      {
        label: 'Xã Ninh Châu',
        value: 'XA_NINH_CHAU'
      },
      {
        label: 'Xã Trường Ninh',
        value: 'XA_TRUONG_NINH'
      },
      {
        label: 'Xã Lệ Ninh',
        value: 'XA_LE_NINH'
      },
      {
        label: 'Xã Lệ Thủy',
        value: 'XA_LE_THUY'
      },
      {
        label: 'Xã Cam Hồng',
        value: 'XA_CAM_HONG'
      },
      {
        label: 'Xã Sen Ngư',
        value: 'XA_SEN_NGU'
      },
      {
        label: 'Xã Tân Mỹ',
        value: 'XA_TAN_MY'
      },
      {
        label: 'Xã Trường Phú',
        value: 'XA_TRUONG_PHU'
      },
      {
        label: 'Xã Kim Ngân',
        value: 'XA_KIM_NGAN'
      },
      {
        label: 'Phường Đông Hà',
        value: 'PHUONG_DONG_HA'
      },
      {
        label: 'Phường Nam Đông Hà',
        value: 'PHUONG_NAM_DONG_HA'
      },
      {
        label: 'Phường Quảng Trị',
        value: 'PHUONG_QUANG_TRI'
      },
      {
        label: 'Xã Vĩnh Linh',
        value: 'XA_VINH_LINH'
      },
      {
        label: 'Xã Bến Quan',
        value: 'XA_BEN_QUAN'
      },
      {
        label: 'Xã Vĩnh Hoàng',
        value: 'XA_VINH_HOANG'
      },
      {
        label: 'Xã Vĩnh Thủy',
        value: 'XA_VINH_THUY'
      },
      {
        label: 'Xã Cửa Tùng',
        value: 'XA_CUA_TUNG'
      },
      {
        label: 'Xã Khe Sanh',
        value: 'XA_KHE_SANH'
      },
      {
        label: 'Xã Lao Bảo',
        value: 'XA_LAO_BAO'
      },
      {
        label: 'Xã Hướng Lập',
        value: 'XA_HUONG_LAP'
      },
      {
        label: 'Xã Hướng Phùng',
        value: 'XA_HUONG_PHUNG'
      },
      {
        label: 'Xã Tân Lập',
        value: 'XA_TAN_LAP'
      },
      {
        label: 'Xã A Dơi',
        value: 'XA_A_DOI'
      },
      {
        label: 'Xã Lìa',
        value: 'XA_LIA'
      },
      {
        label: 'Xã Gio Linh',
        value: 'XA_GIO_LINH'
      },
      {
        label: 'Xã Cửa Việt',
        value: 'XA_CUA_VIET'
      },
      {
        label: 'Xã Bến Hải',
        value: 'XA_BEN_HAI'
      },
      {
        label: 'Xã Cồn Tiên',
        value: 'XA_CON_TIEN'
      },
      {
        label: 'Xã Hướng Hiệp',
        value: 'XA_HUONG_HIEP'
      },
      {
        label: 'Xã Đakrông',
        value: 'XA_DAKRONG'
      },
      {
        label: 'Xã Ba Lòng',
        value: 'XA_BA_LONG'
      },
      {
        label: 'Xã Tà Rụt',
        value: 'XA_TA_RUT'
      },
      {
        label: 'Xã La Lay',
        value: 'XA_LA_LAY'
      },
      {
        label: 'Xã Cam Lộ',
        value: 'XA_CAM_LO'
      },
      {
        label: 'Xã Hiếu Giang',
        value: 'XA_HIEU_GIANG'
      },
      {
        label: 'Xã Triệu Phong',
        value: 'XA_TRIEU_PHONG'
      },
      {
        label: 'Xã Nam Cửa Việt',
        value: 'XA_NAM_CUA_VIET'
      },
      {
        label: 'Xã Triệu Bình',
        value: 'XA_TRIEU_BINH'
      },
      {
        label: 'Xã Triệu Cơ',
        value: 'XA_TRIEU_CO'
      },
      {
        label: 'Xã Ái Tử',
        value: 'XA_AI_TU'
      },
      {
        label: 'Xã Diên Sanh',
        value: 'XA_DIEN_SANH'
      },
      {
        label: 'Xã Vĩnh Định',
        value: 'XA_VINH_DINH'
      },
      {
        label: 'Xã Hải Lăng',
        value: 'XA_HAI_LANG'
      },
      {
        label: 'Xã Nam Hải Lăng',
        value: 'XA_NAM_HAI_LANG'
      },
      {
        label: 'Xã Mỹ Thủy',
        value: 'XA_MY_THUY'
      },
      {
        label: 'Đặc khu Cồn Cỏ',
        value: 'DAC_KHU_CON_CO'
      }
    ]
  },
  {
    label: 'Thành phố Huế',
    value: 'THANH_PHO_HUE',
    children: [
      {
        label: 'Phường Phú Xuân',
        value: 'PHUONG_PHU_XUAN'
      },
      {
        label: 'Phường Vỹ Dạ',
        value: 'PHUONG_VY_DA'
      },
      {
        label: 'Phường Thuận Hóa',
        value: 'PHUONG_THUAN_HOA'
      },
      {
        label: 'Phường Kim Long',
        value: 'PHUONG_KIM_LONG'
      },
      {
        label: 'Phường Thủy Xuân',
        value: 'PHUONG_THUY_XUAN'
      },
      {
        label: 'Phường An Cựu',
        value: 'PHUONG_AN_CUU'
      },
      {
        label: 'Phường Phong Điền',
        value: 'PHUONG_PHONG_DIEN'
      },
      {
        label: 'Phường Phong Phú',
        value: 'PHUONG_PHONG_PHU'
      },
      {
        label: 'Phường Phong Dinh',
        value: 'PHUONG_PHONG_DINH'
      },
      {
        label: 'Phường Phong Thái',
        value: 'PHUONG_PHONG_THAI'
      },
      {
        label: 'Xã Quảng Điền',
        value: 'XA_QUANG_DIEN'
      },
      {
        label: 'Phường Phong Quảng',
        value: 'PHUONG_PHONG_QUANG'
      },
      {
        label: 'Xã Đan Điền',
        value: 'XA_DAN_DIEN'
      },
      {
        label: 'Phường Thuận An',
        value: 'PHUONG_THUAN_AN'
      },
      {
        label: 'Phường Dương Nỗ',
        value: 'PHUONG_DUONG_NO'
      },
      {
        label: 'Xã Phú Hồ',
        value: 'XA_PHU_HO'
      },
      {
        label: 'Phường Mỹ Thượng',
        value: 'PHUONG_MY_THUONG'
      },
      {
        label: 'Xã Phú Vang',
        value: 'XA_PHU_VANG'
      },
      {
        label: 'Xã Phú Vinh',
        value: 'XA_PHU_VINH'
      },
      {
        label: 'Phường Phú Bài',
        value: 'PHUONG_PHU_BAI'
      },
      {
        label: 'Phường Thanh Thủy',
        value: 'PHUONG_THANH_THUY'
      },
      {
        label: 'Phường Hương Thủy',
        value: 'PHUONG_HUONG_THUY'
      },
      {
        label: 'Phường Hương Trà',
        value: 'PHUONG_HUONG_TRA'
      },
      {
        label: 'Phường Hóa Châu',
        value: 'PHUONG_HOA_CHAU'
      },
      {
        label: 'Phường Kim Trà',
        value: 'PHUONG_KIM_TRA'
      },
      {
        label: 'Phường Hương An',
        value: 'PHUONG_HUONG_AN'
      },
      {
        label: 'Xã Bình Điền',
        value: 'XA_BINH_DIEN'
      },
      {
        label: 'Xã A Lưới 2',
        value: 'XA_A_LUOI_2'
      },
      {
        label: 'Xã A Lưới 5',
        value: 'XA_A_LUOI_5'
      },
      {
        label: 'Xã A Lưới 1',
        value: 'XA_A_LUOI_1'
      },
      {
        label: 'Xã A Lưới 3',
        value: 'XA_A_LUOI_3'
      },
      {
        label: 'Xã A Lưới 4',
        value: 'XA_A_LUOI_4'
      },
      {
        label: 'Xã Phú Lộc',
        value: 'XA_PHU_LOC'
      },
      {
        label: 'Xã Vinh Lộc',
        value: 'XA_VINH_LOC'
      },
      {
        label: 'Xã Hưng Lộc',
        value: 'XA_HUNG_LOC'
      },
      {
        label: 'Xã Lộc An',
        value: 'XA_LOC_AN'
      },
      {
        label: 'Xã Chân Mây – Lăng Cô',
        value: 'XA_CHAN_MAY_LANG_CO'
      },
      {
        label: 'Xã Khe Tre',
        value: 'XA_KHE_TRE'
      },
      {
        label: 'Xã Nam Đông',
        value: 'XA_NAM_DONG'
      },
      {
        label: 'Xã Long Quảng',
        value: 'XA_LONG_QUANG'
      }
    ]
  },
  {
    label: 'Thành phố Đà Nẵng',
    value: 'THANH_PHO_DA_NANG',
    children: [
      {
        label: 'Phường Hải Vân',
        value: 'PHUONG_HAI_VAN'
      },
      {
        label: 'Phường Liên Chiểu',
        value: 'PHUONG_LIEN_CHIEU'
      },
      {
        label: 'Phường Hòa Khánh',
        value: 'PHUONG_HOA_KHANH'
      },
      {
        label: 'Phường Thanh Khê',
        value: 'PHUONG_THANH_KHE'
      },
      {
        label: 'Phường An Khê',
        value: 'PHUONG_AN_KHE'
      },
      {
        label: 'Phường Hải Châu',
        value: 'PHUONG_HAI_CHAU'
      },
      {
        label: 'Phường Hòa Cường',
        value: 'PHUONG_HOA_CUONG'
      },
      {
        label: 'Phường Cẩm Lệ',
        value: 'PHUONG_CAM_LE'
      },
      {
        label: 'Phường Sơn Trà',
        value: 'PHUONG_SON_TRA'
      },
      {
        label: 'Phường An Hải',
        value: 'PHUONG_AN_HAI'
      },
      {
        label: 'Phường Ngũ Hành Sơn',
        value: 'PHUONG_NGU_HANH_SON'
      },
      {
        label: 'Xã Bà Nà',
        value: 'XA_BA_NA'
      },
      {
        label: 'Phường Hòa Xuân',
        value: 'PHUONG_HOA_XUAN'
      },
      {
        label: 'Xã Hòa Vang',
        value: 'XA_HOA_VANG'
      },
      {
        label: 'Xã Hòa Tiến',
        value: 'XA_HOA_TIEN'
      },
      {
        label: 'Đặc khu Hoàng Sa',
        value: 'DAC_KHU_HOANG_SA'
      },
      {
        label: 'Phường Bàn Thạch',
        value: 'PHUONG_BAN_THACH'
      },
      {
        label: 'Phường Tam Kỳ',
        value: 'PHUONG_TAM_KY'
      },
      {
        label: 'Phường Hương Trà',
        value: 'PHUONG_HUONG_TRA'
      },
      {
        label: 'Phường Quảng Phú',
        value: 'PHUONG_QUANG_PHU'
      },
      {
        label: 'Xã Chiên Đàn',
        value: 'XA_CHIEN_DAN'
      },
      {
        label: 'Xã Tây Hồ',
        value: 'XA_TAY_HO'
      },
      {
        label: 'Xã Phú Ninh',
        value: 'XA_PHU_NINH'
      },
      {
        label: 'Phường Hội An Tây',
        value: 'PHUONG_HOI_AN_TAY'
      },
      {
        label: 'Phường Hội An',
        value: 'PHUONG_HOI_AN'
      },
      {
        label: 'Phường Hội An Đông',
        value: 'PHUONG_HOI_AN_DONG'
      },
      {
        label: 'Xã Tân Hiệp',
        value: 'XA_TAN_HIEP'
      },
      {
        label: 'Xã Hùng Sơn',
        value: 'XA_HUNG_SON'
      },
      {
        label: 'Xã Tây Giang',
        value: 'XA_TAY_GIANG'
      },
      {
        label: 'Xã Avương',
        value: 'XA_AVUONG'
      },
      {
        label: 'Xã Đông Giang',
        value: 'XA_DONG_GIANG'
      },
      {
        label: 'Xã Sông Kôn',
        value: 'XA_SONG_KON'
      },
      {
        label: 'Xã Sông Vàng',
        value: 'XA_SONG_VANG'
      },
      {
        label: 'Xã Bến Hiên',
        value: 'XA_BEN_HIEN'
      },
      {
        label: 'Xã Đại Lộc',
        value: 'XA_DAI_LOC'
      },
      {
        label: 'Xã Thượng Đức',
        value: 'XA_THUONG_DUC'
      },
      {
        label: 'Xã Hà Nha',
        value: 'XA_HA_NHA'
      },
      {
        label: 'Xã Vu Gia',
        value: 'XA_VU_GIA'
      },
      {
        label: 'Xã Phú Thuận',
        value: 'XA_PHU_THUAN'
      },
      {
        label: 'Phường Điện Bàn',
        value: 'PHUONG_DIEN_BAN'
      },
      {
        label: 'Phường Điện Bàn Bắc',
        value: 'PHUONG_DIEN_BAN_BAC'
      },
      {
        label: 'Xã Điện Bàn Tây',
        value: 'XA_DIEN_BAN_TAY'
      },
      {
        label: 'Phường An Thắng',
        value: 'PHUONG_AN_THANG'
      },
      {
        label: 'Phường Điện Bàn Đông',
        value: 'PHUONG_DIEN_BAN_DONG'
      },
      {
        label: 'Xã Gò Nổi',
        value: 'XA_GO_NOI'
      },
      {
        label: 'Xã Nam Phước',
        value: 'XA_NAM_PHUOC'
      },
      {
        label: 'Xã Thu Bồn',
        value: 'XA_THU_BON'
      },
      {
        label: 'Xã Duy Xuyên',
        value: 'XA_DUY_XUYEN'
      },
      {
        label: 'Xã Duy Nghĩa',
        value: 'XA_DUY_NGHIA'
      },
      {
        label: 'Xã Quế Sơn',
        value: 'XA_QUE_SON'
      },
      {
        label: 'Xã Xuân Phú',
        value: 'XA_XUAN_PHU'
      },
      {
        label: 'Xã Nông Sơn',
        value: 'XA_NONG_SON'
      },
      {
        label: 'Xã Quế Sơn Trung',
        value: 'XA_QUE_SON_TRUNG'
      },
      {
        label: 'Xã Quế Phước',
        value: 'XA_QUE_PHUOC'
      },
      {
        label: 'Xã Thạnh Mỹ',
        value: 'XA_THANH_MY'
      },
      {
        label: 'Xã La Êê',
        value: 'XA_LA_EE'
      },
      {
        label: 'Xã La Dêê',
        value: 'XA_LA_DEE'
      },
      {
        label: 'Xã Nam Giang',
        value: 'XA_NAM_GIANG'
      },
      {
        label: 'Xã Bến Giằng',
        value: 'XA_BEN_GIANG'
      },
      {
        label: 'Xã Đắc Pring',
        value: 'XA_DAC_PRING'
      },
      {
        label: 'Xã Khâm Đức',
        value: 'XA_KHAM_DUC'
      },
      {
        label: 'Xã Phước Hiệp',
        value: 'XA_PHUOC_HIEP'
      },
      {
        label: 'Xã Phước Năng',
        value: 'XA_PHUOC_NANG'
      },
      {
        label: 'Xã Phước Chánh',
        value: 'XA_PHUOC_CHANH'
      },
      {
        label: 'Xã Phước Thành',
        value: 'XA_PHUOC_THANH'
      },
      {
        label: 'Xã Việt An',
        value: 'XA_VIET_AN'
      },
      {
        label: 'Xã Phước Trà',
        value: 'XA_PHUOC_TRA'
      },
      {
        label: 'Xã Hiệp Đức',
        value: 'XA_HIEP_DUC'
      },
      {
        label: 'Xã Thăng Bình',
        value: 'XA_THANG_BINH'
      },
      {
        label: 'Xã Thăng An',
        value: 'XA_THANG_AN'
      },
      {
        label: 'Xã Đồng Dương',
        value: 'XA_DONG_DUONG'
      },
      {
        label: 'Xã Thăng Phú',
        value: 'XA_THANG_PHU'
      },
      {
        label: 'Xã Thăng Trường',
        value: 'XA_THANG_TRUONG'
      },
      {
        label: 'Xã Thăng Điền',
        value: 'XA_THANG_DIEN'
      },
      {
        label: 'Xã Tiên Phước',
        value: 'XA_TIEN_PHUOC'
      },
      {
        label: 'Xã Sơn Cẩm Hà',
        value: 'XA_SON_CAM_HA'
      },
      {
        label: 'Xã Lãnh Ngọc',
        value: 'XA_LANH_NGOC'
      },
      {
        label: 'Xã Thạnh Bình',
        value: 'XA_THANH_BINH'
      },
      {
        label: 'Xã Trà My',
        value: 'XA_TRA_MY'
      },
      {
        label: 'Xã Trà Liên',
        value: 'XA_TRA_LIEN'
      },
      {
        label: 'Xã Trà Đốc',
        value: 'XA_TRA_DOC'
      },
      {
        label: 'Xã Trà Tân',
        value: 'XA_TRA_TAN'
      },
      {
        label: 'Xã Trà Giáp',
        value: 'XA_TRA_GIAP'
      },
      {
        label: 'Xã Trà Leng',
        value: 'XA_TRA_LENG'
      },
      {
        label: 'Xã Trà Tập',
        value: 'XA_TRA_TAP'
      },
      {
        label: 'Xã Nam Trà My',
        value: 'XA_NAM_TRA_MY'
      },
      {
        label: 'Xã Trà Linh',
        value: 'XA_TRA_LINH'
      },
      {
        label: 'Xã Trà Vân',
        value: 'XA_TRA_VAN'
      },
      {
        label: 'Xã Núi Thành',
        value: 'XA_NUI_THANH'
      },
      {
        label: 'Xã Tam Xuân',
        value: 'XA_TAM_XUAN'
      },
      {
        label: 'Xã Đức Phú',
        value: 'XA_DUC_PHU'
      },
      {
        label: 'Xã Tam Anh',
        value: 'XA_TAM_ANH'
      },
      {
        label: 'Xã Tam Hải',
        value: 'XA_TAM_HAI'
      },
      {
        label: 'Xã Tam Mỹ',
        value: 'XA_TAM_MY'
      }
    ]
  },
  {
    label: 'Quảng Ngãi',
    value: 'QUANG_NGAI',
    children: [
      {
        label: 'Phường Cẩm Thành',
        value: 'PHUONG_CAM_THANH'
      },
      {
        label: 'Phường Nghĩa Lộ',
        value: 'PHUONG_NGHIA_LO'
      },
      {
        label: 'Xã An Phú',
        value: 'XA_AN_PHU'
      },
      {
        label: 'Xã Bình Sơn',
        value: 'XA_BINH_SON'
      },
      {
        label: 'Xã Vạn Tường',
        value: 'XA_VAN_TUONG'
      },
      {
        label: 'Xã Bình Minh',
        value: 'XA_BINH_MINH'
      },
      {
        label: 'Xã Bình Chương',
        value: 'XA_BINH_CHUONG'
      },
      {
        label: 'Xã Đông Sơn',
        value: 'XA_DONG_SON'
      },
      {
        label: 'Xã Trà Bồng',
        value: 'XA_TRA_BONG'
      },
      {
        label: 'Xã Thanh Bồng',
        value: 'XA_THANH_BONG'
      },
      {
        label: 'Xã Đông Trà Bồng',
        value: 'XA_DONG_TRA_BONG'
      },
      {
        label: 'Xã Cà Đam',
        value: 'XA_CA_DAM'
      },
      {
        label: 'Xã Tây Trà',
        value: 'XA_TAY_TRA'
      },
      {
        label: 'Xã Tây Trà Bồng',
        value: 'XA_TAY_TRA_BONG'
      },
      {
        label: 'Phường Trương Quang Trọng',
        value: 'PHUONG_TRUONG_QUANG_TRONG'
      },
      {
        label: 'Xã Thọ Phong',
        value: 'XA_THO_PHONG'
      },
      {
        label: 'Xã Trường Giang',
        value: 'XA_TRUONG_GIANG'
      },
      {
        label: 'Xã Ba Gia',
        value: 'XA_BA_GIA'
      },
      {
        label: 'Xã Tịnh Khê',
        value: 'XA_TINH_KHE'
      },
      {
        label: 'Xã Sơn Tịnh',
        value: 'XA_SON_TINH'
      },
      {
        label: 'Xã Tư Nghĩa',
        value: 'XA_TU_NGHIA'
      },
      {
        label: 'Xã Vệ Giang',
        value: 'XA_VE_GIANG'
      },
      {
        label: 'Xã Trà Giang',
        value: 'XA_TRA_GIANG'
      },
      {
        label: 'Xã Nghĩa Giang',
        value: 'XA_NGHIA_GIANG'
      },
      {
        label: 'Xã Sơn Hà',
        value: 'XA_SON_HA'
      },
      {
        label: 'Xã Sơn Hạ',
        value: 'XA_SON_HA'
      },
      {
        label: 'Xã Sơn Linh',
        value: 'XA_SON_LINH'
      },
      {
        label: 'Xã Sơn Thủy',
        value: 'XA_SON_THUY'
      },
      {
        label: 'Xã Sơn Kỳ',
        value: 'XA_SON_KY'
      },
      {
        label: 'Xã Sơn Tây Thượng',
        value: 'XA_SON_TAY_THUONG'
      },
      {
        label: 'Xã Sơn Tây',
        value: 'XA_SON_TAY'
      },
      {
        label: 'Xã Sơn Tây Hạ',
        value: 'XA_SON_TAY_HA'
      },
      {
        label: 'Xã Sơn Mai',
        value: 'XA_SON_MAI'
      },
      {
        label: 'Xã Minh Long',
        value: 'XA_MINH_LONG'
      },
      {
        label: 'Xã Nghĩa Hành',
        value: 'XA_NGHIA_HANH'
      },
      {
        label: 'Xã Phước Giang',
        value: 'XA_PHUOC_GIANG'
      },
      {
        label: 'Xã Đình Cương',
        value: 'XA_DINH_CUONG'
      },
      {
        label: 'Xã Thiện Tín',
        value: 'XA_THIEN_TIN'
      },
      {
        label: 'Xã Mộ Đức',
        value: 'XA_MO_DUC'
      },
      {
        label: 'Xã Long Phụng',
        value: 'XA_LONG_PHUNG'
      },
      {
        label: 'Xã Mỏ Cày',
        value: 'XA_MO_CAY'
      },
      {
        label: 'Xã Lân Phong',
        value: 'XA_LAN_PHONG'
      },
      {
        label: 'Phường Đức Phổ',
        value: 'PHUONG_DUC_PHO'
      },
      {
        label: 'Phường Trà Câu',
        value: 'PHUONG_TRA_CAU'
      },
      {
        label: 'Xã Nguyễn Nghiêm',
        value: 'XA_NGUYEN_NGHIEM'
      },
      {
        label: 'Xã Khánh Cường',
        value: 'XA_KHANH_CUONG'
      },
      {
        label: 'Phường Sa Huỳnh',
        value: 'PHUONG_SA_HUYNH'
      },
      {
        label: 'Xã Ba Tơ',
        value: 'XA_BA_TO'
      },
      {
        label: 'Xã Ba Vinh',
        value: 'XA_BA_VINH'
      },
      {
        label: 'Xã Ba Động',
        value: 'XA_BA_DONG'
      },
      {
        label: 'Xã Ba Dinh',
        value: 'XA_BA_DINH'
      },
      {
        label: 'Xã Đặng Thùy Trâm',
        value: 'XA_DANG_THUY_TRAM'
      },
      {
        label: 'Xã Ba Tô',
        value: 'XA_BA_TO'
      },
      {
        label: 'Xã Ba Vì',
        value: 'XA_BA_VI'
      },
      {
        label: 'Xã Ba Xa',
        value: 'XA_BA_XA'
      },
      {
        label: 'Đặc khu Lý Sơn',
        value: 'DAC_KHU_LY_SON'
      },
      {
        label: 'Phường Đăk Cấm',
        value: 'PHUONG_DAK_CAM'
      },
      {
        label: 'Phường Kon Tum',
        value: 'PHUONG_KON_TUM'
      },
      {
        label: 'Phường Đăk BLa',
        value: 'PHUONG_DAK_BLA'
      },
      {
        label: 'Xã Ngọk Bay',
        value: 'XA_NGOK_BAY'
      },
      {
        label: 'Xã Ia Chim',
        value: 'XA_IA_CHIM'
      },
      {
        label: 'Xã Đăk Rơ Wa',
        value: 'XA_DAK_RO_WA'
      },
      {
        label: 'Xã Đăk Pék',
        value: 'XA_DAK_PEK'
      },
      {
        label: 'Xã Đăk Plô',
        value: 'XA_DAK_PLO'
      },
      {
        label: 'Xã Xốp',
        value: 'XA_XOP'
      },
      {
        label: 'Xã Ngọc Linh',
        value: 'XA_NGOC_LINH'
      },
      {
        label: 'Xã Đăk Long',
        value: 'XA_DAK_LONG'
      },
      {
        label: 'Xã Đăk Môn',
        value: 'XA_DAK_MON'
      },
      {
        label: 'Xã Bờ Y',
        value: 'XA_BO_Y'
      },
      {
        label: 'Xã Dục Nông',
        value: 'XA_DUC_NONG'
      },
      {
        label: 'Xã Sa Loong',
        value: 'XA_SA_LOONG'
      },
      {
        label: 'Xã Đăk Tô',
        value: 'XA_DAK_TO'
      },
      {
        label: 'Xã Đăk Sao',
        value: 'XA_DAK_SAO'
      },
      {
        label: 'Xã Đăk Tờ Kan',
        value: 'XA_DAK_TO_KAN'
      },
      {
        label: 'Xã Tu Mơ Rông',
        value: 'XA_TU_MO_RONG'
      },
      {
        label: 'Xã Ngọk Tụ',
        value: 'XA_NGOK_TU'
      },
      {
        label: 'Xã Kon Đào',
        value: 'XA_KON_DAO'
      },
      {
        label: 'Xã Măng Ri',
        value: 'XA_MANG_RI'
      },
      {
        label: 'Xã Măng Bút',
        value: 'XA_MANG_BUT'
      },
      {
        label: 'Xã Măng Đen',
        value: 'XA_MANG_DEN'
      },
      {
        label: 'Xã Kon Plông',
        value: 'XA_KON_PLONG'
      },
      {
        label: 'Xã Đăk Rve',
        value: 'XA_DAK_RVE'
      },
      {
        label: 'Xã Đăk Kôi',
        value: 'XA_DAK_KOI'
      },
      {
        label: 'Xã Kon Braih',
        value: 'XA_KON_BRAIH'
      },
      {
        label: 'Xã Đăk Hà',
        value: 'XA_DAK_HA'
      },
      {
        label: 'Xã Đăk Pxi',
        value: 'XA_DAK_PXI'
      },
      {
        label: 'Xã Đăk Ui',
        value: 'XA_DAK_UI'
      },
      {
        label: 'Xã Đăk Mar',
        value: 'XA_DAK_MAR'
      },
      {
        label: 'Xã Ngọk Réo',
        value: 'XA_NGOK_REO'
      },
      {
        label: 'Xã Sa Thầy',
        value: 'XA_SA_THAY'
      },
      {
        label: 'Xã Rờ Kơi',
        value: 'XA_RO_KOI'
      },
      {
        label: 'Xã Sa Bình',
        value: 'XA_SA_BINH'
      },
      {
        label: 'Xã Ia Đal',
        value: 'XA_IA_DAL'
      },
      {
        label: 'Xã Mô Rai',
        value: 'XA_MO_RAI'
      },
      {
        label: 'Xã Ia Tơi',
        value: 'XA_IA_TOI'
      },
      {
        label: 'Xã Ya Ly',
        value: 'XA_YA_LY'
      }
    ]
  },
  {
    label: 'Gia Lai',
    value: 'GIA_LAI',
    children: [
      {
        label: 'Phường Quy Nhơn Bắc',
        value: 'PHUONG_QUY_NHON_BAC'
      },
      {
        label: 'Phường Quy Nhơn',
        value: 'PHUONG_QUY_NHON'
      },
      {
        label: 'Phường Quy Nhơn Tây',
        value: 'PHUONG_QUY_NHON_TAY'
      },
      {
        label: 'Phường Quy Nhơn Nam',
        value: 'PHUONG_QUY_NHON_NAM'
      },
      {
        label: 'Phường Quy Nhơn Đông',
        value: 'PHUONG_QUY_NHON_DONG'
      },
      {
        label: 'Xã Nhơn Châu',
        value: 'XA_NHON_CHAU'
      },
      {
        label: 'Xã An Lão',
        value: 'XA_AN_LAO'
      },
      {
        label: 'Xã An Vinh',
        value: 'XA_AN_VINH'
      },
      {
        label: 'Xã An Toàn',
        value: 'XA_AN_TOAN'
      },
      {
        label: 'Xã An Hòa',
        value: 'XA_AN_HOA'
      },
      {
        label: 'Phường Tam Quan',
        value: 'PHUONG_TAM_QUAN'
      },
      {
        label: 'Phường Bồng Sơn',
        value: 'PHUONG_BONG_SON'
      },
      {
        label: 'Phường Hoài Nhơn Bắc',
        value: 'PHUONG_HOAI_NHON_BAC'
      },
      {
        label: 'Phường Hoài Nhơn Tây',
        value: 'PHUONG_HOAI_NHON_TAY'
      },
      {
        label: 'Phường Hoài Nhơn',
        value: 'PHUONG_HOAI_NHON'
      },
      {
        label: 'Phường Hoài Nhơn Đông',
        value: 'PHUONG_HOAI_NHON_DONG'
      },
      {
        label: 'Phường Hoài Nhơn Nam',
        value: 'PHUONG_HOAI_NHON_NAM'
      },
      {
        label: 'Xã Hoài Ân',
        value: 'XA_HOAI_AN'
      },
      {
        label: 'Xã Ân Hảo',
        value: 'XA_AN_HAO'
      },
      {
        label: 'Xã Vạn Đức',
        value: 'XA_VAN_DUC'
      },
      {
        label: 'Xã Ân Tường',
        value: 'XA_AN_TUONG'
      },
      {
        label: 'Xã Kim Sơn',
        value: 'XA_KIM_SON'
      },
      {
        label: 'Xã Phù Mỹ',
        value: 'XA_PHU_MY'
      },
      {
        label: 'Xã Bình Dương',
        value: 'XA_BINH_DUONG'
      },
      {
        label: 'Xã Phù Mỹ Bắc',
        value: 'XA_PHU_MY_BAC'
      },
      {
        label: 'Xã Phù Mỹ Đông',
        value: 'XA_PHU_MY_DONG'
      },
      {
        label: 'Xã Phù Mỹ Tây',
        value: 'XA_PHU_MY_TAY'
      },
      {
        label: 'Xã An Lương',
        value: 'XA_AN_LUONG'
      },
      {
        label: 'Xã Phù Mỹ Nam',
        value: 'XA_PHU_MY_NAM'
      },
      {
        label: 'Xã Vĩnh Thạnh',
        value: 'XA_VINH_THANH'
      },
      {
        label: 'Xã Vĩnh Sơn',
        value: 'XA_VINH_SON'
      },
      {
        label: 'Xã Vĩnh Thịnh',
        value: 'XA_VINH_THINH'
      },
      {
        label: 'Xã Vĩnh Quang',
        value: 'XA_VINH_QUANG'
      },
      {
        label: 'Xã Tây Sơn',
        value: 'XA_TAY_SON'
      },
      {
        label: 'Xã Bình Hiệp',
        value: 'XA_BINH_HIEP'
      },
      {
        label: 'Xã Bình Khê',
        value: 'XA_BINH_KHE'
      },
      {
        label: 'Xã Bình An',
        value: 'XA_BINH_AN'
      },
      {
        label: 'Xã Bình Phú',
        value: 'XA_BINH_PHU'
      },
      {
        label: 'Xã Phù Cát',
        value: 'XA_PHU_CAT'
      },
      {
        label: 'Xã Đề Gi',
        value: 'XA_DE_GI'
      },
      {
        label: 'Xã Hội Sơn',
        value: 'XA_HOI_SON'
      },
      {
        label: 'Xã Hòa Hội',
        value: 'XA_HOA_HOI'
      },
      {
        label: 'Xã Ngô Mây',
        value: 'XA_NGO_MAY'
      },
      {
        label: 'Xã Xuân An',
        value: 'XA_XUAN_AN'
      },
      {
        label: 'Xã Cát Tiến',
        value: 'XA_CAT_TIEN'
      },
      {
        label: 'Phường Bình Định',
        value: 'PHUONG_BINH_DINH'
      },
      {
        label: 'Phường An Nhơn',
        value: 'PHUONG_AN_NHON'
      },
      {
        label: 'Phường An Nhơn Bắc',
        value: 'PHUONG_AN_NHON_BAC'
      },
      {
        label: 'Phường An Nhơn Đông',
        value: 'PHUONG_AN_NHON_DONG'
      },
      {
        label: 'Xã An Nhơn Tây',
        value: 'XA_AN_NHON_TAY'
      },
      {
        label: 'Phường An Nhơn Nam',
        value: 'PHUONG_AN_NHON_NAM'
      },
      {
        label: 'Xã Tuy Phước',
        value: 'XA_TUY_PHUOC'
      },
      {
        label: 'Xã Tuy Phước Bắc',
        value: 'XA_TUY_PHUOC_BAC'
      },
      {
        label: 'Xã Tuy Phước Đông',
        value: 'XA_TUY_PHUOC_DONG'
      },
      {
        label: 'Xã Tuy Phước Tây',
        value: 'XA_TUY_PHUOC_TAY'
      },
      {
        label: 'Xã Vân Canh',
        value: 'XA_VAN_CANH'
      },
      {
        label: 'Xã Canh Liên',
        value: 'XA_CANH_LIEN'
      },
      {
        label: 'Xã Canh Vinh',
        value: 'XA_CANH_VINH'
      },
      {
        label: 'Phường Diên Hồng',
        value: 'PHUONG_DIEN_HONG'
      },
      {
        label: 'Phường Pleiku',
        value: 'PHUONG_PLEIKU'
      },
      {
        label: 'Phường Thống Nhất',
        value: 'PHUONG_THONG_NHAT'
      },
      {
        label: 'Phường Hội Phú',
        value: 'PHUONG_HOI_PHU'
      },
      {
        label: 'Xã Biển Hồ',
        value: 'XA_BIEN_HO'
      },
      {
        label: 'Phường An Phú',
        value: 'PHUONG_AN_PHU'
      },
      {
        label: 'Xã Gào',
        value: 'XA_GAO'
      },
      {
        label: 'Phường An Bình',
        value: 'PHUONG_AN_BINH'
      },
      {
        label: 'Phường An Khê',
        value: 'PHUONG_AN_KHE'
      },
      {
        label: 'Xã Cửu An',
        value: 'XA_CUU_AN'
      },
      {
        label: 'Xã Kbang',
        value: 'XA_KBANG'
      },
      {
        label: 'Xã Đak Rong',
        value: 'XA_DAK_RONG'
      },
      {
        label: 'Xã Sơn Lang',
        value: 'XA_SON_LANG'
      },
      {
        label: 'Xã Krong',
        value: 'XA_KRONG'
      },
      {
        label: 'Xã Tơ Tung',
        value: 'XA_TO_TUNG'
      },
      {
        label: 'Xã Kông Bơ La',
        value: 'XA_KONG_BO_LA'
      },
      {
        label: 'Xã Đak Đoa',
        value: 'XA_DAK_DOA'
      },
      {
        label: 'Xã Đak Sơmei',
        value: 'XA_DAK_SOMEI'
      },
      {
        label: 'Xã Kon Gang',
        value: 'XA_KON_GANG'
      },
      {
        label: 'Xã Ia Băng',
        value: 'XA_IA_BANG'
      },
      {
        label: 'Xã KDang',
        value: 'XA_KDANG'
      },
      {
        label: 'Xã Chư Păh',
        value: 'XA_CHU_PAH'
      },
      {
        label: 'Xã Ia Khươl',
        value: 'XA_IA_KHUOL'
      },
      {
        label: 'Xã Ia Ly',
        value: 'XA_IA_LY'
      },
      {
        label: 'Xã Ia Mơ',
        value: 'XA_IA_MO'
      },
      {
        label: 'Xã Ia Phí',
        value: 'XA_IA_PHI'
      },
      {
        label: 'Xã Ia Grai',
        value: 'XA_IA_GRAI'
      },
      {
        label: 'Xã Ia Hrung',
        value: 'XA_IA_HRUNG'
      },
      {
        label: 'Xã Ia Krái',
        value: 'XA_IA_KRAI'
      },
      {
        label: 'Xã Ia O',
        value: 'XA_IA_O'
      },
      {
        label: 'Xã Ia Chia',
        value: 'XA_IA_CHIA'
      },
      {
        label: 'Xã Mang Yang',
        value: 'XA_MANG_YANG'
      },
      {
        label: 'Xã Ayun',
        value: 'XA_AYUN'
      },
      {
        label: 'Xã Hra',
        value: 'XA_HRA'
      },
      {
        label: 'Xã Lơ Pang',
        value: 'XA_LO_PANG'
      },
      {
        label: 'Xã Kon Chiêng',
        value: 'XA_KON_CHIENG'
      },
      {
        label: 'Xã Kông Chro',
        value: 'XA_KONG_CHRO'
      },
      {
        label: 'Xã Chư Krey',
        value: 'XA_CHU_KREY'
      },
      {
        label: 'Xã Ya Ma',
        value: 'XA_YA_MA'
      },
      {
        label: 'Xã SRó',
        value: 'XA_SRO'
      },
      {
        label: 'Xã Đăk Song',
        value: 'XA_DAK_SONG'
      },
      {
        label: 'Xã Chơ Long',
        value: 'XA_CHO_LONG'
      },
      {
        label: 'Xã Đức Cơ',
        value: 'XA_DUC_CO'
      },
      {
        label: 'Xã Ia Krêl',
        value: 'XA_IA_KREL'
      },
      {
        label: 'Xã Ia Dơk',
        value: 'XA_IA_DOK'
      },
      {
        label: 'Xã Ia Dom',
        value: 'XA_IA_DOM'
      },
      {
        label: 'Xã Ia Pnôn',
        value: 'XA_IA_PNON'
      },
      {
        label: 'Xã Ia Nan',
        value: 'XA_IA_NAN'
      },
      {
        label: 'Xã Chư Prông',
        value: 'XA_CHU_PRONG'
      },
      {
        label: 'Xã Bàu Cạn',
        value: 'XA_BAU_CAN'
      },
      {
        label: 'Xã Ia Tôr',
        value: 'XA_IA_TOR'
      },
      {
        label: 'Xã Ia Boòng',
        value: 'XA_IA_BOONG'
      },
      {
        label: 'Xã Ia Púch',
        value: 'XA_IA_PUCH'
      },
      {
        label: 'Xã Ia Pia',
        value: 'XA_IA_PIA'
      },
      {
        label: 'Xã Ia Lâu',
        value: 'XA_IA_LAU'
      },
      {
        label: 'Xã Chư Sê',
        value: 'XA_CHU_SE'
      },
      {
        label: 'Xã Chư Pưh',
        value: 'XA_CHU_PUH'
      },
      {
        label: 'Xã Bờ Ngoong',
        value: 'XA_BO_NGOONG'
      },
      {
        label: 'Xã Albá',
        value: 'XA_ALBA'
      },
      {
        label: 'Xã Ia Hrú',
        value: 'XA_IA_HRU'
      },
      {
        label: 'Xã Ia Ko',
        value: 'XA_IA_KO'
      },
      {
        label: 'Xã Ia Le',
        value: 'XA_IA_LE'
      },
      {
        label: 'Xã Đak Pơ',
        value: 'XA_DAK_PO'
      },
      {
        label: 'Xã Ya Hội',
        value: 'XA_YA_HOI'
      },
      {
        label: 'Xã Pờ Tó',
        value: 'XA_PO_TO'
      },
      {
        label: 'Xã Ia Pa',
        value: 'XA_IA_PA'
      },
      {
        label: 'Xã Ia Tul',
        value: 'XA_IA_TUL'
      },
      {
        label: 'Xã Phú Thiện',
        value: 'XA_PHU_THIEN'
      },
      {
        label: 'Phường Ayun Pa',
        value: 'PHUONG_AYUN_PA'
      },
      {
        label: 'Xã Chư A Thai',
        value: 'XA_CHU_A_THAI'
      },
      {
        label: 'Xã Ia Hiao',
        value: 'XA_IA_HIAO'
      },
      {
        label: 'Xã Ia Rbol',
        value: 'XA_IA_RBOL'
      },
      {
        label: 'Xã Ia Sao',
        value: 'XA_IA_SAO'
      },
      {
        label: 'Xã Phú Túc',
        value: 'XA_PHU_TUC'
      },
      {
        label: 'Xã Ia Dreh',
        value: 'XA_IA_DREH'
      },
      {
        label: 'Xã Uar',
        value: 'XA_UAR'
      },
      {
        label: 'Xã Ia Rsai',
        value: 'XA_IA_RSAI'
      }
    ]
  },
  {
    label: 'Khánh Hòa',
    value: 'KHANH_HOA',
    children: [
      {
        label: 'Phường Bắc Nha Trang',
        value: 'PHUONG_BAC_NHA_TRANG'
      },
      {
        label: 'Phường Nha Trang',
        value: 'PHUONG_NHA_TRANG'
      },
      {
        label: 'Phường Tây Nha Trang',
        value: 'PHUONG_TAY_NHA_TRANG'
      },
      {
        label: 'Phường Nam Nha Trang',
        value: 'PHUONG_NAM_NHA_TRANG'
      },
      {
        label: 'Phường Bắc Cam Ranh',
        value: 'PHUONG_BAC_CAM_RANH'
      },
      {
        label: 'Phường Cam Ranh',
        value: 'PHUONG_CAM_RANH'
      },
      {
        label: 'Phường Ba Ngòi',
        value: 'PHUONG_BA_NGOI'
      },
      {
        label: 'Phường Cam Linh',
        value: 'PHUONG_CAM_LINH'
      },
      {
        label: 'Xã Cam Hiệp',
        value: 'XA_CAM_HIEP'
      },
      {
        label: 'Xã Cam Lâm',
        value: 'XA_CAM_LAM'
      },
      {
        label: 'Xã Cam An',
        value: 'XA_CAM_AN'
      },
      {
        label: 'Xã Nam Cam Ranh',
        value: 'XA_NAM_CAM_RANH'
      },
      {
        label: 'Xã Vạn Ninh',
        value: 'XA_VAN_NINH'
      },
      {
        label: 'Xã Tu Bông',
        value: 'XA_TU_BONG'
      },
      {
        label: 'Xã Đại Lãnh',
        value: 'XA_DAI_LANH'
      },
      {
        label: 'Xã Vạn Thắng',
        value: 'XA_VAN_THANG'
      },
      {
        label: 'Xã Vạn Hưng',
        value: 'XA_VAN_HUNG'
      },
      {
        label: 'Phường Ninh Hòa',
        value: 'PHUONG_NINH_HOA'
      },
      {
        label: 'Xã Bắc Ninh Hòa',
        value: 'XA_BAC_NINH_HOA'
      },
      {
        label: 'Xã Tây Ninh Hòa',
        value: 'XA_TAY_NINH_HOA'
      },
      {
        label: 'Xã Hòa Trí',
        value: 'XA_HOA_TRI'
      },
      {
        label: 'Phường Đông Ninh Hòa',
        value: 'PHUONG_DONG_NINH_HOA'
      },
      {
        label: 'Xã Tân Định',
        value: 'XA_TAN_DINH'
      },
      {
        label: 'Phường Hòa Thắng',
        value: 'PHUONG_HOA_THANG'
      },
      {
        label: 'Xã Nam Ninh Hòa',
        value: 'XA_NAM_NINH_HOA'
      },
      {
        label: 'Xã Khánh Vĩnh',
        value: 'XA_KHANH_VINH'
      },
      {
        label: 'Xã Trung Khánh Vĩnh',
        value: 'XA_TRUNG_KHANH_VINH'
      },
      {
        label: 'Xã Bắc Khánh Vĩnh',
        value: 'XA_BAC_KHANH_VINH'
      },
      {
        label: 'Xã Tây Khánh Vĩnh',
        value: 'XA_TAY_KHANH_VINH'
      },
      {
        label: 'Xã Nam Khánh Vĩnh',
        value: 'XA_NAM_KHANH_VINH'
      },
      {
        label: 'Xã Diên Khánh',
        value: 'XA_DIEN_KHANH'
      },
      {
        label: 'Xã Diên Điền',
        value: 'XA_DIEN_DIEN'
      },
      {
        label: 'Xã Diên Lâm',
        value: 'XA_DIEN_LAM'
      },
      {
        label: 'Xã Diên Thọ',
        value: 'XA_DIEN_THO'
      },
      {
        label: 'Xã Diên Lạc',
        value: 'XA_DIEN_LAC'
      },
      {
        label: 'Xã Suối Hiệp',
        value: 'XA_SUOI_HIEP'
      },
      {
        label: 'Xã Suối Dầu',
        value: 'XA_SUOI_DAU'
      },
      {
        label: 'Xã Khánh Sơn',
        value: 'XA_KHANH_SON'
      },
      {
        label: 'Xã Tây Khánh Sơn',
        value: 'XA_TAY_KHANH_SON'
      },
      {
        label: 'Xã Đông Khánh Sơn',
        value: 'XA_DONG_KHANH_SON'
      },
      {
        label: 'Đặc khu Trường Sa',
        value: 'DAC_KHU_TRUONG_SA'
      },
      {
        label: 'Phường Đô Vinh',
        value: 'PHUONG_DO_VINH'
      },
      {
        label: 'Phường Bảo An',
        value: 'PHUONG_BAO_AN'
      },
      {
        label: 'Phường Phan Rang',
        value: 'PHUONG_PHAN_RANG'
      },
      {
        label: 'Phường Đông Hải',
        value: 'PHUONG_DONG_HAI'
      },
      {
        label: 'Xã Bác Ái Tây',
        value: 'XA_BAC_AI_TAY'
      },
      {
        label: 'Xã Bác Ái',
        value: 'XA_BAC_AI'
      },
      {
        label: 'Xã Bác Ái Đông',
        value: 'XA_BAC_AI_DONG'
      },
      {
        label: 'Xã Ninh Sơn',
        value: 'XA_NINH_SON'
      },
      {
        label: 'Xã Lâm Sơn',
        value: 'XA_LAM_SON'
      },
      {
        label: 'Xã Mỹ Sơn',
        value: 'XA_MY_SON'
      },
      {
        label: 'Xã Anh Dũng',
        value: 'XA_ANH_DUNG'
      },
      {
        label: 'Phường Ninh Chử',
        value: 'PHUONG_NINH_CHU'
      },
      {
        label: 'Xã Công Hải',
        value: 'XA_CONG_HAI'
      },
      {
        label: 'Xã Thuận Bắc',
        value: 'XA_THUAN_BAC'
      },
      {
        label: 'Xã Ninh Hải',
        value: 'XA_NINH_HAI'
      },
      {
        label: 'Xã Xuân Hải',
        value: 'XA_XUAN_HAI'
      },
      {
        label: 'Xã Vĩnh Hải',
        value: 'XA_VINH_HAI'
      },
      {
        label: 'Xã Ninh Phước',
        value: 'XA_NINH_PHUOC'
      },
      {
        label: 'Xã Phước Hậu',
        value: 'XA_PHUOC_HAU'
      },
      {
        label: 'Xã Phước Hà',
        value: 'XA_PHUOC_HA'
      },
      {
        label: 'Xã Phước Hữu',
        value: 'XA_PHUOC_HUU'
      },
      {
        label: 'Xã Thuận Nam',
        value: 'XA_THUAN_NAM'
      },
      {
        label: 'Xã Phước Dinh',
        value: 'XA_PHUOC_DINH'
      },
      {
        label: 'Xã Cà Ná',
        value: 'XA_CA_NA'
      }
    ]
  },
  {
    label: 'Đắk Lắk',
    value: 'DAK_LAK',
    children: [
      {
        label: 'Phường Tuy Hòa',
        value: 'PHUONG_TUY_HOA'
      },
      {
        label: 'Phường Bình Kiến',
        value: 'PHUONG_BINH_KIEN'
      },
      {
        label: 'Phường Sông Cầu',
        value: 'PHUONG_SONG_CAU'
      },
      {
        label: 'Xã Xuân Lộc',
        value: 'XA_XUAN_LOC'
      },
      {
        label: 'Xã Xuân Cảnh',
        value: 'XA_XUAN_CANH'
      },
      {
        label: 'Xã Xuân Thọ',
        value: 'XA_XUAN_THO'
      },
      {
        label: 'Phường Xuân Đài',
        value: 'PHUONG_XUAN_DAI'
      },
      {
        label: 'Xã Đồng Xuân',
        value: 'XA_DONG_XUAN'
      },
      {
        label: 'Xã Xuân Lãnh',
        value: 'XA_XUAN_LANH'
      },
      {
        label: 'Xã Phú Mỡ',
        value: 'XA_PHU_MO'
      },
      {
        label: 'Xã Xuân Phước',
        value: 'XA_XUAN_PHUOC'
      },
      {
        label: 'Xã Tuy An Bắc',
        value: 'XA_TUY_AN_BAC'
      },
      {
        label: 'Xã Tuy An Đông',
        value: 'XA_TUY_AN_DONG'
      },
      {
        label: 'Xã Tuy An Tây',
        value: 'XA_TUY_AN_TAY'
      },
      {
        label: 'Xã Ô Loan',
        value: 'XA_O_LOAN'
      },
      {
        label: 'Xã Tuy An Nam',
        value: 'XA_TUY_AN_NAM'
      },
      {
        label: 'Xã Sơn Hòa',
        value: 'XA_SON_HOA'
      },
      {
        label: 'Xã Tây Sơn',
        value: 'XA_TAY_SON'
      },
      {
        label: 'Xã Vân Hòa',
        value: 'XA_VAN_HOA'
      },
      {
        label: 'Xã Suối Trai',
        value: 'XA_SUOI_TRAI'
      },
      {
        label: 'Xã Sông Hinh',
        value: 'XA_SONG_HINH'
      },
      {
        label: 'Xã Đức Bình',
        value: 'XA_DUC_BINH'
      },
      {
        label: 'Xã Ea Bá',
        value: 'XA_EA_BA'
      },
      {
        label: 'Xã Ea Ly',
        value: 'XA_EA_LY'
      },
      {
        label: 'Phường Phú Yên',
        value: 'PHUONG_PHU_YEN'
      },
      {
        label: 'Xã Sơn Thành',
        value: 'XA_SON_THANH'
      },
      {
        label: 'Xã Tây Hòa',
        value: 'XA_TAY_HOA'
      },
      {
        label: 'Phường Đông Hòa',
        value: 'PHUONG_DONG_HOA'
      },
      {
        label: 'Phường Hòa Hiệp',
        value: 'PHUONG_HOA_HIEP'
      },
      {
        label: 'Xã Hòa Thịnh',
        value: 'XA_HOA_THINH'
      },
      {
        label: 'Xã Hòa Mỹ',
        value: 'XA_HOA_MY'
      },
      {
        label: 'Xã Hòa Xuân',
        value: 'XA_HOA_XUAN'
      },
      {
        label: 'Xã Phú Hòa 2',
        value: 'XA_PHU_HOA_2'
      },
      {
        label: 'Xã Phú Hòa 1',
        value: 'XA_PHU_HOA_1'
      },
      {
        label: 'Phường  Tân Lập',
        value: 'PHUONG_TAN_LAP'
      },
      {
        label: 'Phường  Buôn Ma Thuột',
        value: 'PHUONG_BUON_MA_THUOT'
      },
      {
        label: 'Phường  Thành Nhất',
        value: 'PHUONG_THANH_NHAT'
      },
      {
        label: 'Phường  Tân An',
        value: 'PHUONG_TAN_AN'
      },
      {
        label: 'Phường Ea Kao',
        value: 'PHUONG_EA_KAO'
      },
      {
        label: 'Xã Hòa Phú',
        value: 'XA_HOA_PHU'
      },
      {
        label: 'Xã Ea Drăng',
        value: 'XA_EA_DRANG'
      },
      {
        label: 'Xã Ea H’leo',
        value: 'XA_EA_H_LEO'
      },
      {
        label: 'Xã Ea Hiao',
        value: 'XA_EA_HIAO'
      },
      {
        label: 'Xã Ea Wy',
        value: 'XA_EA_WY'
      },
      {
        label: 'Xã Ea Khăl',
        value: 'XA_EA_KHAL'
      },
      {
        label: 'Xã Ea Súp',
        value: 'XA_EA_SUP'
      },
      {
        label: 'Xã Ia Lốp',
        value: 'XA_IA_LOP'
      },
      {
        label: 'Xã Ea Rốk',
        value: 'XA_EA_ROK'
      },
      {
        label: 'Xã Ia Rvê',
        value: 'XA_IA_RVE'
      },
      {
        label: 'Xã Ea Bung',
        value: 'XA_EA_BUNG'
      },
      {
        label: 'Xã Buôn Đôn',
        value: 'XA_BUON_DON'
      },
      {
        label: 'Xã Ea Wer',
        value: 'XA_EA_WER'
      },
      {
        label: 'Xã Ea Nuôl',
        value: 'XA_EA_NUOL'
      },
      {
        label: 'Xã Quảng Phú',
        value: 'XA_QUANG_PHU'
      },
      {
        label: 'Xã Ea Kiết',
        value: 'XA_EA_KIET'
      },
      {
        label: 'Xã Ea Tul',
        value: 'XA_EA_TUL'
      },
      {
        label: 'Xã Cư M’gar',
        value: 'XA_CU_M_GAR'
      },
      {
        label: 'Xã Ea M’Droh',
        value: 'XA_EA_M_DROH'
      },
      {
        label: 'Xã Cuôr Đăng',
        value: 'XA_CUOR_DANG'
      },
      {
        label: 'Phường Buôn Hồ',
        value: 'PHUONG_BUON_HO'
      },
      {
        label: 'Xã Krông Búk',
        value: 'XA_KRONG_BUK'
      },
      {
        label: 'Xã Cư Pơng',
        value: 'XA_CU_PONG'
      },
      {
        label: 'Xã Pơng Drang',
        value: 'XA_PONG_DRANG'
      },
      {
        label: 'Xã Ea Drông',
        value: 'XA_EA_DRONG'
      },
      {
        label: 'Phường Cư Bao',
        value: 'PHUONG_CU_BAO'
      },
      {
        label: 'Xã Krông Năng',
        value: 'XA_KRONG_NANG'
      },
      {
        label: 'Xã Dliê Ya',
        value: 'XA_DLIE_YA'
      },
      {
        label: 'Xã Tam Giang',
        value: 'XA_TAM_GIANG'
      },
      {
        label: 'Xã Phú Xuân',
        value: 'XA_PHU_XUAN'
      },
      {
        label: 'Xã Ea Kar',
        value: 'XA_EA_KAR'
      },
      {
        label: 'Xã Ea Knốp',
        value: 'XA_EA_KNOP'
      },
      {
        label: 'Xã Ea Păl',
        value: 'XA_EA_PAL'
      },
      {
        label: 'Xã Ea Ô',
        value: 'XA_EA_O'
      },
      {
        label: 'Xã Cư Yang',
        value: 'XA_CU_YANG'
      },
      {
        label: 'Xã M’Drắk',
        value: 'XA_M_DRAK'
      },
      {
        label: 'Xã Cư Prao',
        value: 'XA_CU_PRAO'
      },
      {
        label: 'Xã Ea Riêng',
        value: 'XA_EA_RIENG'
      },
      {
        label: 'Xã Cư M’ta',
        value: 'XA_CU_M_TA'
      },
      {
        label: 'Xã Krông Á',
        value: 'XA_KRONG_A'
      },
      {
        label: 'Xã Ea Trang',
        value: 'XA_EA_TRANG'
      },
      {
        label: 'Xã Krông Bông',
        value: 'XA_KRONG_BONG'
      },
      {
        label: 'Xã Dang Kang',
        value: 'XA_DANG_KANG'
      },
      {
        label: 'Xã Cư Pui',
        value: 'XA_CU_PUI'
      },
      {
        label: 'Xã Hòa Sơn',
        value: 'XA_HOA_SON'
      },
      {
        label: 'Xã Yang Mao',
        value: 'XA_YANG_MAO'
      },
      {
        label: 'Xã Krông Pắc',
        value: 'XA_KRONG_PAC'
      },
      {
        label: 'Xã Ea Kly',
        value: 'XA_EA_KLY'
      },
      {
        label: 'Xã Ea Phê',
        value: 'XA_EA_PHE'
      },
      {
        label: 'Xã Ea Knuếc',
        value: 'XA_EA_KNUEC'
      },
      {
        label: 'Xã Tân Tiến',
        value: 'XA_TAN_TIEN'
      },
      {
        label: 'Xã Vụ Bổn',
        value: 'XA_VU_BON'
      },
      {
        label: 'Xã Krông Ana',
        value: 'XA_KRONG_ANA'
      },
      {
        label: 'Xã Ea Ning',
        value: 'XA_EA_NING'
      },
      {
        label: 'Xã Ea Ktur',
        value: 'XA_EA_KTUR'
      },
      {
        label: 'Xã Ea Na',
        value: 'XA_EA_NA'
      },
      {
        label: 'Xã Dray Bhăng',
        value: 'XA_DRAY_BHANG'
      },
      {
        label: 'Xã Dur Kmăl',
        value: 'XA_DUR_KMAL'
      },
      {
        label: 'Xã Liên Sơn Lắk',
        value: 'XA_LIEN_SON_LAK'
      },
      {
        label: 'Xã Đắk Liêng',
        value: 'XA_DAK_LIENG'
      },
      {
        label: 'Xã Đắk Phơi',
        value: 'XA_DAK_PHOI'
      },
      {
        label: 'Xã Krông Nô',
        value: 'XA_KRONG_NO'
      },
      {
        label: 'Xã Nam Ka',
        value: 'XA_NAM_KA'
      }
    ]
  },
  {
    label: 'Lâm Đồng',
    value: 'LAM_DONG',
    children: [
      {
        label: 'Phường Mũi Né',
        value: 'PHUONG_MUI_NE'
      },
      {
        label: 'Phường Phú Thuỷ',
        value: 'PHUONG_PHU_THUY'
      },
      {
        label: 'Phường Hàm Thắng',
        value: 'PHUONG_HAM_THANG'
      },
      {
        label: 'Phường Phan Thiết',
        value: 'PHUONG_PHAN_THIET'
      },
      {
        label: 'Phường Tiến Thành',
        value: 'PHUONG_TIEN_THANH'
      },
      {
        label: 'Phường Bình Thuận',
        value: 'PHUONG_BINH_THUAN'
      },
      {
        label: 'Xã Tuyên Quang',
        value: 'XA_TUYEN_QUANG'
      },
      {
        label: 'Xã Liên Hương',
        value: 'XA_LIEN_HUONG'
      },
      {
        label: 'Xã Phan Rí Cửa',
        value: 'XA_PHAN_RI_CUA'
      },
      {
        label: 'Xã Tuy Phong',
        value: 'XA_TUY_PHONG'
      },
      {
        label: 'Xã Vĩnh Hảo',
        value: 'XA_VINH_HAO'
      },
      {
        label: 'Xã Bắc Bình',
        value: 'XA_BAC_BINH'
      },
      {
        label: 'Xã Phan Sơn',
        value: 'XA_PHAN_SON'
      },
      {
        label: 'Xã Hải Ninh',
        value: 'XA_HAI_NINH'
      },
      {
        label: 'Xã Sông Lũy',
        value: 'XA_SONG_LUY'
      },
      {
        label: 'Xã Lương Sơn',
        value: 'XA_LUONG_SON'
      },
      {
        label: 'Xã Hồng Thái',
        value: 'XA_HONG_THAI'
      },
      {
        label: 'Xã Hòa Thắng',
        value: 'XA_HOA_THANG'
      },
      {
        label: 'Xã Hàm Thuận',
        value: 'XA_HAM_THUAN'
      },
      {
        label: 'Xã La Dạ',
        value: 'XA_LA_DA'
      },
      {
        label: 'Xã Đông Giang',
        value: 'XA_DONG_GIANG'
      },
      {
        label: 'Xã Hồng Sơn',
        value: 'XA_HONG_SON'
      },
      {
        label: 'Xã Hàm Thuận Bắc',
        value: 'XA_HAM_THUAN_BAC'
      },
      {
        label: 'Xã Hàm Liêm',
        value: 'XA_HAM_LIEM'
      },
      {
        label: 'Xã Hàm Thuận Nam',
        value: 'XA_HAM_THUAN_NAM'
      },
      {
        label: 'Xã Hàm Thạnh',
        value: 'XA_HAM_THANH'
      },
      {
        label: 'Xã Hàm Kiệm',
        value: 'XA_HAM_KIEM'
      },
      {
        label: 'Xã Tân Lập',
        value: 'XA_TAN_LAP'
      },
      {
        label: 'Xã Tân Thành',
        value: 'XA_TAN_THANH'
      },
      {
        label: 'Xã Tánh Linh',
        value: 'XA_TANH_LINH'
      },
      {
        label: 'Xã Bắc Ruộng',
        value: 'XA_BAC_RUONG'
      },
      {
        label: 'Xã Nghị Đức',
        value: 'XA_NGHI_DUC'
      },
      {
        label: 'Xã Đồng Kho',
        value: 'XA_DONG_KHO'
      },
      {
        label: 'Xã Suối Kiết',
        value: 'XA_SUOI_KIET'
      },
      {
        label: 'Xã Đức Linh',
        value: 'XA_DUC_LINH'
      },
      {
        label: 'Xã Hoài Đức',
        value: 'XA_HOAI_DUC'
      },
      {
        label: 'Xã Nam Thành',
        value: 'XA_NAM_THANH'
      },
      {
        label: 'Xã Trà Tân',
        value: 'XA_TRA_TAN'
      },
      {
        label: 'Xã Tân Minh',
        value: 'XA_TAN_MINH'
      },
      {
        label: 'Phường Phước Hội',
        value: 'PHUONG_PHUOC_HOI'
      },
      {
        label: 'Phường La Gi',
        value: 'PHUONG_LA_GI'
      },
      {
        label: 'Xã Hàm Tân',
        value: 'XA_HAM_TAN'
      },
      {
        label: 'Xã Tân Hải',
        value: 'XA_TAN_HAI'
      },
      {
        label: 'Xã Sơn Mỹ',
        value: 'XA_SON_MY'
      },
      {
        label: 'Đặc khu Phú Quý',
        value: 'DAC_KHU_PHU_QUY'
      },
      {
        label: 'Phường Bắc Gia Nghĩa',
        value: 'PHUONG_BAC_GIA_NGHIA'
      },
      {
        label: 'Phường Nam Gia Nghĩa',
        value: 'PHUONG_NAM_GIA_NGHIA'
      },
      {
        label: 'Xã Quảng Sơn',
        value: 'XA_QUANG_SON'
      },
      {
        label: 'Phường Đông Gia Nghĩa',
        value: 'PHUONG_DONG_GIA_NGHIA'
      },
      {
        label: 'Xã Quảng Hòa',
        value: 'XA_QUANG_HOA'
      },
      {
        label: 'Xã Quảng Khê',
        value: 'XA_QUANG_KHE'
      },
      {
        label: 'Xã Tà Đùng',
        value: 'XA_TA_DUNG'
      },
      {
        label: 'Xã Cư Jút',
        value: 'XA_CU_JUT'
      },
      {
        label: 'Xã Đắk Wil',
        value: 'XA_DAK_WIL'
      },
      {
        label: 'Xã Nam Dong',
        value: 'XA_NAM_DONG'
      },
      {
        label: 'Xã Đức Lập',
        value: 'XA_DUC_LAP'
      },
      {
        label: 'Xã Đắk Mil',
        value: 'XA_DAK_MIL'
      },
      {
        label: 'Xã Đắk Sắk',
        value: 'XA_DAK_SAK'
      },
      {
        label: 'Xã Thuận An',
        value: 'XA_THUAN_AN'
      },
      {
        label: 'Xã Krông Nô',
        value: 'XA_KRONG_NO'
      },
      {
        label: 'Xã Nam Đà',
        value: 'XA_NAM_DA'
      },
      {
        label: 'Xã Nâm Nung',
        value: 'XA_NAM_NUNG'
      },
      {
        label: 'Xã Quảng Phú',
        value: 'XA_QUANG_PHU'
      },
      {
        label: 'Xã Đức An',
        value: 'XA_DUC_AN'
      },
      {
        label: 'Xã Đắk song',
        value: 'XA_DAK_SONG'
      },
      {
        label: 'Xã Thuận Hạnh',
        value: 'XA_THUAN_HANH'
      },
      {
        label: 'Xã Trường Xuân',
        value: 'XA_TRUONG_XUAN'
      },
      {
        label: 'Xã Kiến Đức',
        value: 'XA_KIEN_DUC'
      },
      {
        label: 'Xã Quảng Trực',
        value: 'XA_QUANG_TRUC'
      },
      {
        label: 'Xã Tuy Đức',
        value: 'XA_TUY_DUC'
      },
      {
        label: 'Xã Quảng Tân',
        value: 'XA_QUANG_TAN'
      },
      {
        label: 'Xã Nhân Cơ',
        value: 'XA_NHAN_CO'
      },
      {
        label: 'Xã Quảng Tín',
        value: 'XA_QUANG_TIN'
      },
      {
        label: 'Phường Lâm Viên - Đà Lạt',
        value: 'PHUONG_LAM_VIEN_DA_LAT'
      },
      {
        label: 'Phường Xuân Hương - Đà Lạt',
        value: 'PHUONG_XUAN_HUONG_DA_LAT'
      },
      {
        label: 'Phường Cam Ly - Đà Lạt',
        value: 'PHUONG_CAM_LY_DA_LAT'
      },
      {
        label: 'Phường Xuân Trường - Đà Lạt',
        value: 'PHUONG_XUAN_TRUONG_DA_LAT'
      },
      {
        label: 'Phường 2 Bảo Lộc',
        value: 'PHUONG_2_BAO_LOC'
      },
      {
        label: 'Phường 1 Bảo Lộc',
        value: 'PHUONG_1_BAO_LOC'
      },
      {
        label: "Phường B'Lao",
        value: 'PHUONG_B_LAO'
      },
      {
        label: 'Phường 3 Bảo Lộc',
        value: 'PHUONG_3_BAO_LOC'
      },
      {
        label: 'Phường Lang Biang - Đà Lạt',
        value: 'PHUONG_LANG_BIANG_DA_LAT'
      },
      {
        label: 'Xã Lạc Dương',
        value: 'XA_LAC_DUONG'
      },
      {
        label: 'Xã Đam Rông 4',
        value: 'XA_DAM_RONG_4'
      },
      {
        label: 'Xã Nam Ban Lâm Hà',
        value: 'XA_NAM_BAN_LAM_HA'
      },
      {
        label: 'Xã Đinh Văn Lâm Hà',
        value: 'XA_DINH_VAN_LAM_HA'
      },
      {
        label: 'Xã Đam Rông 3',
        value: 'XA_DAM_RONG_3'
      },
      {
        label: 'Xã Đam Rông 2',
        value: 'XA_DAM_RONG_2'
      },
      {
        label: 'Xã Nam Hà Lâm Hà',
        value: 'XA_NAM_HA_LAM_HA'
      },
      {
        label: 'Xã Đam Rông 1',
        value: 'XA_DAM_RONG_1'
      },
      {
        label: 'Xã Phú Sơn Lâm Hà',
        value: 'XA_PHU_SON_LAM_HA'
      },
      {
        label: 'Xã Phúc Thọ Lâm Hà',
        value: 'XA_PHUC_THO_LAM_HA'
      },
      {
        label: 'Xã Tân Hà Lâm Hà',
        value: 'XA_TAN_HA_LAM_HA'
      },
      {
        label: 'Xã Đơn Dương',
        value: 'XA_DON_DUONG'
      },
      {
        label: "Xã D'Ran",
        value: 'XA_D_RAN'
      },
      {
        label: 'Xã Ka Đô',
        value: 'XA_KA_DO'
      },
      {
        label: 'Xã Quảng Lập',
        value: 'XA_QUANG_LAP'
      },
      {
        label: 'Xã Đức Trọng',
        value: 'XA_DUC_TRONG'
      },
      {
        label: 'Xã Hiệp Thạnh',
        value: 'XA_HIEP_THANH'
      },
      {
        label: 'Xã Tân Hội',
        value: 'XA_TAN_HOI'
      },
      {
        label: 'Xã Ninh Gia',
        value: 'XA_NINH_GIA'
      },
      {
        label: 'Xã Tà Năng',
        value: 'XA_TA_NANG'
      },
      {
        label: 'Xã Tà Hine',
        value: 'XA_TA_HINE'
      },
      {
        label: 'Xã Di Linh',
        value: 'XA_DI_LINH'
      },
      {
        label: 'Xã Đinh Trang Thượng',
        value: 'XA_DINH_TRANG_THUONG'
      },
      {
        label: 'Xã Gia Hiệp',
        value: 'XA_GIA_HIEP'
      },
      {
        label: 'Xã Bảo Thuận',
        value: 'XA_BAO_THUAN'
      },
      {
        label: 'Xã Hòa Ninh',
        value: 'XA_HOA_NINH'
      },
      {
        label: 'Xã Hòa Bắc',
        value: 'XA_HOA_BAC'
      },
      {
        label: 'Xã Sơn Điền',
        value: 'XA_SON_DIEN'
      },
      {
        label: 'Xã Bảo Lâm 1',
        value: 'XA_BAO_LAM_1'
      },
      {
        label: 'Xã Bảo Lâm 5',
        value: 'XA_BAO_LAM_5'
      },
      {
        label: 'Xã Bảo Lâm 4',
        value: 'XA_BAO_LAM_4'
      },
      {
        label: 'Xã Bảo Lâm 2',
        value: 'XA_BAO_LAM_2'
      },
      {
        label: 'Xã Bảo Lâm 3',
        value: 'XA_BAO_LAM_3'
      },
      {
        label: 'Xã Đạ Huoai',
        value: 'XA_DA_HUOAI'
      },
      {
        label: 'Xã Đạ Huoai 2',
        value: 'XA_DA_HUOAI_2'
      },
      {
        label: 'Xã Đạ Huoai 3',
        value: 'XA_DA_HUOAI_3'
      },
      {
        label: 'Xã Đạ Tẻh',
        value: 'XA_DA_TEH'
      },
      {
        label: 'Xã Đạ Tẻh 3',
        value: 'XA_DA_TEH_3'
      },
      {
        label: 'Xã Đạ Tẻh 2',
        value: 'XA_DA_TEH_2'
      },
      {
        label: 'Xã Cát Tiên',
        value: 'XA_CAT_TIEN'
      },
      {
        label: 'Xã Cát Tiên 3',
        value: 'XA_CAT_TIEN_3'
      },
      {
        label: 'Xã Cát Tiên 2',
        value: 'XA_CAT_TIEN_2'
      }
    ]
  },
  {
    label: 'Đồng Nai',
    value: 'DONG_NAI',
    children: [
      {
        label: 'Phường Bình Phước',
        value: 'PHUONG_BINH_PHUOC'
      },
      {
        label: 'Phường Đồng Xoài',
        value: 'PHUONG_DONG_XOAI'
      },
      {
        label: 'Phường Phước Long',
        value: 'PHUONG_PHUOC_LONG'
      },
      {
        label: 'Phường Phước Bình',
        value: 'PHUONG_PHUOC_BINH'
      },
      {
        label: 'Xã Bù Gia Mập',
        value: 'XA_BU_GIA_MAP'
      },
      {
        label: 'Xã Đăk Ơ',
        value: 'XA_DAK_O'
      },
      {
        label: 'Xã Đa Kia',
        value: 'XA_DA_KIA'
      },
      {
        label: 'Xã Bình Tân',
        value: 'XA_BINH_TAN'
      },
      {
        label: 'Xã Long Hà',
        value: 'XA_LONG_HA'
      },
      {
        label: 'Xã Phú Trung',
        value: 'XA_PHU_TRUNG'
      },
      {
        label: 'Xã Phú Riềng',
        value: 'XA_PHU_RIENG'
      },
      {
        label: 'Xã Phú Nghĩa',
        value: 'XA_PHU_NGHIA'
      },
      {
        label: 'Xã Lộc Ninh',
        value: 'XA_LOC_NINH'
      },
      {
        label: 'Xã Lộc Tấn',
        value: 'XA_LOC_TAN'
      },
      {
        label: 'Xã Lộc Thạnh',
        value: 'XA_LOC_THANH'
      },
      {
        label: 'Xã Lộc Quang',
        value: 'XA_LOC_QUANG'
      },
      {
        label: 'Xã Lộc Thành',
        value: 'XA_LOC_THANH'
      },
      {
        label: 'Xã Lộc Hưng',
        value: 'XA_LOC_HUNG'
      },
      {
        label: 'Xã Thiện Hưng',
        value: 'XA_THIEN_HUNG'
      },
      {
        label: 'Xã Hưng Phước',
        value: 'XA_HUNG_PHUOC'
      },
      {
        label: 'Xã Tân Tiến',
        value: 'XA_TAN_TIEN'
      },
      {
        label: 'Phường Bình Long',
        value: 'PHUONG_BINH_LONG'
      },
      {
        label: 'Phường An Lộc',
        value: 'PHUONG_AN_LOC'
      },
      {
        label: 'Xã Tân Hưng',
        value: 'XA_TAN_HUNG'
      },
      {
        label: 'Xã Minh Đức',
        value: 'XA_MINH_DUC'
      },
      {
        label: 'Xã Tân Quan',
        value: 'XA_TAN_QUAN'
      },
      {
        label: 'Xã Tân Khai',
        value: 'XA_TAN_KHAI'
      },
      {
        label: 'Xã Đồng Phú',
        value: 'XA_DONG_PHU'
      },
      {
        label: 'Xã Tân Lợi',
        value: 'XA_TAN_LOI'
      },
      {
        label: 'Xã Thuận Lợi',
        value: 'XA_THUAN_LOI'
      },
      {
        label: 'Xã Đồng Tâm',
        value: 'XA_DONG_TAM'
      },
      {
        label: 'Xã Bù Đăng',
        value: 'XA_BU_DANG'
      },
      {
        label: 'Xã Đak Nhau',
        value: 'XA_DAK_NHAU'
      },
      {
        label: 'Xã Thọ Sơn',
        value: 'XA_THO_SON'
      },
      {
        label: 'Xã Bom Bo',
        value: 'XA_BOM_BO'
      },
      {
        label: 'Xã Nghĩa Trung',
        value: 'XA_NGHIA_TRUNG'
      },
      {
        label: 'Xã Phước Sơn',
        value: 'XA_PHUOC_SON'
      },
      {
        label: 'Phường Chơn Thành',
        value: 'PHUONG_CHON_THANH'
      },
      {
        label: 'Phường Minh Hưng',
        value: 'PHUONG_MINH_HUNG'
      },
      {
        label: 'Xã Nha Bích',
        value: 'XA_NHA_BICH'
      },
      {
        label: 'Phường Trảng Dài',
        value: 'PHUONG_TRANG_DAI'
      },
      {
        label: 'Phường Hố Nai',
        value: 'PHUONG_HO_NAI'
      },
      {
        label: 'Phường Tam Hiệp',
        value: 'PHUONG_TAM_HIEP'
      },
      {
        label: 'Phường Long Bình',
        value: 'PHUONG_LONG_BINH'
      },
      {
        label: 'Phường Trấn Biên',
        value: 'PHUONG_TRAN_BIEN'
      },
      {
        label: 'Phường Biên Hòa',
        value: 'PHUONG_BIEN_HOA'
      },
      {
        label: 'Phường Long Khánh',
        value: 'PHUONG_LONG_KHANH'
      },
      {
        label: 'Phường Bình Lộc',
        value: 'PHUONG_BINH_LOC'
      },
      {
        label: 'Phường Bảo Vinh',
        value: 'PHUONG_BAO_VINH'
      },
      {
        label: 'Phường Xuân Lập',
        value: 'PHUONG_XUAN_LAP'
      },
      {
        label: 'Phường Hàng Gòn',
        value: 'PHUONG_HANG_GON'
      },
      {
        label: 'Xã Tân Phú',
        value: 'XA_TAN_PHU'
      },
      {
        label: 'Xã Đak Lua',
        value: 'XA_DAK_LUA'
      },
      {
        label: 'Xã Nam Cát Tiên',
        value: 'XA_NAM_CAT_TIEN'
      },
      {
        label: 'Xã Tà Lài',
        value: 'XA_TA_LAI'
      },
      {
        label: 'Xã Phú Lâm',
        value: 'XA_PHU_LAM'
      },
      {
        label: 'Xã Trị An',
        value: 'XA_TRI_AN'
      },
      {
        label: 'Xã Phú Lý',
        value: 'XA_PHU_LY'
      },
      {
        label: 'Xã Tân An',
        value: 'XA_TAN_AN'
      },
      {
        label: 'Phường Tân Triều',
        value: 'PHUONG_TAN_TRIEU'
      },
      {
        label: 'Xã Định Quán',
        value: 'XA_DINH_QUAN'
      },
      {
        label: 'Xã Thanh Sơn',
        value: 'XA_THANH_SON'
      },
      {
        label: 'Xã Phú Vinh',
        value: 'XA_PHU_VINH'
      },
      {
        label: 'Xã Phú Hòa',
        value: 'XA_PHU_HOA'
      },
      {
        label: 'Xã La Ngà',
        value: 'XA_LA_NGA'
      },
      {
        label: 'Xã Trảng Bom',
        value: 'XA_TRANG_BOM'
      },
      {
        label: 'Xã Bàu Hàm',
        value: 'XA_BAU_HAM'
      },
      {
        label: 'Xã Bình Minh',
        value: 'XA_BINH_MINH'
      },
      {
        label: 'Xã Hưng Thịnh',
        value: 'XA_HUNG_THINH'
      },
      {
        label: 'Xã An Viễn',
        value: 'XA_AN_VIEN'
      },
      {
        label: 'Xã Thống Nhất',
        value: 'XA_THONG_NHAT'
      },
      {
        label: 'Xã Gia Kiệm',
        value: 'XA_GIA_KIEM'
      },
      {
        label: 'Xã Dầu Giây',
        value: 'XA_DAU_GIAY'
      },
      {
        label: 'Xã Xuân Quế',
        value: 'XA_XUAN_QUE'
      },
      {
        label: 'Xã Cẩm Mỹ',
        value: 'XA_CAM_MY'
      },
      {
        label: 'Xã Xuân Đường',
        value: 'XA_XUAN_DUONG'
      },
      {
        label: 'Xã Xuân Đông',
        value: 'XA_XUAN_DONG'
      },
      {
        label: 'Xã Sông Ray',
        value: 'XA_SONG_RAY'
      },
      {
        label: 'Xã Long Thành',
        value: 'XA_LONG_THANH'
      },
      {
        label: 'Phường Tam Phước',
        value: 'PHUONG_TAM_PHUOC'
      },
      {
        label: 'Phường Phước Tân',
        value: 'PHUONG_PHUOC_TAN'
      },
      {
        label: 'Phường Long Hưng',
        value: 'PHUONG_LONG_HUNG'
      },
      {
        label: 'Xã An Phước',
        value: 'XA_AN_PHUOC'
      },
      {
        label: 'Xã Bình An',
        value: 'XA_BINH_AN'
      },
      {
        label: 'Xã Long Phước',
        value: 'XA_LONG_PHUOC'
      },
      {
        label: 'Xã Phước Thái',
        value: 'XA_PHUOC_THAI'
      },
      {
        label: 'Xã Xuân Lộc',
        value: 'XA_XUAN_LOC'
      },
      {
        label: 'Xã Xuân Bắc',
        value: 'XA_XUAN_BAC'
      },
      {
        label: 'Xã Xuân Thành',
        value: 'XA_XUAN_THANH'
      },
      {
        label: 'Xã Xuân Hòa',
        value: 'XA_XUAN_HOA'
      },
      {
        label: 'Xã Xuân Phú',
        value: 'XA_XUAN_PHU'
      },
      {
        label: 'Xã Xuân Định',
        value: 'XA_XUAN_DINH'
      },
      {
        label: 'Xã Nhơn Trạch',
        value: 'XA_NHON_TRACH'
      },
      {
        label: 'Xã Đại Phước',
        value: 'XA_DAI_PHUOC'
      },
      {
        label: 'Xã Phước An',
        value: 'XA_PHUOC_AN'
      }
    ]
  },
  {
    label: 'Thành phố Hồ Chí Minh',
    value: 'THANH_PHO_HO_CHI_MINH',
    children: [
      {
        label: 'Phường Thủ Dầu Một',
        value: 'PHUONG_THU_DAU_MOT'
      },
      {
        label: 'Phường Phú Lợi',
        value: 'PHUONG_PHU_LOI'
      },
      {
        label: 'Phường Bình Dương',
        value: 'PHUONG_BINH_DUONG'
      },
      {
        label: 'Phường Phú An',
        value: 'PHUONG_PHU_AN'
      },
      {
        label: 'Phường Chánh Hiệp',
        value: 'PHUONG_CHANH_HIEP'
      },
      {
        label: 'Xã Dầu Tiếng',
        value: 'XA_DAU_TIENG'
      },
      {
        label: 'Xã Minh Thạnh',
        value: 'XA_MINH_THANH'
      },
      {
        label: 'Xã Long Hòa',
        value: 'XA_LONG_HOA'
      },
      {
        label: 'Xã Thanh An',
        value: 'XA_THANH_AN'
      },
      {
        label: 'Phường Bến Cát',
        value: 'PHUONG_BEN_CAT'
      },
      {
        label: 'Xã Trừ Văn Thố',
        value: 'XA_TRU_VAN_THO'
      },
      {
        label: 'Xã Bàu Bàng',
        value: 'XA_BAU_BANG'
      },
      {
        label: 'Phường Chánh Phú Hòa',
        value: 'PHUONG_CHANH_PHU_HOA'
      },
      {
        label: 'Phường Long Nguyên',
        value: 'PHUONG_LONG_NGUYEN'
      },
      {
        label: 'Phường Tây Nam',
        value: 'PHUONG_TAY_NAM'
      },
      {
        label: 'Phường Thới Hòa',
        value: 'PHUONG_THOI_HOA'
      },
      {
        label: 'Phường Hòa Lợi',
        value: 'PHUONG_HOA_LOI'
      },
      {
        label: 'Xã Phú Giáo',
        value: 'XA_PHU_GIAO'
      },
      {
        label: 'Xã Phước Thành',
        value: 'XA_PHUOC_THANH'
      },
      {
        label: 'Xã An Long',
        value: 'XA_AN_LONG'
      },
      {
        label: 'Xã Phước Hòa',
        value: 'XA_PHUOC_HOA'
      },
      {
        label: 'Phường Tân Uyên',
        value: 'PHUONG_TAN_UYEN'
      },
      {
        label: 'Phường Tân Khánh',
        value: 'PHUONG_TAN_KHANH'
      },
      {
        label: 'Xã Bắc Tân Uyên',
        value: 'XA_BAC_TAN_UYEN'
      },
      {
        label: 'Xã Thường Tân',
        value: 'XA_THUONG_TAN'
      },
      {
        label: 'Phường Vĩnh Tân',
        value: 'PHUONG_VINH_TAN'
      },
      {
        label: 'Phường Bình Cơ',
        value: 'PHUONG_BINH_CO'
      },
      {
        label: 'Phường Tân Hiệp',
        value: 'PHUONG_TAN_HIEP'
      },
      {
        label: 'Phường Dĩ An',
        value: 'PHUONG_DI_AN'
      },
      {
        label: 'Phường Tân Đông Hiệp',
        value: 'PHUONG_TAN_DONG_HIEP'
      },
      {
        label: 'Phường Đông Hòa',
        value: 'PHUONG_DONG_HOA'
      },
      {
        label: 'Phường Lái Thiêu',
        value: 'PHUONG_LAI_THIEU'
      },
      {
        label: 'Phường Thuận Giao',
        value: 'PHUONG_THUAN_GIAO'
      },
      {
        label: 'Phường An Phú',
        value: 'PHUONG_AN_PHU'
      },
      {
        label: 'Phường Thuận An',
        value: 'PHUONG_THUAN_AN'
      },
      {
        label: 'Phường Bình Hòa',
        value: 'PHUONG_BINH_HOA'
      },
      {
        label: 'Phường Vũng Tàu',
        value: 'PHUONG_VUNG_TAU'
      },
      {
        label: 'Phường Tam Thắng',
        value: 'PHUONG_TAM_THANG'
      },
      {
        label: 'Phường  Rạch Dừa',
        value: 'PHUONG_RACH_DUA'
      },
      {
        label: 'Phường Phước Thắng',
        value: 'PHUONG_PHUOC_THANG'
      },
      {
        label: 'Xã Long Sơn',
        value: 'XA_LONG_SON'
      },
      {
        label: 'Phường Bà Rịa',
        value: 'PHUONG_BA_RIA'
      },
      {
        label: 'Phường Long Hương',
        value: 'PHUONG_LONG_HUONG'
      },
      {
        label: 'Phường Tam Long',
        value: 'PHUONG_TAM_LONG'
      },
      {
        label: 'Xã Ngãi Giao',
        value: 'XA_NGAI_GIAO'
      },
      {
        label: 'Xã Xuân Sơn',
        value: 'XA_XUAN_SON'
      },
      {
        label: 'Xã Bình Giã',
        value: 'XA_BINH_GIA'
      },
      {
        label: 'Xã Châu Đức',
        value: 'XA_CHAU_DUC'
      },
      {
        label: 'Xã Kim Long',
        value: 'XA_KIM_LONG'
      },
      {
        label: 'Xã Nghĩa Thành',
        value: 'XA_NGHIA_THANH'
      },
      {
        label: 'Xã Hồ Tràm',
        value: 'XA_HO_TRAM'
      },
      {
        label: 'Xã Xuyên Mộc',
        value: 'XA_XUYEN_MOC'
      },
      {
        label: 'Xã Bàu Lâm',
        value: 'XA_BAU_LAM'
      },
      {
        label: 'Xã Hòa Hội',
        value: 'XA_HOA_HOI'
      },
      {
        label: 'Xã Hòa Hiệp',
        value: 'XA_HOA_HIEP'
      },
      {
        label: 'Xã Bình Châu',
        value: 'XA_BINH_CHAU'
      },
      {
        label: 'Xã Long Điền',
        value: 'XA_LONG_DIEN'
      },
      {
        label: 'Xã Long Hải',
        value: 'XA_LONG_HAI'
      },
      {
        label: 'Xã Đất Đỏ',
        value: 'XA_DAT_DO'
      },
      {
        label: 'Xã Phước Hải',
        value: 'XA_PHUOC_HAI'
      },
      {
        label: 'Phường Phú Mỹ',
        value: 'PHUONG_PHU_MY'
      },
      {
        label: 'Phường Tân Hải',
        value: 'PHUONG_TAN_HAI'
      },
      {
        label: 'Phường Tân Phước',
        value: 'PHUONG_TAN_PHUOC'
      },
      {
        label: 'Phường Tân Thành',
        value: 'PHUONG_TAN_THANH'
      },
      {
        label: 'Xã Châu Pha',
        value: 'XA_CHAU_PHA'
      },
      {
        label: 'Đặc khu Côn Đảo',
        value: 'DAC_KHU_CON_DAO'
      },
      {
        label: 'Phường Tân Định',
        value: 'PHUONG_TAN_DINH'
      },
      {
        label: 'Phường Sài Gòn',
        value: 'PHUONG_SAI_GON'
      },
      {
        label: 'Phường Bến Thành',
        value: 'PHUONG_BEN_THANH'
      },
      {
        label: 'Phường Cầu Ông Lãnh',
        value: 'PHUONG_CAU_ONG_LANH'
      },
      {
        label: 'Phường An Phú Đông',
        value: 'PHUONG_AN_PHU_DONG'
      },
      {
        label: 'Phường Thới An',
        value: 'PHUONG_THOI_AN'
      },
      {
        label: 'Phường Tân Thới Hiệp',
        value: 'PHUONG_TAN_THOI_HIEP'
      },
      {
        label: 'Phường Trung Mỹ Tây',
        value: 'PHUONG_TRUNG_MY_TAY'
      },
      {
        label: 'Phường Đông Hưng Thuận',
        value: 'PHUONG_DONG_HUNG_THUAN'
      },
      {
        label: 'Phường Linh Xuân',
        value: 'PHUONG_LINH_XUAN'
      },
      {
        label: 'Phường Tam Bình',
        value: 'PHUONG_TAM_BINH'
      },
      {
        label: 'Phường Hiệp Bình',
        value: 'PHUONG_HIEP_BINH'
      },
      {
        label: 'Phường Thủ Đức',
        value: 'PHUONG_THU_DUC'
      },
      {
        label: 'Phường Long Bình',
        value: 'PHUONG_LONG_BINH'
      },
      {
        label: 'Phường Tăng Nhơn Phú',
        value: 'PHUONG_TANG_NHON_PHU'
      },
      {
        label: 'Phường Phước Long',
        value: 'PHUONG_PHUOC_LONG'
      },
      {
        label: 'Phường Long Phước',
        value: 'PHUONG_LONG_PHUOC'
      },
      {
        label: 'Phường Long Trường',
        value: 'PHUONG_LONG_TRUONG'
      },
      {
        label: 'Phường An Hội Đông',
        value: 'PHUONG_AN_HOI_DONG'
      },
      {
        label: 'Phường An Hội Tây',
        value: 'PHUONG_AN_HOI_TAY'
      },
      {
        label: 'Phường Gò Vấp',
        value: 'PHUONG_GO_VAP'
      },
      {
        label: 'Phường  An Nhơn',
        value: 'PHUONG_AN_NHON'
      },
      {
        label: 'Phường Thông Tây Hội',
        value: 'PHUONG_THONG_TAY_HOI'
      },
      {
        label: 'Phường Hạnh Thông',
        value: 'PHUONG_HANH_THONG'
      },
      {
        label: 'Phường Bình Lợi Trung',
        value: 'PHUONG_BINH_LOI_TRUNG'
      },
      {
        label: 'Phường Bình Quới',
        value: 'PHUONG_BINH_QUOI'
      },
      {
        label: 'Phường Bình Thạnh',
        value: 'PHUONG_BINH_THANH'
      },
      {
        label: 'Phường Gia Định',
        value: 'PHUONG_GIA_DINH'
      },
      {
        label: 'Phường Thạnh Mỹ Tây',
        value: 'PHUONG_THANH_MY_TAY'
      },
      {
        label: 'Phường Tân Sơn Nhất',
        value: 'PHUONG_TAN_SON_NHAT'
      },
      {
        label: 'Phường Tân Sơn Hòa',
        value: 'PHUONG_TAN_SON_HOA'
      },
      {
        label: 'Phường Bảy Hiền',
        value: 'PHUONG_BAY_HIEN'
      },
      {
        label: 'Phường Tân Hòa',
        value: 'PHUONG_TAN_HOA'
      },
      {
        label: 'Phường Tân Bình',
        value: 'PHUONG_TAN_BINH'
      },
      {
        label: 'Phường Tân Sơn',
        value: 'PHUONG_TAN_SON'
      },
      {
        label: 'Phường Tân Sơn Nhì',
        value: 'PHUONG_TAN_SON_NHI'
      },
      {
        label: 'Phường Tây Thạnh',
        value: 'PHUONG_TAY_THANH'
      },
      {
        label: 'Phường Phú Thọ Hòa',
        value: 'PHUONG_PHU_THO_HOA'
      },
      {
        label: 'Phường Phú Thạnh',
        value: 'PHUONG_PHU_THANH'
      },
      {
        label: 'Phường Tân Phú',
        value: 'PHUONG_TAN_PHU'
      },
      {
        label: 'Phường Đức Nhuận',
        value: 'PHUONG_DUC_NHUAN'
      },
      {
        label: 'Phường Cầu Kiệu',
        value: 'PHUONG_CAU_KIEU'
      },
      {
        label: 'Phường Phú Nhuận',
        value: 'PHUONG_PHU_NHUAN'
      },
      {
        label: 'Phường Bình Trưng',
        value: 'PHUONG_BINH_TRUNG'
      },
      {
        label: 'Phường Cát Lái',
        value: 'PHUONG_CAT_LAI'
      },
      {
        label: 'Phường An Khánh',
        value: 'PHUONG_AN_KHANH'
      },
      {
        label: 'Phường Xuân Hòa',
        value: 'PHUONG_XUAN_HOA'
      },
      {
        label: 'Phường Nhiêu Lộc',
        value: 'PHUONG_NHIEU_LOC'
      },
      {
        label: 'Phường Bàn Cờ',
        value: 'PHUONG_BAN_CO'
      },
      {
        label: 'Phường Hòa Hưng',
        value: 'PHUONG_HOA_HUNG'
      },
      {
        label: 'Phường Diên Hồng',
        value: 'PHUONG_DIEN_HONG'
      },
      {
        label: 'Phường Vườn Lài',
        value: 'PHUONG_VUON_LAI'
      },
      {
        label: 'Phường Hòa Bình',
        value: 'PHUONG_HOA_BINH'
      },
      {
        label: 'Phường Phú Thọ',
        value: 'PHUONG_PHU_THO'
      },
      {
        label: 'Phường Bình Thới',
        value: 'PHUONG_BINH_THOI'
      },
      {
        label: 'Phường Minh Phụng',
        value: 'PHUONG_MINH_PHUNG'
      },
      {
        label: 'Phường Xóm Chiếu',
        value: 'PHUONG_XOM_CHIEU'
      },
      {
        label: 'Phường Khánh Hội',
        value: 'PHUONG_KHANH_HOI'
      },
      {
        label: 'Phường Vĩnh Hội',
        value: 'PHUONG_VINH_HOI'
      },
      {
        label: 'Phường Chợ Quán',
        value: 'PHUONG_CHO_QUAN'
      },
      {
        label: 'Phường An Đông',
        value: 'PHUONG_AN_DONG'
      },
      {
        label: 'Phường Chợ Lớn',
        value: 'PHUONG_CHO_LON'
      },
      {
        label: 'Phường Phú Lâm',
        value: 'PHUONG_PHU_LAM'
      },
      {
        label: 'Phường Bình Tây',
        value: 'PHUONG_BINH_TAY'
      },
      {
        label: 'Phường Bình Tiên',
        value: 'PHUONG_BINH_TIEN'
      },
      {
        label: 'Phường Bình Phú',
        value: 'PHUONG_BINH_PHU'
      },
      {
        label: 'Phường Chánh Hưng',
        value: 'PHUONG_CHANH_HUNG'
      },
      {
        label: 'Phường Bình Đông',
        value: 'PHUONG_BINH_DONG'
      },
      {
        label: 'Phường Phú Định',
        value: 'PHUONG_PHU_DINH'
      },
      {
        label: 'Phường Bình Hưng Hòa',
        value: 'PHUONG_BINH_HUNG_HOA'
      },
      {
        label: 'Phường Bình Tân',
        value: 'PHUONG_BINH_TAN'
      },
      {
        label: 'Phường Bình Trị Đông',
        value: 'PHUONG_BINH_TRI_DONG'
      },
      {
        label: 'Phường Tân Tạo',
        value: 'PHUONG_TAN_TAO'
      },
      {
        label: 'Phường An Lạc',
        value: 'PHUONG_AN_LAC'
      },
      {
        label: 'Phường Tân Hưng',
        value: 'PHUONG_TAN_HUNG'
      },
      {
        label: 'Phường Tân Thuận',
        value: 'PHUONG_TAN_THUAN'
      },
      {
        label: 'Phường Phú Thuận',
        value: 'PHUONG_PHU_THUAN'
      },
      {
        label: 'Phường Tân Mỹ',
        value: 'PHUONG_TAN_MY'
      },
      {
        label: 'Xã Tân An Hội',
        value: 'XA_TAN_AN_HOI'
      },
      {
        label: 'Xã An Nhơn Tây',
        value: 'XA_AN_NHON_TAY'
      },
      {
        label: 'Xã Nhuận Đức',
        value: 'XA_NHUAN_DUC'
      },
      {
        label: 'Xã Thái Mỹ',
        value: 'XA_THAI_MY'
      },
      {
        label: 'Xã Phú Hòa Đông',
        value: 'XA_PHU_HOA_DONG'
      },
      {
        label: 'Xã Bình Mỹ',
        value: 'XA_BINH_MY'
      },
      {
        label: 'Xã Củ Chi',
        value: 'XA_CU_CHI'
      },
      {
        label: 'Xã Hóc Môn',
        value: 'XA_HOC_MON'
      },
      {
        label: 'Xã Đông Thạnh',
        value: 'XA_DONG_THANH'
      },
      {
        label: 'Xã Xuân Thới Sơn',
        value: 'XA_XUAN_THOI_SON'
      },
      {
        label: 'Xã Bà Điểm',
        value: 'XA_BA_DIEM'
      },
      {
        label: 'Xã Tân Nhựt',
        value: 'XA_TAN_NHUT'
      },
      {
        label: 'Xã Vĩnh Lộc',
        value: 'XA_VINH_LOC'
      },
      {
        label: 'Xã Tân Vĩnh Lộc',
        value: 'XA_TAN_VINH_LOC'
      },
      {
        label: 'Xã Bình Lợi',
        value: 'XA_BINH_LOI'
      },
      {
        label: 'Xã Bình Hưng',
        value: 'XA_BINH_HUNG'
      },
      {
        label: 'Xã Hưng Long',
        value: 'XA_HUNG_LONG'
      },
      {
        label: 'Xã Bình Chánh',
        value: 'XA_BINH_CHANH'
      },
      {
        label: 'Xã Nhà Bè',
        value: 'XA_NHA_BE'
      },
      {
        label: 'Xã Hiệp Phước',
        value: 'XA_HIEP_PHUOC'
      },
      {
        label: 'Xã Cần Giờ',
        value: 'XA_CAN_GIO'
      },
      {
        label: 'Xã Bình Khánh',
        value: 'XA_BINH_KHANH'
      },
      {
        label: 'Xã An Thới Đông',
        value: 'XA_AN_THOI_DONG'
      },
      {
        label: 'Xã Thạnh An',
        value: 'XA_THANH_AN'
      }
    ]
  },
  {
    label: 'Tây Ninh',
    value: 'TAY_NINH',
    children: [
      {
        label: 'Phường Tân Ninh',
        value: 'PHUONG_TAN_NINH'
      },
      {
        label: 'Phường Bình Minh',
        value: 'PHUONG_BINH_MINH'
      },
      {
        label: 'Xã Tân Biên',
        value: 'XA_TAN_BIEN'
      },
      {
        label: 'Xã Tân Lập',
        value: 'XA_TAN_LAP'
      },
      {
        label: 'Xã Thạnh Bình',
        value: 'XA_THANH_BINH'
      },
      {
        label: 'Xã Trà Vong',
        value: 'XA_TRA_VONG'
      },
      {
        label: 'Xã Tân Châu',
        value: 'XA_TAN_CHAU'
      },
      {
        label: 'Xã Tân Đông',
        value: 'XA_TAN_DONG'
      },
      {
        label: 'Xã Tân Hội',
        value: 'XA_TAN_HOI'
      },
      {
        label: 'Xã Tân Hòa',
        value: 'XA_TAN_HOA'
      },
      {
        label: 'Xã Tân Thành',
        value: 'XA_TAN_THANH'
      },
      {
        label: 'Xã Tân Phú',
        value: 'XA_TAN_PHU'
      },
      {
        label: 'Xã Dương Minh Châu',
        value: 'XA_DUONG_MINH_CHAU'
      },
      {
        label: 'Phường Ninh Thạnh',
        value: 'PHUONG_NINH_THANH'
      },
      {
        label: 'Xã Cầu Khởi',
        value: 'XA_CAU_KHOI'
      },
      {
        label: 'Xã Lộc Ninh',
        value: 'XA_LOC_NINH'
      },
      {
        label: 'Xã Châu Thành',
        value: 'XA_CHAU_THANH'
      },
      {
        label: 'Xã Hảo Đước',
        value: 'XA_HAO_DUOC'
      },
      {
        label: 'Xã Phước Vinh',
        value: 'XA_PHUOC_VINH'
      },
      {
        label: 'Xã Hoà Hội',
        value: 'XA_HOA_HOI'
      },
      {
        label: 'Xã Ninh Điền',
        value: 'XA_NINH_DIEN'
      },
      {
        label: 'Phường Long Hoa',
        value: 'PHUONG_LONG_HOA'
      },
      {
        label: 'Phường Thanh Điền',
        value: 'PHUONG_THANH_DIEN'
      },
      {
        label: 'Phường Hoà Thành',
        value: 'PHUONG_HOA_THANH'
      },
      {
        label: 'Phường Gò Dầu',
        value: 'PHUONG_GO_DAU'
      },
      {
        label: 'Xã Thạnh Đức',
        value: 'XA_THANH_DUC'
      },
      {
        label: 'Xã Phước Thạnh',
        value: 'XA_PHUOC_THANH'
      },
      {
        label: 'Xã Truông Mít',
        value: 'XA_TRUONG_MIT'
      },
      {
        label: 'Phường Gia Lộc',
        value: 'PHUONG_GIA_LOC'
      },
      {
        label: 'Xã Bến Cầu',
        value: 'XA_BEN_CAU'
      },
      {
        label: 'Xã Long Chữ',
        value: 'XA_LONG_CHU'
      },
      {
        label: 'Xã Long Thuận',
        value: 'XA_LONG_THUAN'
      },
      {
        label: 'Phường Trảng Bàng',
        value: 'PHUONG_TRANG_BANG'
      },
      {
        label: 'Xã Hưng Thuận',
        value: 'XA_HUNG_THUAN'
      },
      {
        label: 'Xã Phước Chỉ',
        value: 'XA_PHUOC_CHI'
      },
      {
        label: 'Phường An Tịnh',
        value: 'PHUONG_AN_TINH'
      },
      {
        label: 'Phường Long An',
        value: 'PHUONG_LONG_AN'
      },
      {
        label: 'Phường Tân An',
        value: 'PHUONG_TAN_AN'
      },
      {
        label: 'Phường Khánh Hậu',
        value: 'PHUONG_KHANH_HAU'
      },
      {
        label: 'Xã Tân Hưng',
        value: 'XA_TAN_HUNG'
      },
      {
        label: 'Xã Hưng Điền',
        value: 'XA_HUNG_DIEN'
      },
      {
        label: 'Xã Vĩnh Thạnh',
        value: 'XA_VINH_THANH'
      },
      {
        label: 'Xã Vĩnh Châu',
        value: 'XA_VINH_CHAU'
      },
      {
        label: 'Xã Vĩnh Hưng',
        value: 'XA_VINH_HUNG'
      },
      {
        label: 'Xã Khánh Hưng',
        value: 'XA_KHANH_HUNG'
      },
      {
        label: 'Xã Tuyên Bình',
        value: 'XA_TUYEN_BINH'
      },
      {
        label: 'Phường Kiến Tường',
        value: 'PHUONG_KIEN_TUONG'
      },
      {
        label: 'Xã Bình Hiệp',
        value: 'XA_BINH_HIEP'
      },
      {
        label: 'Xã Bình Hoà',
        value: 'XA_BINH_HOA'
      },
      {
        label: 'Xã Tuyên Thạnh',
        value: 'XA_TUYEN_THANH'
      },
      {
        label: 'Xã Mộc Hoá',
        value: 'XA_MOC_HOA'
      },
      {
        label: 'Xã Tân Thạnh',
        value: 'XA_TAN_THANH'
      },
      {
        label: 'Xã Nhơn Hòa Lập',
        value: 'XA_NHON_HOA_LAP'
      },
      {
        label: 'Xã Hậu Thạnh',
        value: 'XA_HAU_THANH'
      },
      {
        label: 'Xã Nhơn Ninh',
        value: 'XA_NHON_NINH'
      },
      {
        label: 'Xã Thạnh Hóa',
        value: 'XA_THANH_HOA'
      },
      {
        label: 'Xã Bình Thành',
        value: 'XA_BINH_THANH'
      },
      {
        label: 'Xã Thạnh Phước',
        value: 'XA_THANH_PHUOC'
      },
      {
        label: 'Xã Tân Tây',
        value: 'XA_TAN_TAY'
      },
      {
        label: 'Xã Đông Thành',
        value: 'XA_DONG_THANH'
      },
      {
        label: 'Xã Mỹ Quý',
        value: 'XA_MY_QUY'
      },
      {
        label: 'Xã Đức Huệ',
        value: 'XA_DUC_HUE'
      },
      {
        label: 'Xã Hậu Nghĩa',
        value: 'XA_HAU_NGHIA'
      },
      {
        label: 'Xã Đức Hòa',
        value: 'XA_DUC_HOA'
      },
      {
        label: 'Xã An Ninh',
        value: 'XA_AN_NINH'
      },
      {
        label: 'Xã Hiệp Hoà',
        value: 'XA_HIEP_HOA'
      },
      {
        label: 'Xã Đức Lập',
        value: 'XA_DUC_LAP'
      },
      {
        label: 'Xã Mỹ Hạnh',
        value: 'XA_MY_HANH'
      },
      {
        label: 'Xã Hoà Khánh',
        value: 'XA_HOA_KHANH'
      },
      {
        label: 'Xã Bến Lức',
        value: 'XA_BEN_LUC'
      },
      {
        label: 'Xã Thạnh Lợi',
        value: 'XA_THANH_LOI'
      },
      {
        label: 'Xã Lương Hoà',
        value: 'XA_LUONG_HOA'
      },
      {
        label: 'Xã Bình Đức',
        value: 'XA_BINH_DUC'
      },
      {
        label: 'Xã Mỹ Yên',
        value: 'XA_MY_YEN'
      },
      {
        label: 'Xã Thủ Thừa',
        value: 'XA_THU_THUA'
      },
      {
        label: 'Xã Mỹ Thạnh',
        value: 'XA_MY_THANH'
      },
      {
        label: 'Xã Mỹ An',
        value: 'XA_MY_AN'
      },
      {
        label: 'Xã Tân Long',
        value: 'XA_TAN_LONG'
      },
      {
        label: 'Xã Tân Trụ',
        value: 'XA_TAN_TRU'
      },
      {
        label: 'Xã Nhựt Tảo',
        value: 'XA_NHUT_TAO'
      },
      {
        label: 'Xã Vàm Cỏ',
        value: 'XA_VAM_CO'
      },
      {
        label: 'Xã Cần Đước',
        value: 'XA_CAN_DUOC'
      },
      {
        label: 'Xã Rạch Kiến',
        value: 'XA_RACH_KIEN'
      },
      {
        label: 'Xã Long Cang',
        value: 'XA_LONG_CANG'
      },
      {
        label: 'Xã Mỹ Lệ',
        value: 'XA_MY_LE'
      },
      {
        label: 'Xã Tân Lân',
        value: 'XA_TAN_LAN'
      },
      {
        label: 'Xã Long Hựu',
        value: 'XA_LONG_HUU'
      },
      {
        label: 'Xã Cần Giuộc',
        value: 'XA_CAN_GIUOC'
      },
      {
        label: 'Xã Phước Lý',
        value: 'XA_PHUOC_LY'
      },
      {
        label: 'Xã Mỹ Lộc',
        value: 'XA_MY_LOC'
      },
      {
        label: 'Xã Phước Vĩnh Tây',
        value: 'XA_PHUOC_VINH_TAY'
      },
      {
        label: 'Xã Tân Tập',
        value: 'XA_TAN_TAP'
      },
      {
        label: 'Xã Tầm Vu',
        value: 'XA_TAM_VU'
      },
      {
        label: 'Xã Vĩnh Công',
        value: 'XA_VINH_CONG'
      },
      {
        label: 'Xã Thuận Mỹ',
        value: 'XA_THUAN_MY'
      },
      {
        label: 'Xã An Lục Long',
        value: 'XA_AN_LUC_LONG'
      }
    ]
  },
  {
    label: 'Đồng Tháp',
    value: 'DONG_THAP',
    children: [
      {
        label: 'Phường Đạo Thạnh',
        value: 'PHUONG_DAO_THANH'
      },
      {
        label: 'Phường Mỹ Tho',
        value: 'PHUONG_MY_THO'
      },
      {
        label: 'Phường Thới Sơn',
        value: 'PHUONG_THOI_SON'
      },
      {
        label: 'Phường Mỹ Phong',
        value: 'PHUONG_MY_PHONG'
      },
      {
        label: 'Phường Trung An',
        value: 'PHUONG_TRUNG_AN'
      },
      {
        label: 'Phường Long Thuận',
        value: 'PHUONG_LONG_THUAN'
      },
      {
        label: 'Phường Gò Công',
        value: 'PHUONG_GO_CONG'
      },
      {
        label: 'Phường Bình Xuân',
        value: 'PHUONG_BINH_XUAN'
      },
      {
        label: 'Xã Tân Phước 1',
        value: 'XA_TAN_PHUOC_1'
      },
      {
        label: 'Xã Tân Phước 2',
        value: 'XA_TAN_PHUOC_2'
      },
      {
        label: 'Xã Hưng Thạnh',
        value: 'XA_HUNG_THANH'
      },
      {
        label: 'Xã Tân Phước 3',
        value: 'XA_TAN_PHUOC_3'
      },
      {
        label: 'Xã Cái Bè',
        value: 'XA_CAI_BE'
      },
      {
        label: 'Xã Hậu Mỹ',
        value: 'XA_HAU_MY'
      },
      {
        label: 'Xã Mỹ Thiện',
        value: 'XA_MY_THIEN'
      },
      {
        label: 'Xã Hội Cư',
        value: 'XA_HOI_CU'
      },
      {
        label: 'Xã Mỹ Đức Tây',
        value: 'XA_MY_DUC_TAY'
      },
      {
        label: 'Xã Mỹ Lợi',
        value: 'XA_MY_LOI'
      },
      {
        label: 'Xã Thanh Hưng',
        value: 'XA_THANH_HUNG'
      },
      {
        label: 'Xã An Hữu',
        value: 'XA_AN_HUU'
      },
      {
        label: 'Phường Mỹ Phước Tây',
        value: 'PHUONG_MY_PHUOC_TAY'
      },
      {
        label: 'Phường Thanh Hòa',
        value: 'PHUONG_THANH_HOA'
      },
      {
        label: 'Phường Cai Lậy',
        value: 'PHUONG_CAI_LAY'
      },
      {
        label: 'Xã Thạnh Phú',
        value: 'XA_THANH_PHU'
      },
      {
        label: 'Xã Mỹ Thành',
        value: 'XA_MY_THANH'
      },
      {
        label: 'Xã Tân Phú',
        value: 'XA_TAN_PHU'
      },
      {
        label: 'Xã Bình Phú',
        value: 'XA_BINH_PHU'
      },
      {
        label: 'Phường Nhị Quý',
        value: 'PHUONG_NHI_QUY'
      },
      {
        label: 'Xã Hiệp Đức',
        value: 'XA_HIEP_DUC'
      },
      {
        label: 'Xã Long Tiên',
        value: 'XA_LONG_TIEN'
      },
      {
        label: 'Xã Ngũ Hiệp',
        value: 'XA_NGU_HIEP'
      },
      {
        label: 'Xã Châu Thành',
        value: 'XA_CHAU_THANH'
      },
      {
        label: 'Xã Tân Hương',
        value: 'XA_TAN_HUONG'
      },
      {
        label: 'Xã Long Hưng',
        value: 'XA_LONG_HUNG'
      },
      {
        label: 'Xã Long Định',
        value: 'XA_LONG_DINH'
      },
      {
        label: 'Xã Bình Trưng',
        value: 'XA_BINH_TRUNG'
      },
      {
        label: 'Xã Vĩnh Kim',
        value: 'XA_VINH_KIM'
      },
      {
        label: 'Xã Kim Sơn',
        value: 'XA_KIM_SON'
      },
      {
        label: 'Xã Chợ Gạo',
        value: 'XA_CHO_GAO'
      },
      {
        label: 'Xã Mỹ Tịnh An',
        value: 'XA_MY_TINH_AN'
      },
      {
        label: 'Xã Lương Hòa Lạc',
        value: 'XA_LUONG_HOA_LAC'
      },
      {
        label: 'Xã Tân Thuận Bình',
        value: 'XA_TAN_THUAN_BINH'
      },
      {
        label: 'Xã An Thạnh Thủy',
        value: 'XA_AN_THANH_THUY'
      },
      {
        label: 'Xã Bình Ninh',
        value: 'XA_BINH_NINH'
      },
      {
        label: 'Xã Vĩnh Bình',
        value: 'XA_VINH_BINH'
      },
      {
        label: 'Xã Đồng Sơn',
        value: 'XA_DONG_SON'
      },
      {
        label: 'Xã Phú Thành',
        value: 'XA_PHU_THANH'
      },
      {
        label: 'Xã Vĩnh Hựu',
        value: 'XA_VINH_HUU'
      },
      {
        label: 'Xã Long Bình',
        value: 'XA_LONG_BINH'
      },
      {
        label: 'Xã Tân Thới',
        value: 'XA_TAN_THOI'
      },
      {
        label: 'Xã Tân Phú Đông',
        value: 'XA_TAN_PHU_DONG'
      },
      {
        label: 'Xã Tân Hòa',
        value: 'XA_TAN_HOA'
      },
      {
        label: 'Xã Gia Thuận',
        value: 'XA_GIA_THUAN'
      },
      {
        label: 'Xã Tân Đông',
        value: 'XA_TAN_DONG'
      },
      {
        label: 'Phường Sơn Qui',
        value: 'PHUONG_SON_QUI'
      },
      {
        label: 'Xã Tân Điền',
        value: 'XA_TAN_DIEN'
      },
      {
        label: 'Xã Gò Công Đông',
        value: 'XA_GO_CONG_DONG'
      },
      {
        label: 'Phường Cao Lãnh',
        value: 'PHUONG_CAO_LANH'
      },
      {
        label: 'Phường Mỹ Ngãi',
        value: 'PHUONG_MY_NGAI'
      },
      {
        label: 'Phường Mỹ Trà',
        value: 'PHUONG_MY_TRA'
      },
      {
        label: 'Phường Sa Đéc',
        value: 'PHUONG_SA_DEC'
      },
      {
        label: 'Xã Tân Hồng',
        value: 'XA_TAN_HONG'
      },
      {
        label: 'Xã Tân Hộ Cơ',
        value: 'XA_TAN_HO_CO'
      },
      {
        label: 'Xã Tân Thành',
        value: 'XA_TAN_THANH'
      },
      {
        label: 'Xã An Phước',
        value: 'XA_AN_PHUOC'
      },
      {
        label: 'Phường An Bình',
        value: 'PHUONG_AN_BINH'
      },
      {
        label: 'Phường Hồng Ngự',
        value: 'PHUONG_HONG_NGU'
      },
      {
        label: 'Xã Thường Phước',
        value: 'XA_THUONG_PHUOC'
      },
      {
        label: 'Phường Thường Lạc',
        value: 'PHUONG_THUONG_LAC'
      },
      {
        label: 'Xã Long Khánh',
        value: 'XA_LONG_KHANH'
      },
      {
        label: 'Xã Long Phú Thuận',
        value: 'XA_LONG_PHU_THUAN'
      },
      {
        label: 'Xã Tràm Chim',
        value: 'XA_TRAM_CHIM'
      },
      {
        label: 'Xã Tam Nông',
        value: 'XA_TAM_NONG'
      },
      {
        label: 'Xã An Hòa',
        value: 'XA_AN_HOA'
      },
      {
        label: 'Xã Phú Cường',
        value: 'XA_PHU_CUONG'
      },
      {
        label: 'Xã An Long',
        value: 'XA_AN_LONG'
      },
      {
        label: 'Xã Phú Thọ',
        value: 'XA_PHU_THO'
      },
      {
        label: 'Xã Tháp Mười',
        value: 'XA_THAP_MUOI'
      },
      {
        label: 'Xã Phương Thịnh',
        value: 'XA_PHUONG_THINH'
      },
      {
        label: 'Xã Trường Xuân',
        value: 'XA_TRUONG_XUAN'
      },
      {
        label: 'Xã Mỹ Quí',
        value: 'XA_MY_QUI'
      },
      {
        label: 'Xã Đốc Binh Kiều',
        value: 'XA_DOC_BINH_KIEU'
      },
      {
        label: 'Xã Thanh Mỹ',
        value: 'XA_THANH_MY'
      },
      {
        label: 'Xã Mỹ Thọ',
        value: 'XA_MY_THO'
      },
      {
        label: 'Xã Ba Sao',
        value: 'XA_BA_SAO'
      },
      {
        label: 'Xã Phong Mỹ',
        value: 'XA_PHONG_MY'
      },
      {
        label: 'Xã Mỹ Hiệp',
        value: 'XA_MY_HIEP'
      },
      {
        label: 'Xã Bình Hàng Trung',
        value: 'XA_BINH_HANG_TRUNG'
      },
      {
        label: 'Xã Thanh Bình',
        value: 'XA_THANH_BINH'
      },
      {
        label: 'Xã Tân Long',
        value: 'XA_TAN_LONG'
      },
      {
        label: 'Xã Tân Thạnh',
        value: 'XA_TAN_THANH'
      },
      {
        label: 'Xã Bình Thành',
        value: 'XA_BINH_THANH'
      },
      {
        label: 'Xã Lấp Vò',
        value: 'XA_LAP_VO'
      },
      {
        label: 'Xã Mỹ An Hưng',
        value: 'XA_MY_AN_HUNG'
      },
      {
        label: 'Xã Tân Khánh Trung',
        value: 'XA_TAN_KHANH_TRUNG'
      },
      {
        label: 'Xã Hòa Long',
        value: 'XA_HOA_LONG'
      },
      {
        label: 'Xã Tân Dương',
        value: 'XA_TAN_DUONG'
      },
      {
        label: 'Xã Lai Vung',
        value: 'XA_LAI_VUNG'
      },
      {
        label: 'Xã Phong Hòa',
        value: 'XA_PHONG_HOA'
      },
      {
        label: 'Xã Phú Hựu',
        value: 'XA_PHU_HUU'
      },
      {
        label: 'Xã Tân Nhuận Đông',
        value: 'XA_TAN_NHUAN_DONG'
      },
      {
        label: 'Xã Tân Phú Trung',
        value: 'XA_TAN_PHU_TRUNG'
      }
    ]
  },
  {
    label: 'Vĩnh Long',
    value: 'VINH_LONG',
    children: [
      {
        label: 'Phường Phú Khương',
        value: 'PHUONG_PHU_KHUONG'
      },
      {
        label: 'Phường An Hội',
        value: 'PHUONG_AN_HOI'
      },
      {
        label: 'Phường Sơn Đông',
        value: 'PHUONG_SON_DONG'
      },
      {
        label: 'Phường Bến Tre',
        value: 'PHUONG_BEN_TRE'
      },
      {
        label: 'Xã Giao Long',
        value: 'XA_GIAO_LONG'
      },
      {
        label: 'Xã Phú Túc',
        value: 'XA_PHU_TUC'
      },
      {
        label: 'Xã Tân Phú',
        value: 'XA_TAN_PHU'
      },
      {
        label: 'Phường Phú Tân',
        value: 'PHUONG_PHU_TAN'
      },
      {
        label: 'Xã Tiên Thủy',
        value: 'XA_TIEN_THUY'
      },
      {
        label: 'Xã Chợ Lách',
        value: 'XA_CHO_LACH'
      },
      {
        label: 'Xã Phú Phụng',
        value: 'XA_PHU_PHUNG'
      },
      {
        label: 'Xã Vĩnh Thành',
        value: 'XA_VINH_THANH'
      },
      {
        label: 'Xã Hưng Khánh Trung',
        value: 'XA_HUNG_KHANH_TRUNG'
      },
      {
        label: 'Xã Mỏ Cày',
        value: 'XA_MO_CAY'
      },
      {
        label: 'Xã Phước Mỹ Trung',
        value: 'XA_PHUOC_MY_TRUNG'
      },
      {
        label: 'Xã Tân Thành Bình',
        value: 'XA_TAN_THANH_BINH'
      },
      {
        label: 'Xã Đồng Khởi',
        value: 'XA_DONG_KHOI'
      },
      {
        label: 'Xã Nhuận Phú Tân',
        value: 'XA_NHUAN_PHU_TAN'
      },
      {
        label: 'Xã An Định',
        value: 'XA_AN_DINH'
      },
      {
        label: 'Xã Thành Thới',
        value: 'XA_THANH_THOI'
      },
      {
        label: 'Xã Hương Mỹ',
        value: 'XA_HUONG_MY'
      },
      {
        label: 'Xã Giồng Trôm',
        value: 'XA_GIONG_TROM'
      },
      {
        label: 'Xã Lương Hòa',
        value: 'XA_LUONG_HOA'
      },
      {
        label: 'Xã Lương Phú',
        value: 'XA_LUONG_PHU'
      },
      {
        label: 'Xã Châu Hòa',
        value: 'XA_CHAU_HOA'
      },
      {
        label: 'Xã Phước Long',
        value: 'XA_PHUOC_LONG'
      },
      {
        label: 'Xã Tân Hào',
        value: 'XA_TAN_HAO'
      },
      {
        label: 'Xã Hưng Nhượng',
        value: 'XA_HUNG_NHUONG'
      },
      {
        label: 'Xã Bình Đại',
        value: 'XA_BINH_DAI'
      },
      {
        label: 'Xã Phú Thuận',
        value: 'XA_PHU_THUAN'
      },
      {
        label: 'Xã Lộc Thuận',
        value: 'XA_LOC_THUAN'
      },
      {
        label: 'Xã Châu Hưng',
        value: 'XA_CHAU_HUNG'
      },
      {
        label: 'Xã Thạnh Trị',
        value: 'XA_THANH_TRI'
      },
      {
        label: 'Xã Thạnh Phước',
        value: 'XA_THANH_PHUOC'
      },
      {
        label: 'Xã Thới Thuận',
        value: 'XA_THOI_THUAN'
      },
      {
        label: 'Xã Ba Tri',
        value: 'XA_BA_TRI'
      },
      {
        label: 'Xã Mỹ Chánh Hòa',
        value: 'XA_MY_CHANH_HOA'
      },
      {
        label: 'Xã Bảo Thạnh',
        value: 'XA_BAO_THANH'
      },
      {
        label: 'Xã Tân Xuân',
        value: 'XA_TAN_XUAN'
      },
      {
        label: 'Xã An Ngãi Trung',
        value: 'XA_AN_NGAI_TRUNG'
      },
      {
        label: 'Xã An Hiệp',
        value: 'XA_AN_HIEP'
      },
      {
        label: 'Xã Tân Thủy',
        value: 'XA_TAN_THUY'
      },
      {
        label: 'Xã Thạnh Phú',
        value: 'XA_THANH_PHU'
      },
      {
        label: 'Xã Quới Điền',
        value: 'XA_QUOI_DIEN'
      },
      {
        label: 'Xã Đại Điền',
        value: 'XA_DAI_DIEN'
      },
      {
        label: 'Xã Thạnh Hải',
        value: 'XA_THANH_HAI'
      },
      {
        label: 'Xã An Qui',
        value: 'XA_AN_QUI'
      },
      {
        label: 'Xã Thạnh Phong',
        value: 'XA_THANH_PHONG'
      },
      {
        label: 'Phường Trà Vinh',
        value: 'PHUONG_TRA_VINH'
      },
      {
        label: 'Phường Nguyệt Hóa',
        value: 'PHUONG_NGUYET_HOA'
      },
      {
        label: 'Phường Long Đức',
        value: 'PHUONG_LONG_DUC'
      },
      {
        label: 'Xã Càng Long',
        value: 'XA_CANG_LONG'
      },
      {
        label: 'Xã An Trường',
        value: 'XA_AN_TRUONG'
      },
      {
        label: 'Xã Tân An',
        value: 'XA_TAN_AN'
      },
      {
        label: 'Xã Bình Phú',
        value: 'XA_BINH_PHU'
      },
      {
        label: 'Xã Nhị Long',
        value: 'XA_NHI_LONG'
      },
      {
        label: 'Xã Cầu Kè',
        value: 'XA_CAU_KE'
      },
      {
        label: 'Xã An Phú Tân',
        value: 'XA_AN_PHU_TAN'
      },
      {
        label: 'Xã Phong Thạnh',
        value: 'XA_PHONG_THANH'
      },
      {
        label: 'Xã Tam Ngãi',
        value: 'XA_TAM_NGAI'
      },
      {
        label: 'Xã Tiểu Cần',
        value: 'XA_TIEU_CAN'
      },
      {
        label: 'Xã Hùng Hòa',
        value: 'XA_HUNG_HOA'
      },
      {
        label: 'Xã Tập Ngãi',
        value: 'XA_TAP_NGAI'
      },
      {
        label: 'Xã Tân Hòa',
        value: 'XA_TAN_HOA'
      },
      {
        label: 'Xã Châu Thành',
        value: 'XA_CHAU_THANH'
      },
      {
        label: 'Xã Song Lộc',
        value: 'XA_SONG_LOC'
      },
      {
        label: 'Phường Hòa Thuận',
        value: 'PHUONG_HOA_THUAN'
      },
      {
        label: 'Xã Hưng Mỹ',
        value: 'XA_HUNG_MY'
      },
      {
        label: 'Xã Hòa Minh',
        value: 'XA_HOA_MINH'
      },
      {
        label: 'Xã Long Hòa',
        value: 'XA_LONG_HOA'
      },
      {
        label: 'Xã Cầu Ngang',
        value: 'XA_CAU_NGANG'
      },
      {
        label: 'Xã Mỹ Long',
        value: 'XA_MY_LONG'
      },
      {
        label: 'Xã Vinh Kim',
        value: 'XA_VINH_KIM'
      },
      {
        label: 'Xã Nhị Trường',
        value: 'XA_NHI_TRUONG'
      },
      {
        label: 'Xã Hiệp Mỹ',
        value: 'XA_HIEP_MY'
      },
      {
        label: 'Xã Trà Cú',
        value: 'XA_TRA_CU'
      },
      {
        label: 'Xã Tập Sơn',
        value: 'XA_TAP_SON'
      },
      {
        label: 'Xã Lưu Nghiệp Anh',
        value: 'XA_LUU_NGHIEP_ANH'
      },
      {
        label: 'Xã Hàm Giang',
        value: 'XA_HAM_GIANG'
      },
      {
        label: 'Xã Đại An',
        value: 'XA_DAI_AN'
      },
      {
        label: 'Xã Đôn Châu',
        value: 'XA_DON_CHAU'
      },
      {
        label: 'Xã Long Hiệp',
        value: 'XA_LONG_HIEP'
      },
      {
        label: 'Phường Duyên Hải',
        value: 'PHUONG_DUYEN_HAI'
      },
      {
        label: 'Xã Long Thành',
        value: 'XA_LONG_THANH'
      },
      {
        label: 'Phường Trường Long Hòa',
        value: 'PHUONG_TRUONG_LONG_HOA'
      },
      {
        label: 'Xã Long Hữu',
        value: 'XA_LONG_HUU'
      },
      {
        label: 'Xã Ngũ Lạc',
        value: 'XA_NGU_LAC'
      },
      {
        label: 'Xã Long Vĩnh',
        value: 'XA_LONG_VINH'
      },
      {
        label: 'Xã Đông Hải',
        value: 'XA_DONG_HAI'
      },
      {
        label: 'Phường Long Châu',
        value: 'PHUONG_LONG_CHAU'
      },
      {
        label: 'Phường Phước Hậu',
        value: 'PHUONG_PHUOC_HAU'
      },
      {
        label: 'Phường Tân Ngãi',
        value: 'PHUONG_TAN_NGAI'
      },
      {
        label: 'Xã An Bình',
        value: 'XA_AN_BINH'
      },
      {
        label: 'Phường Thanh Đức',
        value: 'PHUONG_THANH_DUC'
      },
      {
        label: 'Phường Tân Hạnh',
        value: 'PHUONG_TAN_HANH'
      },
      {
        label: 'Xã Long Hồ',
        value: 'XA_LONG_HO'
      },
      {
        label: 'Xã Phú Quới',
        value: 'XA_PHU_QUOI'
      },
      {
        label: 'Xã Nhơn Phú',
        value: 'XA_NHON_PHU'
      },
      {
        label: 'Xã Bình Phước',
        value: 'XA_BINH_PHUOC'
      },
      {
        label: 'Xã Cái Nhum',
        value: 'XA_CAI_NHUM'
      },
      {
        label: 'Xã Tân Long Hội',
        value: 'XA_TAN_LONG_HOI'
      },
      {
        label: 'Xã Trung Thành',
        value: 'XA_TRUNG_THANH'
      },
      {
        label: 'Xã Quới An',
        value: 'XA_QUOI_AN'
      },
      {
        label: 'Xã Quới Thiện',
        value: 'XA_QUOI_THIEN'
      },
      {
        label: 'Xã Trung Hiệp',
        value: 'XA_TRUNG_HIEP'
      },
      {
        label: 'Xã Trung Ngãi',
        value: 'XA_TRUNG_NGAI'
      },
      {
        label: 'Xã Hiếu Phụng',
        value: 'XA_HIEU_PHUNG'
      },
      {
        label: 'Xã Hiếu Thành',
        value: 'XA_HIEU_THANH'
      },
      {
        label: 'Xã Tam Bình',
        value: 'XA_TAM_BINH'
      },
      {
        label: 'Xã Cái Ngang',
        value: 'XA_CAI_NGANG'
      },
      {
        label: 'Xã Hòa Hiệp',
        value: 'XA_HOA_HIEP'
      },
      {
        label: 'Xã Song Phú',
        value: 'XA_SONG_PHU'
      },
      {
        label: 'Xã Ngãi Tứ',
        value: 'XA_NGAI_TU'
      },
      {
        label: 'Phường Cái Vồn',
        value: 'PHUONG_CAI_VON'
      },
      {
        label: 'Phường Bình Minh',
        value: 'PHUONG_BINH_MINH'
      },
      {
        label: 'Xã Tân Lược',
        value: 'XA_TAN_LUOC'
      },
      {
        label: 'Xã Mỹ Thuận',
        value: 'XA_MY_THUAN'
      },
      {
        label: 'Xã Tân Quới',
        value: 'XA_TAN_QUOI'
      },
      {
        label: 'Phường Đông Thành',
        value: 'PHUONG_DONG_THANH'
      },
      {
        label: 'Xã Trà Ôn',
        value: 'XA_TRA_ON'
      },
      {
        label: 'Xã Hòa Bình',
        value: 'XA_HOA_BINH'
      },
      {
        label: 'Xã Trà Côn',
        value: 'XA_TRA_CON'
      },
      {
        label: 'Xã Vĩnh Xuân',
        value: 'XA_VINH_XUAN'
      },
      {
        label: 'Xã Lục Sỹ Thành',
        value: 'XA_LUC_SY_THANH'
      }
    ]
  },
  {
    label: 'An Giang',
    value: 'AN_GIANG',
    children: [
      {
        label: 'Phường Bình Đức',
        value: 'PHUONG_BINH_DUC'
      },
      {
        label: 'Phường Mỹ Thới',
        value: 'PHUONG_MY_THOI'
      },
      {
        label: 'Phường Long Xuyên',
        value: 'PHUONG_LONG_XUYEN'
      },
      {
        label: 'Xã Mỹ Hòa Hưng',
        value: 'XA_MY_HOA_HUNG'
      },
      {
        label: 'Phường Châu Đốc',
        value: 'PHUONG_CHAU_DOC'
      },
      {
        label: 'Phường Vĩnh Tế',
        value: 'PHUONG_VINH_TE'
      },
      {
        label: 'Xã An Phú',
        value: 'XA_AN_PHU'
      },
      {
        label: 'Xã Khánh Bình',
        value: 'XA_KHANH_BINH'
      },
      {
        label: 'Xã Nhơn Hội',
        value: 'XA_NHON_HOI'
      },
      {
        label: 'Xã Phú Hữu',
        value: 'XA_PHU_HUU'
      },
      {
        label: 'Xã Vĩnh Hậu',
        value: 'XA_VINH_HAU'
      },
      {
        label: 'Phường Tân Châu',
        value: 'PHUONG_TAN_CHAU'
      },
      {
        label: 'Phường Long Phú',
        value: 'PHUONG_LONG_PHU'
      },
      {
        label: 'Xã Vĩnh Xương',
        value: 'XA_VINH_XUONG'
      },
      {
        label: 'Xã Tân An',
        value: 'XA_TAN_AN'
      },
      {
        label: 'Xã Châu Phong',
        value: 'XA_CHAU_PHONG'
      },
      {
        label: 'Xã Phú Tân',
        value: 'XA_PHU_TAN'
      },
      {
        label: 'Xã Chợ Vàm',
        value: 'XA_CHO_VAM'
      },
      {
        label: 'Xã Phú Lâm',
        value: 'XA_PHU_LAM'
      },
      {
        label: 'Xã Hòa Lạc',
        value: 'XA_HOA_LAC'
      },
      {
        label: 'Xã Phú An',
        value: 'XA_PHU_AN'
      },
      {
        label: 'Xã Bình Thạnh Đông',
        value: 'XA_BINH_THANH_DONG'
      },
      {
        label: 'Xã Châu Phú',
        value: 'XA_CHAU_PHU'
      },
      {
        label: 'Xã Mỹ Đức',
        value: 'XA_MY_DUC'
      },
      {
        label: 'Xã Vĩnh Thạnh Trung',
        value: 'XA_VINH_THANH_TRUNG'
      },
      {
        label: 'Xã Thạnh Mỹ Tây',
        value: 'XA_THANH_MY_TAY'
      },
      {
        label: 'Xã Bình Mỹ',
        value: 'XA_BINH_MY'
      },
      {
        label: 'Phường Thới Sơn',
        value: 'PHUONG_THOI_SON'
      },
      {
        label: 'Phường Chi Lăng',
        value: 'PHUONG_CHI_LANG'
      },
      {
        label: 'Phường Tịnh Biên',
        value: 'PHUONG_TINH_BIEN'
      },
      {
        label: 'Xã An Cư',
        value: 'XA_AN_CU'
      },
      {
        label: 'Xã Núi Cấm',
        value: 'XA_NUI_CAM'
      },
      {
        label: 'Xã Tri Tôn',
        value: 'XA_TRI_TON'
      },
      {
        label: 'Xã Ba Chúc',
        value: 'XA_BA_CHUC'
      },
      {
        label: 'Xã Vĩnh Gia',
        value: 'XA_VINH_GIA'
      },
      {
        label: 'Xã Ô Lâm',
        value: 'XA_O_LAM'
      },
      {
        label: 'Xã Cô Tô',
        value: 'XA_CO_TO'
      },
      {
        label: 'Xã An Châu',
        value: 'XA_AN_CHAU'
      },
      {
        label: 'Xã Cần Đăng',
        value: 'XA_CAN_DANG'
      },
      {
        label: 'Xã Vĩnh An',
        value: 'XA_VINH_AN'
      },
      {
        label: 'Xã Bình Hòa',
        value: 'XA_BINH_HOA'
      },
      {
        label: 'Xã Vĩnh Hanh',
        value: 'XA_VINH_HANH'
      },
      {
        label: 'Xã Chợ Mới',
        value: 'XA_CHO_MOI'
      },
      {
        label: 'Xã Long Điền',
        value: 'XA_LONG_DIEN'
      },
      {
        label: 'Xã Cù Lao Giêng',
        value: 'XA_CU_LAO_GIENG'
      },
      {
        label: 'Xã Nhơn Mỹ',
        value: 'XA_NHON_MY'
      },
      {
        label: 'Xã Long Kiến',
        value: 'XA_LONG_KIEN'
      },
      {
        label: 'Xã Hội An',
        value: 'XA_HOI_AN'
      },
      {
        label: 'Xã Thoại Sơn',
        value: 'XA_THOAI_SON'
      },
      {
        label: 'Xã Phú Hòa',
        value: 'XA_PHU_HOA'
      },
      {
        label: 'Xã Óc Eo',
        value: 'XA_OC_EO'
      },
      {
        label: 'Xã Tây Phú',
        value: 'XA_TAY_PHU'
      },
      {
        label: 'Xã Vĩnh Trạch',
        value: 'XA_VINH_TRACH'
      },
      {
        label: 'Xã Định Mỹ',
        value: 'XA_DINH_MY'
      },
      {
        label: 'Phường Rạch Giá',
        value: 'PHUONG_RACH_GIA'
      },
      {
        label: 'Phường Vĩnh Thông',
        value: 'PHUONG_VINH_THONG'
      },
      {
        label: 'Phường Tô Châu',
        value: 'PHUONG_TO_CHAU'
      },
      {
        label: 'Phường Hà Tiên',
        value: 'PHUONG_HA_TIEN'
      },
      {
        label: 'Xã Tiên Hải',
        value: 'XA_TIEN_HAI'
      },
      {
        label: 'Xã Kiên Lương',
        value: 'XA_KIEN_LUONG'
      },
      {
        label: 'Xã Hòa Điền',
        value: 'XA_HOA_DIEN'
      },
      {
        label: 'Xã Vĩnh Điều',
        value: 'XA_VINH_DIEU'
      },
      {
        label: 'Xã Giang Thành',
        value: 'XA_GIANG_THANH'
      },
      {
        label: 'Xã Sơn Hải',
        value: 'XA_SON_HAI'
      },
      {
        label: 'Xã Hòn Nghệ',
        value: 'XA_HON_NGHE'
      },
      {
        label: 'Xã Hòn Đất',
        value: 'XA_HON_DAT'
      },
      {
        label: 'Xã Bình Sơn',
        value: 'XA_BINH_SON'
      },
      {
        label: 'Xã Bình Giang',
        value: 'XA_BINH_GIANG'
      },
      {
        label: 'Xã Sơn Kiên',
        value: 'XA_SON_KIEN'
      },
      {
        label: 'Xã Mỹ Thuận',
        value: 'XA_MY_THUAN'
      },
      {
        label: 'Xã Tân Hiệp',
        value: 'XA_TAN_HIEP'
      },
      {
        label: 'Xã Tân Hội',
        value: 'XA_TAN_HOI'
      },
      {
        label: 'Xã Thạnh Đông',
        value: 'XA_THANH_DONG'
      },
      {
        label: 'Xã Châu Thành',
        value: 'XA_CHAU_THANH'
      },
      {
        label: 'Xã Thạnh Lộc',
        value: 'XA_THANH_LOC'
      },
      {
        label: 'Xã Bình An',
        value: 'XA_BINH_AN'
      },
      {
        label: 'Xã Giồng Riềng',
        value: 'XA_GIONG_RIENG'
      },
      {
        label: 'Xã Thạnh Hưng',
        value: 'XA_THANH_HUNG'
      },
      {
        label: 'Xã Ngọc Chúc',
        value: 'XA_NGOC_CHUC'
      },
      {
        label: 'Xã Hòa Hưng',
        value: 'XA_HOA_HUNG'
      },
      {
        label: 'Xã Long Thạnh',
        value: 'XA_LONG_THANH'
      },
      {
        label: 'Xã Hòa Thuận',
        value: 'XA_HOA_THUAN'
      },
      {
        label: 'Xã Gò Quao',
        value: 'XA_GO_QUAO'
      },
      {
        label: 'Xã Định Hòa',
        value: 'XA_DINH_HOA'
      },
      {
        label: 'Xã Vĩnh Hòa Hưng',
        value: 'XA_VINH_HOA_HUNG'
      },
      {
        label: 'Xã Vĩnh Tuy',
        value: 'XA_VINH_TUY'
      },
      {
        label: 'Xã An Biên',
        value: 'XA_AN_BIEN'
      },
      {
        label: 'Xã Tây Yên',
        value: 'XA_TAY_YEN'
      },
      {
        label: 'Xã Đông Thái',
        value: 'XA_DONG_THAI'
      },
      {
        label: 'Xã Vĩnh Hòa',
        value: 'XA_VINH_HOA'
      },
      {
        label: 'Xã An Minh',
        value: 'XA_AN_MINH'
      },
      {
        label: 'Xã Đông Hòa',
        value: 'XA_DONG_HOA'
      },
      {
        label: 'Xã U Minh Thượng',
        value: 'XA_U_MINH_THUONG'
      },
      {
        label: 'Xã Tân Thạnh',
        value: 'XA_TAN_THANH'
      },
      {
        label: 'Xã Đông Hưng',
        value: 'XA_DONG_HUNG'
      },
      {
        label: 'Xã Vân Khánh',
        value: 'XA_VAN_KHANH'
      },
      {
        label: 'Xã Vĩnh Phong',
        value: 'XA_VINH_PHONG'
      },
      {
        label: 'Xã Vĩnh Bình',
        value: 'XA_VINH_BINH'
      },
      {
        label: 'Xã Vĩnh Thuận',
        value: 'XA_VINH_THUAN'
      },
      {
        label: 'Đặc khu Phú Quốc',
        value: 'DAC_KHU_PHU_QUOC'
      },
      {
        label: 'Đặc khu Thổ Châu',
        value: 'DAC_KHU_THO_CHAU'
      },
      {
        label: 'Đặc khu Kiên Hải',
        value: 'DAC_KHU_KIEN_HAI'
      }
    ]
  },
  {
    label: 'Thành phố Cần Thơ',
    value: 'THANH_PHO_CAN_THO',
    children: [
      {
        label: 'Phường Cái Khế',
        value: 'PHUONG_CAI_KHE'
      },
      {
        label: 'Phường Ninh Kiều',
        value: 'PHUONG_NINH_KIEU'
      },
      {
        label: 'Phường Tân An',
        value: 'PHUONG_TAN_AN'
      },
      {
        label: 'Phường An Bình',
        value: 'PHUONG_AN_BINH'
      },
      {
        label: 'Phường Ô Môn',
        value: 'PHUONG_O_MON'
      },
      {
        label: 'Phường Thới Long',
        value: 'PHUONG_THOI_LONG'
      },
      {
        label: 'Phường Phước Thới',
        value: 'PHUONG_PHUOC_THOI'
      },
      {
        label: 'Phường Bình Thủy',
        value: 'PHUONG_BINH_THUY'
      },
      {
        label: 'Phường Thới An Đông',
        value: 'PHUONG_THOI_AN_DONG'
      },
      {
        label: 'Phường Long Tuyền',
        value: 'PHUONG_LONG_TUYEN'
      },
      {
        label: 'Phường Cái Răng',
        value: 'PHUONG_CAI_RANG'
      },
      {
        label: 'Phường Hưng Phú',
        value: 'PHUONG_HUNG_PHU'
      },
      {
        label: 'Phường Thuận Hưng',
        value: 'PHUONG_THUAN_HUNG'
      },
      {
        label: 'Phường Thốt Nốt',
        value: 'PHUONG_THOT_NOT'
      },
      {
        label: 'Phường Tân Lộc',
        value: 'PHUONG_TAN_LOC'
      },
      {
        label: 'Phường Trung Nhứt',
        value: 'PHUONG_TRUNG_NHUT'
      },
      {
        label: 'Xã Thạnh An',
        value: 'XA_THANH_AN'
      },
      {
        label: 'Xã Vĩnh Thạnh',
        value: 'XA_VINH_THANH'
      },
      {
        label: 'Xã Vĩnh Trinh',
        value: 'XA_VINH_TRINH'
      },
      {
        label: 'Xã Thạnh Quới',
        value: 'XA_THANH_QUOI'
      },
      {
        label: 'Xã Thạnh Phú',
        value: 'XA_THANH_PHU'
      },
      {
        label: 'Xã Trung Hưng',
        value: 'XA_TRUNG_HUNG'
      },
      {
        label: 'Xã Thới Lai',
        value: 'XA_THOI_LAI'
      },
      {
        label: 'Xã Cờ Đỏ',
        value: 'XA_CO_DO'
      },
      {
        label: 'Xã Thới Hưng',
        value: 'XA_THOI_HUNG'
      },
      {
        label: 'Xã Đông Hiệp',
        value: 'XA_DONG_HIEP'
      },
      {
        label: 'Xã Đông Thuận',
        value: 'XA_DONG_THUAN'
      },
      {
        label: 'Xã Trường Thành',
        value: 'XA_TRUONG_THANH'
      },
      {
        label: 'Xã Trường Xuân',
        value: 'XA_TRUONG_XUAN'
      },
      {
        label: 'Xã Phong Điền',
        value: 'XA_PHONG_DIEN'
      },
      {
        label: 'Xã Trường Long',
        value: 'XA_TRUONG_LONG'
      },
      {
        label: 'Xã Nhơn Ái',
        value: 'XA_NHON_AI'
      },
      {
        label: 'Phường Vị Thanh',
        value: 'PHUONG_VI_THANH'
      },
      {
        label: 'Phường Vị Tân',
        value: 'PHUONG_VI_TAN'
      },
      {
        label: 'Xã Hỏa Lựu',
        value: 'XA_HOA_LUU'
      },
      {
        label: 'Phường Ngã Bảy',
        value: 'PHUONG_NGA_BAY'
      },
      {
        label: 'Xã Tân Hòa',
        value: 'XA_TAN_HOA'
      },
      {
        label: 'Xã Trường Long Tây',
        value: 'XA_TRUONG_LONG_TAY'
      },
      {
        label: 'Xã Thạnh Xuân',
        value: 'XA_THANH_XUAN'
      },
      {
        label: 'Xã Châu Thành',
        value: 'XA_CHAU_THANH'
      },
      {
        label: 'Xã Đông Phước',
        value: 'XA_DONG_PHUOC'
      },
      {
        label: 'Xã  Phú Hữu',
        value: 'XA_PHU_HUU'
      },
      {
        label: 'Xã Hòa An',
        value: 'XA_HOA_AN'
      },
      {
        label: 'Xã Hiệp Hưng',
        value: 'XA_HIEP_HUNG'
      },
      {
        label: 'Xã Tân Bình',
        value: 'XA_TAN_BINH'
      },
      {
        label: 'Xã Thạnh Hòa',
        value: 'XA_THANH_HOA'
      },
      {
        label: 'Phường Đại Thành',
        value: 'PHUONG_DAI_THANH'
      },
      {
        label: 'Xã Phụng Hiệp',
        value: 'XA_PHUNG_HIEP'
      },
      {
        label: 'Xã Phương Bình',
        value: 'XA_PHUONG_BINH'
      },
      {
        label: 'Xã Tân Phước Hưng',
        value: 'XA_TAN_PHUOC_HUNG'
      },
      {
        label: 'Xã Vị Thủy',
        value: 'XA_VI_THUY'
      },
      {
        label: 'Xã Vĩnh Thuận Đông',
        value: 'XA_VINH_THUAN_DONG'
      },
      {
        label: 'Xã Vĩnh Tường',
        value: 'XA_VINH_TUONG'
      },
      {
        label: 'Xã Vị Thanh 1',
        value: 'XA_VI_THANH_1'
      },
      {
        label: 'Phường Long Mỹ',
        value: 'PHUONG_LONG_MY'
      },
      {
        label: 'Phường Long Bình',
        value: 'PHUONG_LONG_BINH'
      },
      {
        label: 'Phường Long Phú 1',
        value: 'PHUONG_LONG_PHU_1'
      },
      {
        label: 'Xã Vĩnh Viễn',
        value: 'XA_VINH_VIEN'
      },
      {
        label: 'Xã Lương Tâm',
        value: 'XA_LUONG_TAM'
      },
      {
        label: 'Xã Xà Phiên',
        value: 'XA_XA_PHIEN'
      },
      {
        label: 'Phường Sóc Trăng',
        value: 'PHUONG_SOC_TRANG'
      },
      {
        label: 'Phường Phú Lợi',
        value: 'PHUONG_PHU_LOI'
      },
      {
        label: 'Xã Kế Sách',
        value: 'XA_KE_SACH'
      },
      {
        label: 'Xã An Lạc Thôn',
        value: 'XA_AN_LAC_THON'
      },
      {
        label: 'Xã Phong Nẫm',
        value: 'XA_PHONG_NAM'
      },
      {
        label: 'Xã Thới An Hội',
        value: 'XA_THOI_AN_HOI'
      },
      {
        label: 'Xã Nhơn Mỹ',
        value: 'XA_NHON_MY'
      },
      {
        label: 'Xã  Đại Hải',
        value: 'XA_DAI_HAI'
      },
      {
        label: 'Xã Mỹ Tú',
        value: 'XA_MY_TU'
      },
      {
        label: 'Xã Phú Tâm',
        value: 'XA_PHU_TAM'
      },
      {
        label: 'Xã Hồ Đắc Kiện',
        value: 'XA_HO_DAC_KIEN'
      },
      {
        label: 'Xã Long Hưng',
        value: 'XA_LONG_HUNG'
      },
      {
        label: 'Xã Thuận Hòa',
        value: 'XA_THUAN_HOA'
      },
      {
        label: 'Xã Mỹ Hương',
        value: 'XA_MY_HUONG'
      },
      {
        label: 'Xã An Ninh',
        value: 'XA_AN_NINH'
      },
      {
        label: 'Xã Mỹ Phước',
        value: 'XA_MY_PHUOC'
      },
      {
        label: 'Xã An Thạnh',
        value: 'XA_AN_THANH'
      },
      {
        label: 'Xã Cù Lao Dung',
        value: 'XA_CU_LAO_DUNG'
      },
      {
        label: 'Xã Long Phú',
        value: 'XA_LONG_PHU'
      },
      {
        label: 'Xã Đại Ngãi',
        value: 'XA_DAI_NGAI'
      },
      {
        label: 'Xã Trường Khánh',
        value: 'XA_TRUONG_KHANH'
      },
      {
        label: 'Xã Tân Thạnh',
        value: 'XA_TAN_THANH'
      },
      {
        label: 'Xã Trần Đề',
        value: 'XA_TRAN_DE'
      },
      {
        label: 'Xã Liêu Tú',
        value: 'XA_LIEU_TU'
      },
      {
        label: 'Xã Lịch Hội Thượng',
        value: 'XA_LICH_HOI_THUONG'
      },
      {
        label: 'Phường Mỹ Xuyên',
        value: 'PHUONG_MY_XUYEN'
      },
      {
        label: 'Xã Tài Văn',
        value: 'XA_TAI_VAN'
      },
      {
        label: 'Xã Thạnh Thới An',
        value: 'XA_THANH_THOI_AN'
      },
      {
        label: 'Xã Nhu Gia',
        value: 'XA_NHU_GIA'
      },
      {
        label: 'Xã Hòa Tú',
        value: 'XA_HOA_TU'
      },
      {
        label: 'Xã Ngọc Tố',
        value: 'XA_NGOC_TO'
      },
      {
        label: 'Xã Gia Hòa',
        value: 'XA_GIA_HOA'
      },
      {
        label: 'Phường Ngã Năm',
        value: 'PHUONG_NGA_NAM'
      },
      {
        label: 'Xã Tân Long',
        value: 'XA_TAN_LONG'
      },
      {
        label: 'Phường Mỹ Quới',
        value: 'PHUONG_MY_QUOI'
      },
      {
        label: 'Xã Phú Lộc',
        value: 'XA_PHU_LOC'
      },
      {
        label: 'Xã Lâm Tân',
        value: 'XA_LAM_TAN'
      },
      {
        label: 'Xã Vĩnh Lợi',
        value: 'XA_VINH_LOI'
      },
      {
        label: 'Phường Vĩnh Châu',
        value: 'PHUONG_VINH_CHAU'
      },
      {
        label: 'Phường Khánh Hòa',
        value: 'PHUONG_KHANH_HOA'
      },
      {
        label: 'Xã Vĩnh Hải',
        value: 'XA_VINH_HAI'
      },
      {
        label: 'Phường Vĩnh Phước',
        value: 'PHUONG_VINH_PHUOC'
      },
      {
        label: 'Xã Lai Hòa',
        value: 'XA_LAI_HOA'
      }
    ]
  },
  {
    label: 'Cà Mau',
    value: 'CA_MAU',
    children: [
      {
        label: 'Phường Bạc Liêu',
        value: 'PHUONG_BAC_LIEU'
      },
      {
        label: 'Phường Vĩnh Trạch',
        value: 'PHUONG_VINH_TRACH'
      },
      {
        label: 'Phường Hiệp Thành',
        value: 'PHUONG_HIEP_THANH'
      },
      {
        label: 'Xã Hồng Dân',
        value: 'XA_HONG_DAN'
      },
      {
        label: 'Xã Ninh Quới',
        value: 'XA_NINH_QUOI'
      },
      {
        label: 'Xã Vĩnh Lộc',
        value: 'XA_VINH_LOC'
      },
      {
        label: 'Xã Ninh Thạnh Lợi',
        value: 'XA_NINH_THANH_LOI'
      },
      {
        label: 'Xã Phước Long',
        value: 'XA_PHUOC_LONG'
      },
      {
        label: 'Xã Vĩnh Phước',
        value: 'XA_VINH_PHUOC'
      },
      {
        label: 'Xã Vĩnh Thanh',
        value: 'XA_VINH_THANH'
      },
      {
        label: 'Xã Phong Hiệp',
        value: 'XA_PHONG_HIEP'
      },
      {
        label: 'Xã Hòa Bình',
        value: 'XA_HOA_BINH'
      },
      {
        label: 'Xã Châu Thới',
        value: 'XA_CHAU_THOI'
      },
      {
        label: 'Xã Vĩnh Lợi',
        value: 'XA_VINH_LOI'
      },
      {
        label: 'Xã Hưng Hội',
        value: 'XA_HUNG_HOI'
      },
      {
        label: 'Xã Vĩnh Mỹ',
        value: 'XA_VINH_MY'
      },
      {
        label: 'Xã Vĩnh Hậu',
        value: 'XA_VINH_HAU'
      },
      {
        label: 'Phường Giá Rai',
        value: 'PHUONG_GIA_RAI'
      },
      {
        label: 'Phường Láng Tròn',
        value: 'PHUONG_LANG_TRON'
      },
      {
        label: 'Xã Phong Thạnh',
        value: 'XA_PHONG_THANH'
      },
      {
        label: 'Xã Gành Hào',
        value: 'XA_GANH_HAO'
      },
      {
        label: 'Xã Đông Hải',
        value: 'XA_DONG_HAI'
      },
      {
        label: 'Xã Long Điền',
        value: 'XA_LONG_DIEN'
      },
      {
        label: 'Xã An Trạch',
        value: 'XA_AN_TRACH'
      },
      {
        label: 'Xã Định Thành',
        value: 'XA_DINH_THANH'
      },
      {
        label: 'Phường An Xuyên',
        value: 'PHUONG_AN_XUYEN'
      },
      {
        label: 'Phường Lý Văn Lâm',
        value: 'PHUONG_LY_VAN_LAM'
      },
      {
        label: 'Phường Tân Thành',
        value: 'PHUONG_TAN_THANH'
      },
      {
        label: 'Phường Hòa Thành',
        value: 'PHUONG_HOA_THANH'
      },
      {
        label: 'Xã Nguyễn Phích',
        value: 'XA_NGUYEN_PHICH'
      },
      {
        label: 'Xã U Minh',
        value: 'XA_U_MINH'
      },
      {
        label: 'Xã Khánh An',
        value: 'XA_KHANH_AN'
      },
      {
        label: 'Xã Khánh Lâm',
        value: 'XA_KHANH_LAM'
      },
      {
        label: 'Xã Thới Bình',
        value: 'XA_THOI_BINH'
      },
      {
        label: 'Xã Biển Bạch',
        value: 'XA_BIEN_BACH'
      },
      {
        label: 'Xã Trí Phải',
        value: 'XA_TRI_PHAI'
      },
      {
        label: 'Xã Tân Lộc',
        value: 'XA_TAN_LOC'
      },
      {
        label: 'Xã Hồ Thị Kỷ',
        value: 'XA_HO_THI_KY'
      },
      {
        label: 'Xã Trần Văn Thời',
        value: 'XA_TRAN_VAN_THOI'
      },
      {
        label: 'Xã Sông Đốc',
        value: 'XA_SONG_DOC'
      },
      {
        label: 'Xã Đá Bạc',
        value: 'XA_DA_BAC'
      },
      {
        label: 'Xã Khánh Bình',
        value: 'XA_KHANH_BINH'
      },
      {
        label: 'Xã Khánh Hưng',
        value: 'XA_KHANH_HUNG'
      },
      {
        label: 'Xã Cái Nước',
        value: 'XA_CAI_NUOC'
      },
      {
        label: 'Xã Lương Thế Trân',
        value: 'XA_LUONG_THE_TRAN'
      },
      {
        label: 'Xã Tân Hưng',
        value: 'XA_TAN_HUNG'
      },
      {
        label: 'Xã Hưng Mỹ',
        value: 'XA_HUNG_MY'
      },
      {
        label: 'Xã Đầm Dơi',
        value: 'XA_DAM_DOI'
      },
      {
        label: 'Xã Tạ An Khương',
        value: 'XA_TA_AN_KHUONG'
      },
      {
        label: 'Xã Trần Phán',
        value: 'XA_TRAN_PHAN'
      },
      {
        label: 'Xã Tân Thuận',
        value: 'XA_TAN_THUAN'
      },
      {
        label: 'Xã Quách Phẩm',
        value: 'XA_QUACH_PHAM'
      },
      {
        label: 'Xã Thanh Tùng',
        value: 'XA_THANH_TUNG'
      },
      {
        label: 'Xã Tân Tiến',
        value: 'XA_TAN_TIEN'
      },
      {
        label: 'Xã Năm Căn',
        value: 'XA_NAM_CAN'
      },
      {
        label: 'Xã Đất Mới',
        value: 'XA_DAT_MOI'
      },
      {
        label: 'Xã Tam Giang',
        value: 'XA_TAM_GIANG'
      },
      {
        label: 'Xã Cái Đôi Vàm',
        value: 'XA_CAI_DOI_VAM'
      },
      {
        label: 'Xã Phú Mỹ',
        value: 'XA_PHU_MY'
      },
      {
        label: 'Xã Phú Tân',
        value: 'XA_PHU_TAN'
      },
      {
        label: 'Xã Nguyễn Việt Khái',
        value: 'XA_NGUYEN_VIET_KHAI'
      },
      {
        label: 'Xã Tân Ân',
        value: 'XA_TAN_AN'
      },
      {
        label: 'Xã Phan Ngọc Hiển',
        value: 'XA_PHAN_NGOC_HIEN'
      },
      {
        label: 'Xã Đất Mũi',
        value: 'XA_DAT_MUI'
      }
    ]
  }
]

export enum TYPE_BOOKING {
  NEW = 'NEW',
  CONFIRM = 'CONFIRM',
  CANCEL = 'CANCEL',
  DONE = 'DONE',
  DOING = 'DOING',
  PRICE_QUOTE = 'PRICE_QUOTE'
}

export enum STATUS_TRANSACTION {
  PLUS_POINT = 'PLUS_POINT',
  MINUS_POINT = 'MINUS_POINT'
}

export const LABEL_STATUS_TRANSACTION = {
  [STATUS_TRANSACTION.PLUS_POINT]: 'Cộng điểm',
  [STATUS_TRANSACTION.MINUS_POINT]: 'Trừ điểm'
}

export enum CONTENT_BOOKING {
  APP_REFERAL = 'APP_REFERAL', // Giới thiệu mở app
  SERVICE_REFERAL = 'SERVICE_REFERAL', // Giới thiệu sử dụng dịch vụ
  EXCHANGE = 'EXCHANGE', // Đổi thưởng
  PAYMENT = 'PAYMENT' // Thanh toán
}

export const LABEL_CONTENT_BOOKING = {
  [CONTENT_BOOKING.APP_REFERAL]: 'Giới thiệu mở app',
  [CONTENT_BOOKING.SERVICE_REFERAL]: 'Giới thiệu sử dụng dịch vụ',
  [CONTENT_BOOKING.EXCHANGE]: 'Đổi thưởng',
  [CONTENT_BOOKING.PAYMENT]: 'Thanh toán'
}

export enum TYPE_MAINTAIN {
  PERIODIC = 'PERIODIC',
  INTERIOR = 'INTERIOR',
  EXTERIOR = 'EXTERIOR'
}

export const LABEL_TYPE_MAINTAIN = {
  [TYPE_MAINTAIN.EXTERIOR]: 'Ngoại thất',
  [TYPE_MAINTAIN.INTERIOR]: 'Nội thất',
  [TYPE_MAINTAIN.PERIODIC]: 'Bảo dưỡng định kỳ'
}

export enum TYPE_ADMIN {
  ADMIN = 'ADMIN',
  MASTER_ADMIN = 'MASTER_ADMIN'
}

export const COMPANY_TRANSPORTATIONS = [
  { label: 'Toyota', value: 'TOYOTA' },
  { label: 'Honda', value: 'HONDA' },
  { label: 'Hyundai', value: 'HYUNDAI' },
  { label: 'Kia', value: 'KIA' },
  { label: 'Mazda', value: 'MAZDA' },
  { label: 'Mitsubishi', value: 'MITSUBISHI' },
  { label: 'Ford', value: 'FORD' },
  { label: 'Nissan', value: 'NISSAN' },
  { label: 'Suzuki', value: 'SUZUKI' },
  { label: 'Isuzu', value: 'ISUZU' },
  { label: 'VinFast', value: 'VINFAST' },
  { label: 'Mercedes-Benz', value: 'MERCEDES-BENZ' },
  { label: 'BMW', value: 'BMW' },
  { label: 'Audi', value: 'AUDI' },
  { label: 'Lexus', value: 'LEXUS' },
  { label: 'Volvo', value: 'VOLVO' },
  { label: 'Land Rover', value: 'LAND ROVER' },
  { label: 'Jaguar', value: 'JAGUAR' },
  { label: 'Porsche', value: 'PORSCHE' },
  { label: 'Subaru', value: 'SUBARU' },
  { label: 'Peugeot', value: 'PEUGEOT' },
  { label: 'MG', value: 'MG' },
  { label: 'Jeep', value: 'JEEP' },
  { label: 'MINI', value: 'MINI' },
  { label: 'Volkswagen', value: 'VOLKSWAGEN' },
  { label: 'RAM', value: 'RAM' },
  { label: 'Maserati', value: 'MASERATI' },
  { label: 'Ferrari', value: 'FERRARI' },
  { label: 'Lamborghini', value: 'LAMBORGHINI' },
  { label: 'McLaren', value: 'MCLAREN' },
  { label: 'Bentley', value: 'BENTLEY' },
  { label: 'Rolls-Royce', value: 'ROLLS-ROYCE' },
  { label: 'Aston Martin', value: 'ASTON MARTIN' }
]
